import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { LookupDataService } from './../../../../BaseFramework/core/http/lookupdata.service';
import { CustomHookService } from './../../../shared-services/custom-hook/custom-hook.service';
import { NewBusinessAppSettings } from './../../newbusiness-configs/newbusiness-app-settings.config';
import { PolicyAgentDO } from './../../../../FunctionalModules/PolicyIssuance/models/policyAgent.model';
import { PolicyPaymentDO } from './../../../../BaseFramework/shared/models/payment.model';
import { PolicyPremiumBreakupDO } from './../../../../BaseFramework/shared/models/PolicyPremiumBreakup.model';
import { DataTransformService } from './../../../shared-services/data-transform/data-transform.service';
import { GuidGenerator } from './../../../../BaseFramework/core/utilities/commonUtility';
import { PolicyCoverageDO } from 'app/BaseFramework/shared/models/other/policyCoverageDO';
import { SubmissionDataComponent } from './../../../shared-components/submission-data/submission-data.component';
import { AfterViewInit, Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { BehaviorSubject, Subject, forkJoin, Observable, combineLatest, zip, Subscription } from 'rxjs'
import { concatMap, distinctUntilChanged, startWith, take } from 'rxjs/operators'
import { Router, ActivatedRoute } from '@angular/router';
import { UserInfoService } from 'app/BaseFramework/core';
import {
  ValidationUtilService,
  ClaimClientRole,
  InteractService,
  IntimationService,
  ClaimRegistrationService,
  CommonUtilty,
  AppMetadataHandler,
  WorkqueueService
} from 'app'
import { PolicyService } from '../../../../FunctionalModules/PolicyIssuance/policy.service'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { ComponentOutputDO, IntimationIO, PolicyIO, ProposalIO, VehicleDO, PropertyDO } from 'app/BaseFramework/shared/models';
import { json } from 'ngx-custom-validators/src/app/json/validator';
import * as moment from 'moment/moment';
// import { default as configData } from './transaction-details.component.json';
//import { default as rulesDataObj } from './sample_rules.json';
import { environment } from 'environments/environment';
import { ClientList } from 'app/ViewModules/shared-components/captured-client-list/captured-client-list.component.js';
import { PolicyCoverageInsuredDO } from './../../../../BaseFramework/shared/models/policyCoverageInsured.model'
import { PolicyCoverageScheduleDO } from '../../../../FunctionalModules/PolicyIssuance/models/PolicyCoverageSchedule.model'
import { Store } from '@ngrx/store';
import { AppState } from 'app/BaseFramework/shared/models/statemodels/app-state.model';
import { customSavePolicy, savePolicy } from 'app/BaseFramework/shared/actions/nbu.action';
import { UiBuilderService } from 'app/BaseFramework/core/services/ui-builder/ui-builder.service';
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';
import { HttpClient } from '@angular/common/http';
import { default as guidedDataJSON } from "./guided-data-pixel-data.json";
import { fetchClient } from 'app/BaseFramework/shared/actions/client.action';
import { ClientHandlingService } from 'app/BaseFramework/core/services/clientHandling/client-handling.service';
import { ProposalCoverageDO } from 'app/BaseFramework/shared/models/proposal/proposalCoverageDO';
import { ProposalCoverageInsuredDO } from 'app/BaseFramework/shared/models/proposal/proposalCoverageInsuredDO';
import { ProposalCoverageScheduleDO } from 'app/BaseFramework/shared/models/proposal/proposalCoverageScheduleDO';
import { ProposalPremiumBreakupDO } from 'app/BaseFramework/shared/models/proposal/proposalPremiumBreakupDO';
import { Constants } from 'app/constants';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { claimClientUtil } from 'app/BaseFramework/core/utilities/claimClientUtil';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ProposalPaymentDO } from 'app/BaseFramework/shared/models/proposal/proposalPaymentDO';

export class TaskIO {
  taskCd: any;
  entityGuid: any;
  objectName: any
  assignedto: any
}
export class ChaserIO {
  chaserNum: Number
  chaserDays: Number
  typeCd: String
  chaserDt: Date
}
@Component({
  selector: 'app-transaction-details',
  templateUrl: './transaction-details.component.html',
  styleUrls: ['./transaction-details.component.scss'],
  providers: [TechnicalTranslatePipe]
})
export class TransactionDetailsComponent implements OnInit, AfterViewInit {

  constructor(
    private message: NzMessageService,
    private modalService: NzModalService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private validationUtilService: ValidationUtilService,
    private interactService: InteractService,
    private intimationService: IntimationService,
    private claimRegistrationService: ClaimRegistrationService,
    private commonUtilty: CommonUtilty,
    public appMetadataHandler: AppMetadataHandler,
    private workqueueService: WorkqueueService,
    private policyService: PolicyService,
    public dataTransformService: DataTransformService,
    public newBusinessAppSettings: NewBusinessAppSettings,
    private customHookService: CustomHookService,
    private lookupDataService: LookupDataService,
    private apiRequestService: ApiRequestService,    
    private userInfoService: UserInfoService,
    private uiBuilderService: UiBuilderService,
    private http: HttpClient,
    private technicalTranslatePipe: TechnicalTranslatePipe,
    public claimClientUtil: claimClientUtil,
    public cdr: ChangeDetectorRef,
    public guidGenerator: GuidGenerator,
    private store: Store<{counter: {
      payload : ProposalIO
    }}>,    
    private clientStore: Store<{clientStore: any}>,
    private clientHandlingService: ClientHandlingService
  ) {
    /* Set State (If passed from other routes. Eg: New-Intimation) */
    let newState = this.route.snapshot.paramMap.get('from');
    // if (newState) this.state = newState;
    // console.log("[state] -- ", this.state);
    this.nullifyPayloadInEdit = 'start'
  }
  constants = Constants
  // travelTransactionComponentList = [
  //   "CapturedClientListComponentOWNER",
  //   "CapturedClientListComponentPRIMARYINSURED",
  //   "CapturedClientListComponentINSURED",
  //   "CapturedClientListComponentNOMINEE",
  //   "CapturedClientListComponentAPPOINTEE",
  //   "CapturedClientListComponentPAYER",
  //   "CapturedAgentListComponent",
  //   "SubmissionDataComponent",
  //   "ProductCoveragesComponent",
  //   "OtherPolicyComponent",
  //   "BasePlanComponent",
  //   "QuestionnaireComponent",
  //   "followUpComponent",
  //   "DynamicUIBuilder",
  //   "TripDetailsComponent","MandatoryCoverageComponent",
  // ]
  // propertyTransactionComponentList = [
  //   "CapturedClientListComponentOWNER",
  //   "CapturedClientListComponentPRIMARYINSURED",
  //   "CapturedClientListComponentINSURED",
  //   "CapturedClientListComponentNOMINEE",
  //   "CapturedClientListComponentAPPOINTEE",
  //   "CapturedClientListComponentPAYER",
  //   "CapturedAgentListComponent",
  //   "SubmissionDataComponent",
  //   "ProductCoveragesComponent",
  //   "OtherPolicyComponent",
  //   "BasePlanComponent",
  //   "QuestionnaireComponent",
  //   "followUpComponent",
  //   "DynamicUIBuilder",
  //   "PropertyDetailsComponent"
  // ]

  public currencyOptions = {
    prefix: this.appMetadataHandler.baseCurrencyPREFIX,
    thousands: this.appMetadataHandler.THOUSANDS_SEPARATOR,
    decimal: this.appMetadataHandler.DECIMAL_SEPARATOR,
    align: this.appMetadataHandler.currencyAlignment
  }
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    sanitize: false,
    toolbarPosition: 'top',
  };

  businessType = null; // this is used for claims hence setting this to null
  transactionForm = this.fb.group({})
  tempJosn: any;
  nomineeClaimantFlag: any = false;
  lookupsToBind = ['roleUsers', 'csrUsersUID', 'claimRegRoleUsers', 'decisionTypeCd', 'decisionCd', 'manualUwDecisionCd','uwDecisionCd', 'uwRuleSubType', 'autoUwRuleCd', 'coResponseCd','secondaryTasks','collaborationPartyCd']
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)
  assigneeUser: any = null
  // dummyJsonIntimation = this.configData.dummyJsonIntimation
  TRUEVALUE = true;
  FALSEVALUE = false
  modSearchCustomerInsured: boolean;
  modSearchCustomerPrimaryInsured: boolean;
  modSearchCustomerPayer: boolean;
  modSearchCustomerOwner: boolean;
  modSearchCustomerVehicle: boolean;
  modSearchCustomerMembers: boolean;
  modSearchAgent: boolean;
  tempInVisible = false;
  tempAgentDetail = [];
  sumInsured = 100000;
  setRolesBeneficiary = "Payer";
  productData = []
  otherListNode = null;
  state
  enableModalClose
  refreshThisComponenetOnSaveSubmit = true
  refreshBasePlanToggle = true;
  refreshMandatoryCoveragesToggle = true;
  refreshAdditionalCoveragesToggle = true;
  mandatoryCoveragesList = [];
  maxDepth = "4";
  basePlanComponentData = {};
  additionalCoveragesComponentData = {};
  noOfClientsCanBeAdded = {};
  dataView : string = "grid-layout";
  fundAllocationComponentData = {};
  responseCd: any = null;


  @ViewChild('zoomContainerRef') zoomContainerRef: ElementRef;

  getPackageType(data) {
    console.log("fetched package type", data);
    let clientCountMapping = this.configData.clientCountMapping;
    for (const key in clientCountMapping) {
      if (data === key)
        this.noOfClientsCanBeAdded = clientCountMapping[key]
    }
  }

  getDO(IO) {
    if (IO)
      return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
    else
      null
  }

  refreshComponents() {
    this.refreshThisComponenetOnSaveSubmit = false
    setTimeout(() => {
      this.refreshThisComponenetOnSaveSubmit = true
    }, 500);
  }

  _toggleRefreshBasePlanComponent(value) {
    if (value) {
      this.refreshBasePlanToggle = false;
      setTimeout(() => { this.refreshBasePlanToggle = true; }, 300);
    }
  }

  _toggleRefreshMandatoryCoveragesComponent(value) {
    if (value) {
      this.refreshMandatoryCoveragesToggle = false;
      setTimeout(() => { this.refreshMandatoryCoveragesToggle = true; }, 300);
    }
  }

  _toggleRefreshAdditionalCoveragesComponent(value) {
    if (value) {
      this.refreshAdditionalCoveragesToggle = false;
      setTimeout(() => { this.refreshAdditionalCoveragesToggle = true; }, 300);
    }
  }

  subscribeAndRefreshCoveragesComponent() {
    if (this.toggleInsuredListSubject$ != null) this.toggleInsuredListSubject$.unsubscribe();
    this.toggleInsuredListSubject$ = this.interactService.addClientSubject$.subscribe(val => {
      if (val)
        this._toggleRefreshAdditionalCoveragesComponent(true);
    })
  }

  private transactionMasterUpdateControl = true;
  flattenedPayloadInEdit
  private _payloadInEdit = null
  set payloadInEdit(value: any) {
    if (this._payloadInEdit == null) {
      this._payloadInEdit = this.commonUtilty.deepCopy(value)
    }
    else {
      throw "You cannot set payloadInEdit, since it's a constant and can be initialized only once"
    }
  }

  get payloadInEdit() {
    return this._payloadInEdit
  }

  set nullifyPayloadInEdit(value: any) {
    this._payloadInEdit = null
  }

  

  // mapperTransactionState = this.appMetadataHandler.APPCONSTANTS.nbuDefaultState;
  mapperTransactionState 
  // _inputClaimsBasicDetailsComponent = null;
  TransactionState = null;
  inboxType = null;
  taskId = null;
  proposalType = this.appMetadataHandler.APPCONSTANTS.proposalType;
  productFamilyCd = null;
  selectedProduct = null;
  refreshCoveragesDecision = true;
  givenPolicyDecision: any;

  
  ngOnDestroy() {
    this.interactService.nullifyTransactionEmitters();
    this.nullifyPayloadInEdit = 'start';
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['insuredCd']))
      this.lookupDataService.lookupCacheMap['insuredCd'] = [];
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['additionalCoveragesCd']))
      this.lookupDataService.lookupCacheMap['additionalCoveragesCd'] = [];
    if (this.commonUtilty.isArrayIterable(this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd']))
      this.lookupDataService.lookupCacheMap['mandatoryCoveragesCd'] = [];
    
    if (this.clientStoreSubscription) {
      this.clientStoreSubscription.unsubscribe();
    }
    this.clientHandlingService.clearClientRoleMap();
    this.appMetadataHandler.policyCurrencyCd = null
    this.appMetadataHandler.productCurrencyCd= null
    if (this.overlayObserver) {
      this.overlayObserver.disconnect(); // ✅ Clean up
    }
  }

  initializeIntimationTabs() {
    this.transactionForm = this.fb.group({
    });
  }

  setFooter(data) {
    this.ClientCaptureFooter = data
  }

  enableTabFor(states) {
    let c = states.includes(this.mapperTransactionState)
    return c
  }

  disableTabFor(states) {
    let c = states.includes(this.mapperTransactionState)
    return !c
  }

  tabStates: any;

  getTabVisibilityStatus(tabKey) {
    if(tabKey && this.tabStates[tabKey]){
      let tabKeyMetaData = this.tabStates[tabKey]
      if (tabKeyMetaData.enableTab) {
        return this.enableTabFor(tabKeyMetaData.states)
      }
      else {
        return this.disableTabFor(tabKeyMetaData.states)
      }
   }
  }

  initializeTransactionPageDataStateMap(mapperTransactionState, configData) {
    let listOfAllChildren = this.getListOfChildrenForCurrentState(mapperTransactionState, configData);
    let trasactionPageDataStateMap = {}
    trasactionPageDataStateMap[mapperTransactionState] = {}
    trasactionPageDataStateMap[mapperTransactionState]["components"] = {}
    let components = {}
    if (listOfAllChildren && Array.isArray(listOfAllChildren) && listOfAllChildren.length > 0) {
      listOfAllChildren.forEach(child => {
        components[child] = new Subject()
      })
    }
    trasactionPageDataStateMap[mapperTransactionState]["components"] = components

    return trasactionPageDataStateMap
  }

  listOfAllChildren
  private getListOfChildrenForCurrentState(mapperTransactionState: any, configData: any) {
    let defaultChildrenComponents = configData.StateToChildComponentMapper.allStates;
    let specificChildrenComponents = configData.StateToChildComponentMapper[mapperTransactionState];
    let listOfAllChildren = [...defaultChildrenComponents, ...specificChildrenComponents];
    return listOfAllChildren
  }
  
  // private getListOfChildrenForCurrentState(mapperTransactionState: any, configData: any) {
  //   let defaultChildrenComponents = configData.StateToChildComponentMapper.allStates;
  //   // let specificChildrenComponents = configData.StateToChildComponentMapper[mapperTransactionState];
  //   let specificChildrenComponents = null
  //   if (mapperTransactionState == 'TRAVELproposal_DataEntry'){
  //     specificChildrenComponents = this.travelTransactionComponentList}
  //     else if(mapperTransactionState == 'PROPERTYproposal_DataEntry'){
  //       specificChildrenComponents = this.propertyTransactionComponentList
  //     }
  //   else specificChildrenComponents = configData.StateToChildComponentMapper[mapperTransactionState];

  //   let listOfAllChildren = [...defaultChildrenComponents, ...specificChildrenComponents];
  //   return listOfAllChildren
  // }

  trasactionPageDataStateMap: any = {
    claimIntimation: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject()
      }
    },
    claimRegistration: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject()
      }
    },
    claimAdjudication: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ProposalDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject() //Transform Breaking with error 500
      }
    },
    claimInvestigation: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimPayout: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
      }
    },
    claimUWReferral: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ProposalDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject()
      }
    },
    claimReinsReferral: {
      components: {
        ClaimsBasicDetailsComponent: new Subject(),
        CapturedPolicyListComponent: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        CapturedClientListComponentCLAIMANT: new Subject(),
        InsuredDetailsComponent: new Subject(),
        DocumentManagerComponent: new Subject(),
        ProposalDecisionComponent: new Subject(),
        ClaimsBenefitComponent: new Subject()
      }
    },
    proposal_ManualUw: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
    },
    policyAutoUWTask : {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
  },
    MOTORproposal_ManualUw: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
    },
    TRAVELproposal_ManualUw: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
    },
    PROPERTYproposal_ManualUw: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
    },
    LIFEproposal_ManualUw: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        CapturedClientListComponentPAYER: new Subject(),
        CapturedClientListComponentNOMINEE: new Subject(),
        CapturedClientListComponentAPPOINTEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        UnderwritingDecisionComponent: new Subject(),
        CapturedAgentListComponent: new Subject()
      }
    },
    proposal_DataEntry: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        SubmissionDataComponent: new Subject(),
        ProductCoveragesComponent: new Subject(),
        OtherPolicyComponent: new Subject(),
        CapturedAgentListComponent: new Subject(),
        // CapturedClientListComponentAGENT: new Subject()
        // CapturedClientListComponentPAYER: new Subject(),
        // CapturedClientListComponentNOMINEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        // UnderwritingDecisionComponent: new Subject()
      }
    },
    MOTORproposal_DataEntry: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        SubmissionDataComponent: new Subject(),
        ProductCoveragesComponent: new Subject(),
        OtherPolicyComponent: new Subject(),
        CapturedAgentListComponent: new Subject(),
        MotorInsuredDetailsComponent:new Subject(),
        AdditionalCoveragesComponent:new Subject(),
        // followUpComponent:new Subject(),
        // CapturedClientListComponentAGENT: new Subject()
        // CapturedClientListComponentPAYER: new Subject(),
        // CapturedClientListComponentNOMINEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        // UnderwritingDecisionComponent: new Subject()
      }
    },
    TRAVELproposal_DataEntry: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        SubmissionDataComponent: new Subject(),
        ProductCoveragesComponent: new Subject(),
        OtherPolicyComponent: new Subject(),
        CapturedAgentListComponent: new Subject(),
        TripDetailsComponent:new Subject(),
        // followUpComponent:new Subject(),
        AdditionalCoveragesComponent:new Subject(),
        // CapturedClientListComponentAGENT: new Subject()
        // CapturedClientListComponentPAYER: new Subject(),
        // CapturedClientListComponentNOMINEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        // UnderwritingDecisionComponent: new Subject()
      }
    },
    PROPERTYproposal_DataEntry: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        SubmissionDataComponent: new Subject(),
        ProductCoveragesComponent: new Subject(),
        OtherPolicyComponent: new Subject(),
        CapturedAgentListComponent: new Subject(),
        PropertyDetailsAddressComponent: new Subject(),
        PropertyDetailsComponent: new Subject(),
        // CapturedClientListComponentAGENT: new Subject()
        // CapturedClientListComponentPAYER: new Subject(),
        // CapturedClientListComponentNOMINEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        // UnderwritingDecisionComponent: new Subject()
      }
    },
    proposal_CounterOffer: {
      components: {
        CapturedClientListComponentINSURED: new Subject(),
        CapturedClientListComponentPRIMARYINSURED: new Subject(),
        CapturedClientListComponentOWNER: new Subject(),
        SubmissionDataComponent: new Subject(),
        ProductCoveragesComponent: new Subject(),
        OtherPolicyComponent: new Subject(),
        CapturedAgentListComponent: new Subject(),
        ProposalDecisionComponent : new Subject(),
        // CapturedClientListComponentAGENT: new Subject()
        // CapturedClientListComponentPAYER: new Subject(),
        // CapturedClientListComponentNOMINEE: new Subject(),
        MulticaptureBankDetailsComponent: new Subject(),
        // UnderwritingDecisionComponent: new Subject()
      }
    }
  }

  trasactionChildComponentTabPlacementMap = {
    ClaimsBasicDetailsComponent: 0,
    CapturedPolicyListComponent: 0,
    CapturedClientListComponentNOMINEE: 2,
    CapturedClientListComponentAPPOINTEE: 2,
    CapturedClientListComponentCLAIMANT: 2,
    InsuredDetailsComponent: 1,
    ProposalDecisionComponent: 6,
  }

  onActionClicked(action: 'ACCEPT' | 'REJECT') {
    this.responseCd = action;
    this.attemptForTransaction('submit');
  }
  transactionSaveType = null
  EmitterStatus = {}
  attemptForTransaction(transactionSaveType) {
    this.transactionSaveType = transactionSaveType;
    this.interactService.transactionCloserState(transactionSaveType)
    this.EmitterStatus = this.listOfAllChildren.reduce((a, b) => (a[b] = { emitted: false, isExtra: false }, a), {});
    this.askAllChildrenForData(this.listOfAllChildren)
    this.store.dispatch(customSavePolicy({payload :{...this.currentAllComponentData}}))
    // this.emitterFailureHandler();
  }

  emitterStatusModal = false
  emitterStatusForView = []
  private emitterFailureHandler() {
    this._transactionInProgress = false; // Stop the Loader State of transaction
    let emitterStatus = this.EmitterStatus // take snapshot of current emitter status
    for (const key in emitterStatus) {
      emitterStatus[key]['componentName'] = key
    }
    emitterStatus = this.commonUtilty.convertMapToArray(emitterStatus)

    this.emitterStatusForView = this.commonUtilty.deepCopy(emitterStatus)
    localStorage.setItem("EMITTERSTATUSERROR", JSON.stringify(this.emitterStatusForView))
    this.emitterStatusModal = true
    if (this.emitterStatusForView.some(es => !es.emitted)) {
      if (!environment.production)
        this.emitterStatusModal = true
      this.message.error("Configuration Error - Technical issue occurred, please contact IT Support.");
    }
  }

  dummySubmit() {
    if (this.payloadInEdit) {
      let DOName = this._getDOName(this.mapperTransactionState)
      if (this.payloadInEdit[DOName]) {
        this.payloadInEdit[DOName].uwDecisionCd = 'STANDARD'
        this.payloadInEdit[DOName].premiumBreakupList = null

        if (this.payloadInEdit[DOName]['caseCoverages'] &&
          this.commonUtilty.isArrayIterable(this.payloadInEdit[DOName]['caseCoverages'])) {
          this.payloadInEdit[DOName]['caseCoverages'].forEach(coverage => {
            coverage.uwDecisionCd = 'STANDARD'

            if (coverage['caseCoverageInsureds'] &&
              this.commonUtilty.isArrayIterable(coverage['caseCoverageInsureds'])) {
              coverage['caseCoverageInsureds'].forEach(coverageInsured => {
                coverageInsured.uwDecisionCd = 'STANDARD'
              });
            }
          });
        }
      }
    }

    this.message.loading('Submitting', { nzDuration: 4000 });
    this.submitCase(this.payloadInEdit);
  }

  askAllChildrenForData(listOfEmitterChildren) {
    this.interactService.pingChildToReact(listOfEmitterChildren)
  }

  getChildrenSubscriberDataPipe() {
    let childrenSubscribers$ = []
    if (this.mapperTransactionState) {
      let components = this.trasactionPageDataStateMap[this.mapperTransactionState].components
      if (!this.appMetadataHandler.featureFlags.enableAutoInitializeTransformDataPipe) components['MulticaptureBankDetailsComponent'] = new Subject()
      for (const key in components) {
        if (components.hasOwnProperty(key)) {
          childrenSubscribers$.push(components[key]);
        }
      }
    }

    if (childrenSubscribers$.length == Object.keys(this.trasactionPageDataStateMap[this.mapperTransactionState].components).length)
      return childrenSubscribers$
    else
      throw new Error("Number of Subject Mappers Do not Match Number of childrenSubscribers")
  }

  getChildrenNumber() {
    let count = null
    if (this.trasactionPageDataStateMap &&
      this.trasactionPageDataStateMap[this.mapperTransactionState] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components']
    ) {
      let c = Object.keys(this.trasactionPageDataStateMap[this.mapperTransactionState]['components'])
      count = c.length
    }

    console.log("count", count)
    return count
  }

  childrenDataPipeSubscription$
  initializeChildSubscribers() {
    let childrenDataPipe = this.getChildrenSubscriberDataPipe()
    let childNo = this.getChildrenNumber();
    console.log("children data pipe length", childrenDataPipe.length);
    console.log("children no ", childNo);
    if (childrenDataPipe.length === this.getChildrenNumber()) {
      if (this.childrenDataPipeSubscription$ != null) this.childrenDataPipeSubscription$.unsubscribe()
      this.childrenDataPipeSubscription$ = zip(...childrenDataPipe).subscribe(responses => {

        console.log((Object.keys(this.emitterHistory).length + " count of object"));
        if (Object.keys(this.emitterHistory).length === this.getChildrenNumber())
          this._intimationTransformUItoServer(responses)
        else {
          if (!environment.production) {
            throw "Missing Subject for a component that's emitting data. Check transactionPageDataStateMap or _BaseEmitterHandler.";

          }
        }
      })
    }
    else {
      throw "Component Emitters Mismatch";

    }
  }

  emitterHistory = {}
  _BaseEmitHandler(data, componentName) {
    console.log("BaseEmitHandler Fired For " + componentName)
    if (!this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) this.emitterHistory[componentName] = data
    else if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) this.dataTransformService.emitterHistory[componentName] = data
    if (this.trasactionPageDataStateMap &&
      this.trasactionPageDataStateMap[this.mapperTransactionState] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName]
    ) {
      this.EmitterStatus[componentName] = { emitted: true, isExtra: !!!(this.listOfAllChildren.find(lc => lc == componentName)) }
      this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName].next(data);
    }
    else {
      console.warn(`A Component - ${componentName} emitted data but as per Data Pipeline is not valid for serviceTask ${this.mapperTransactionState}`)
    }
    if (!this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
      let childrenNumber = this.getChildrenNumber()
      if (Object.keys(this.emitterHistory).length === childrenNumber) {
        console.log("All Childrem emitted data")
        console.log(this.emitterHistory)
      }
    }
    else if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
      let childrenNumber = this.dataTransformService.getChildrenNumber(this.trasactionPageDataStateMap, this.mapperTransactionState)
      if (Object.keys(this.dataTransformService.emitterHistory).length === childrenNumber) {
        console.log("All Childrem emitted data")
        console.log(this.dataTransformService.emitterHistory)
      }
    }
  }
  // _BaseEmitHandler(data, componentName) {
  //   console.log("BaseEmitHandler Fired For " + componentName)
  //   this.emitterHistory[componentName] = data
  //   if (this.trasactionPageDataStateMap &&
  //     this.trasactionPageDataStateMap[this.mapperTransactionState] &&
  //     this.trasactionPageDataStateMap[this.mapperTransactionState]['components'] &&
  //     this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName]
  //   ) {
  //     this.EmitterStatus[componentName] = { emitted: true, isExtra: !!!(this.listOfAllChildren.find(lc => lc == componentName)) }
  //     this.trasactionPageDataStateMap[this.mapperTransactionState]['components'][componentName].next(data);
  //   }
  //   else {
  //     console.warn(`A Component - ${componentName} emitted data but as per Data Pipeline is not valid for serviceTask ${this.mapperTransactionState}`)
  //   }
  //   if (Object.keys(this.emitterHistory).length === this.getChildrenNumber()) {
  //     console.log("All Childrem emitted data")
  //     console.log(this.emitterHistory)
  //   }
  // }

  getBasicDetails(data) {
    console.log(data)
  }

  _transactionInProgress = false
  _UIErrorList = []
  _dynamicBuilderErrorList = []
  _intimationTransformUItoServer(responses) {
    let ErrorList = []
    this._transactionInProgress = true
    let payload = null
    // if (responses != null && !responses ) {
    if (this.commonUtilty.isArrayIterable(responses)) {

      responses = this.DESTRUCTURE_DynamicUIBilder(responses)
      
      if (this.payloadInEdit != null) {
        payload = this.payloadInEdit // Editmode
      }
      else {

        if (this.TransactionState == 'proposal_DataEntry' || this.TransactionState == 'proposal_CounterOffer' || this.TransactionState == 'LIFEproposal_CounterOffer' || this.TransactionState == 'MOTORproposal_DataEntry' || this.TransactionState == 'TRAVELproposal_DataEntry' || this.TransactionState == 'PROPERTYproposal_DataEntry' || this.TransactionState == 'LIFEproposal_DataEntry') {
          payload = new ProposalIO();
        } else {
          payload = new IntimationIO()
          payload = this._setSubmissionModeFromUI(payload)
        }
      }
      responses.forEach((response: any) => {
        if (response.componentName === 'ClaimsBasicDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimsBasicDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimsBasicDetailsComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'CapturedPolicyListComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._CapturedPolicyListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedPolicyListComponentToSeverDOMapper(payload, response)
          }
        }
        // if (response.componentName === 'CapturedClientListComponent' || response.componentName === 'InsuredDetailsComponent') {
        //   if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
        //     if (response.componentData && !response.componentData.isInvalid)
        //       payload = this._CapturedClientListComponentToSeverDOMapper(payload, response)
        //     else if (response && response.componentData && response.componentData.errorDOs) {
        //       ErrorList.push(...response.componentData.errorDOs)
        //     }
        //   }
        //   else {
        //     payload = this._CapturedClientListComponentToSeverDOMapper(payload, response)
        //   }
        // }
        if (response.componentName === 'CapturedAgentListComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (response.componentData && !!!response.componentData.isInvalid)
              payload = this._CapturedAgentListComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._CapturedAgentListComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'DocumentManagerComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._DocumentManagerComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._DocumentManagerComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ProposalDecisionComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ProposalDecisionComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ProposalDecisionComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'UnderwritingDecisionComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._UnderwritingDecisionComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._UnderwritingDecisionComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'SubmissionDataComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._SubmissionDataComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._SubmissionDataComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ProductCoveragesComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ProductCoveragesComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ProductCoveragesComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'OtherPolicyComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._OtherPoliciesComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._OtherPoliciesComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'ClaimsBenefitComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._ClaimsBenefitComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._ClaimsBenefitComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'MulticaptureBankDetailsComponent' || response.componentName === 'ClaimsPaymentBreakupComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._MulticaptureBankDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._MulticaptureBankDetailsComponentToSeverDOMapper(payload, response)
          }
        }

        if (response.componentName === 'BankDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._BankDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._BankDetailsComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'MotorInsuredDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._VehicleDetailsComponentUIToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._VehicleDetailsComponentUIToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'PropertyDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._PropertyDetailsComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._PropertyDetailsComponentToSeverDOMapper(payload, response)
          }
        }
        if (response.componentName === 'TripDetailsComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._TripDetailsComponentToServerDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._TripDetailsComponentToServerDOMapper(payload, response)
          }
        }
        if (response.componentName === 'UIAddressIndComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._PropertyDetailsAddressComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._PropertyDetailsAddressComponentToSeverDOMapper(payload, response)
          }
        }

        if (response.componentName === 'InsuredCoverageDecisionComponent' || response.componentName === 'CoverageDecisionComponent') {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._InsuredCoverageDecisionComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._InsuredCoverageDecisionComponentToSeverDOMapper(payload, response)
          }
        }

        this.transformFundAllocationDataUIToServer(payload, ErrorList)
        // payload = this.checkProposalCoverages(payload);
        payload = this.setLabTestData(payload,this.dataTransformService.labTestData)
        payload = this.clientUIToServerTransform(payload)


        /**
         * WARNING: Do not make any change to Generic Transform Implementation.
         * If you want your component to use Generic Transform, just add your component name to 
         * transaction-detail.component.json to 'GenericTransformComponentList'
         */
        if (this.configData.GenericTransformComponentList && (this.configData.GenericTransformComponentList.includes(response.componentName) || this.configData.GenericBaseComponentList.includes(response.baseComponentName))) {
          if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform) {
            if (!!!response.componentData.isInvalid)
              payload = this._GenericComponentToSeverDOMapper(payload, response)
            else if (response && response.componentData && response.componentData.errorDOs) {
              ErrorList.push(...response.componentData.errorDOs)
            }
          }
          else {
            payload = this._GenericComponentToSeverDOMapper(payload, response)
          }
        }

      });
    }

    // if(this.commonUtilty.isArrayIterable(this.clientHandlingService.clientRoleDataMap['NOMINEE'])){
    //   let err = this.clientHandlingService.checkSplitPercentage(this.clientHandlingService.clientRoleDataMap['NOMINEE'], 'nomineeSplitPrct');
    //   if(this.commonUtilty.isArrayIterable(err)) ErrorList.push(...err);
    // }

    // let DO = this._getDOName(this.TransactionState);
    // payload = this.clientHandlingService.updateClientDataToPayload(payload, DO);

    if (this.appMetadataHandler.featureFlags.enableClientValidationHandlingOnTransform && ErrorList) {
      this._UIErrorList = [...this._UIErrorList, ...this.commonUtilty.deepCopy(ErrorList)]
    }

    if (this.commonUtilty.isArrayIterable(this._dynamicBuilderErrorList)) {
      this._UIErrorList.push(...this._dynamicBuilderErrorList)
    }

    if (payload != null && Array.isArray(this._UIErrorList) && this._UIErrorList.length == 0) {
      if (this.userRole == 'PROPOSAL_BRANCH_OFFICER' && payload[this.currentDO]) {
        payload[this.currentDO].proposalSourceCd = 'BRANCH';
      } else if (payload[this.currentDO]) {
        payload[this.currentDO].proposalSourceCd = null;
      }
      if (payload) {
        let DOName = this.commonUtilty.getDOName(payload)
        payload[DOName]['policyCommencementDt'] = this.commonUtilty.UIDOtoServerDODate(payload[DOName]['policyCommencementDt']);
        payload[DOName]['policyExpiryDt'] = this.commonUtilty.UIDOtoServerDODate(payload[DOName]['policyExpiryDt']);
        payload[DOName]['dueDt'] = new Date(payload[DOName]['dueDt']);
      }
      if (this.appMetadataHandler.featureFlags.enableMarkAllRequirementsAsReceived)
        payload = this.___markAllRequirementsAsReceived(payload)
      if (this.appMetadataHandler.featureFlags.enableMarkAllChecklistAsCompleted)
        payload = this.___markAllChecklistAsCompleted(payload)

      console.log("TransactionState " + this.TransactionState);
      if (this.TransactionState === 'claimIntimation')
        this._saveOrSubmitIntimationTransaction(payload);

      //TODO check with ganesh and ninad

      if (this.TransactionState == 'claimAdjudication')
        this._saveOrSubmitAdjudicationTransaction(payload);
      else if (this.TransactionState == 'proposal_ManualUw') {
        this._saveOrSubmitCaseTransaction(payload)
      }
      else if (this.TransactionState == 'policyAutoUWTask') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'LIFEproposal_ManualUw') {
        this._saveOrSubmitCaseTransaction(payload)
      }
      else if (this.TransactionState == 'MOTORproposal_ManualUw') {
        this._saveOrSubmitCaseTransaction(payload)
      }
      else if (this.TransactionState == 'PROPERTYproposal_ManualUw') {
        this._saveOrSubmitCaseTransaction(payload)
      }
      else if (this.TransactionState == 'TRAVELproposal_ManualUw') {
        this._saveOrSubmitCaseTransaction(payload)
      }
      else if (this.TransactionState == 'proposal_DataEntry') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'TRAVELproposal_DataEntry') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'LIFEproposal_DataEntry') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'PROPERTYproposal_DataEntry') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'MOTORproposal_DataEntry') {
        this._saveOrSubmitPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'proposal_CounterOffer') {
        this._saveOrSubmitCounterPolicyTransaction(payload)
      }
      else if (this.TransactionState == 'LIFEproposal_CounterOffer') {
        this._saveOrSubmitCounterPolicyTransaction(payload)
      }
      else if (this.TransactionState !== 'claimIntimation' && this.TransactionState !== 'claimInvestigation')
        this._saveOrSubmitRegistrationTransaction(payload);
    }
    else if (!environment.production) {
      // throw new Error("Unexpected Error - Empty Payload")
    }
  }

  checkProposalCoverages(payload){
    let DO = this._getDOName(this.TransactionState)
    if(payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO].proposalCoverages)){
      payload[DO].proposalCoverages = payload[DO].proposalCoverages.filter(item=>(item != null));
      if(this.commonUtilty.isArrayIterable(payload[DO].proposalCoverages)){
        payload[DO].proposalCoverages.forEach(item=>{
          if(item.undefined){
            delete item.undefined;
          }
        })
      }
    }
    return payload;
  }
  CUSTOM_fixProductCd(payload) {
    let DO = this._getDOName(this.TransactionState);
    let baseProductCd = payload[DO].baseProductCd;
    let coverageNode = this.configData.CoverageNodeMapper[this.TransactionState];
    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.mapperTransactionState];
    let propertyGuid = null
    if (payload && payload['propertyDOs'] && payload['propertyDOs'].length > 0)
      propertyGuid = payload['propertyDOs'][0]['guid']
    if (payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][coverageNode])) {
      payload[DO][coverageNode].forEach(item => {
        if (typeof item === 'object' && item.planTypeCd === "BASEPLAN") item.productCd = baseProductCd;
        if (item && item[CoveragesInsuredNode] && item[CoveragesInsuredNode].length){
          item[CoveragesInsuredNode].forEach(element => {
            if (typeof element === 'object' && element.roleCd === "PRIMARYINSURED") 
              element.propertyRefGuid = propertyGuid;
            else this.CUSTOM_setCoverageInsuredObject(item[CoveragesInsuredNode], propertyGuid);
          });
        }
        else this.CUSTOM_setCoverageInsuredObject(item[CoveragesInsuredNode], propertyGuid);
      });
    }
  }

  CUSTOM_setCoverageInsuredObject(proposalCoverageInsureds, propertyGuid){
    let primaryInsuredObj = {}
    primaryInsuredObj['roleCd'] = "PRIMARYINSURED",
    primaryInsuredObj['clientId'] = null,
    primaryInsuredObj['clientRefGuid'] = null,
    primaryInsuredObj['customerId'] = null,
    primaryInsuredObj['vehicleId'] = null,
    primaryInsuredObj['vehicleRefGuid'] = null,
    primaryInsuredObj['propertyId'] = null,
    primaryInsuredObj['propertyRefGuid'] = propertyGuid,
    primaryInsuredObj['totBussinessInteruptionInsurable'] = 0.0,
    primaryInsuredObj['totStockCategoryInsurable'] = 0.0,
    primaryInsuredObj['totPropertyDamageInsurable'] = 0.0

    proposalCoverageInsureds.push(primaryInsuredObj);
  }

  private transformFundAllocationDataUIToServer(payload, ErrorList) {
    console.log("fundAllocationComponentData", this.fundAllocationComponentData);
    if(this.fundAllocationComponentData['ComponentData'] && this.commonUtilty.isArrayIterable(this.fundAllocationComponentData['ComponentData']['gridForm'])) {
      const totalPercent = this.fundAllocationComponentData['ComponentData']['gridForm'].reduce((acc, currentValue)=>
        acc + currentValue.percentage,
        0
      );

      if(totalPercent>100) {
        let errorDO = new ErrorDO();
        errorDO.errorMsg = "Fund allocation percentage should not be greater than 100%";
        errorDO.fieldName = "Percentage";
        errorDO.fieldNameDescription = "Percentage"
        errorDO.componentName = "FundAllocationComponent";
        ErrorList = this.commonUtilty.uniquePushInArray(ErrorList, errorDO, 'fieldName')
      } else {
        let DO = this.commonUtilty.getDOName(payload);
        this.fundAllocationComponentData['ComponentData']['gridForm'].forEach(fundsAllocation=>{
          if (!fundsAllocation.guid)
          fundsAllocation.guid = new GuidGenerator().setGuid();
        })
        payload[DO]['policyFunds'] = this.commonUtilty.deepCopy(this.fundAllocationComponentData['ComponentData']['gridForm']);
      }
    }
  }
  private _saveOrSubmitIntimationTransaction(payload: any) {
    if (payload) {

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 4000 });
            this.saveIntimation(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitIntimation(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }


  private _saveOrSubmitPolicyTransaction(payload: any) {
    if (payload) {
      this.dataSubmittedFlag = false;

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 10000 });
            this.savePolicy(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 10000 });
            this.submitPolicy(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Policy Payload."
    }
  }

  private _saveOrSubmitCounterPolicyTransaction(payload: any) {
    if (payload) {
      this.dataSubmittedFlag = false;

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 10000 });
            this.saveCounterPolicy(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 10000 });
            this.submitCounterPolicy(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Policy Payload."
    }
  }

  private _saveOrSubmitCaseTransaction(payload: any) {
    if (payload) {

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 30000 });
            this.saveCase(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 10000 });
            this.submitCase(payload);
          }
        })
    }
    else {
      throw "Error while creating Save Policy Payload."
    }
  }

  savePolicy$ = null
  savePolicy(payload) {
    if (this.savePolicy$) this.savePolicy$.unsubscribe()
    this.savePolicy$ = this.policyService.savePolicies(payload).subscribe(resp => {
      this.dataSubmittedFlag = true;
      this._postSaveHandler(resp);
    });
  }
  saveCounterPolicy(payload) {
    if (this.savePolicy$) this.savePolicy$.unsubscribe()
    this.savePolicy$ = this.policyService.saveCounterPolicies(payload).subscribe(resp => {
      this.dataSubmittedFlag = true;
      this._postSaveHandler(resp);
    });
  }
  submitPolicy$ = null
  submitPolicy(payload) {
    if (this.submitPolicy$) this.submitPolicy$.unsubscribe()
    this.submitPolicy$ = this.policyService.submitPolicies(payload).subscribe(resp => {
      this.dataSubmittedFlag = true;
      this._postSubmitHandler(resp);
    });
  }

  submitCounterPolicy(payload) {
    payload = this.setActionsResponse(payload)
    if (this.submitPolicy$) this.submitPolicy$.unsubscribe()
    this.submitPolicy$ = this.policyService.submitCounterPolicies(payload).subscribe(resp => {
      this.dataSubmittedFlag = true;
      this._postSubmitHandler(resp);
    });
  }

  saveCase$ = null
  saveCase(payload) {
    if (this.savePolicy$) this.savePolicy$.unsubscribe()
    this.savePolicy$ = this.policyService.saveCase(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitCase$ = null
  submitCase(payload) {
    if (this.submitPolicy$) this.submitPolicy$.unsubscribe()
    this.submitPolicy$ = this.policyService.submitCase(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }


  saveIntimation$ = null
  saveIntimation(payload) {
    if (this.saveIntimation$) this.saveIntimation$.unsubscribe()
    this.saveIntimation$ = this.intimationService.saveIntimation(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }
  submitIntimation$ = null
  submitIntimation(payload) {
    if (this.submitIntimation$) this.submitIntimation$.unsubscribe()
    this.submitIntimation$ = this.intimationService.submitIntimation(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }
  saveRegistrationObservable = null
  private _saveOrSubmitRegistrationTransaction(payload: any) {
    if (payload) {
      if (this.saveRegistrationObservable)
        this.saveRegistrationObservable.unsubscribe();
      this.message.loading('Saving', { nzDuration: 8000 });
      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration: 8000 });
            this.saveRegistration(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitRegistration(payload);
          }
        })


    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }




  private _saveOrSubmitAdjudicationTransaction(payload: any) {

    if (payload) {
      if (this.saveRegistrationObservable)
        this.saveRegistrationObservable.unsubscribe();

      this.interactService.transactionCloserSubject$
        .pipe(take(1))
        .subscribe(resp => {
          if (resp && resp == 'save') {
            this.message.loading('Saving', { nzDuration:8000 });
            this.saveAdjudication(payload)
          }
          if (resp && resp == 'submit') {
            this.message.loading('Submitting', { nzDuration: 4000 });
            this.submitAdjudication(payload);
          }
        })


    }
    else {
      throw "Error while creating Save Intimation Payload."
    }
  }
  saveRegistration(payload) {
    this.claimRegistrationService.saveClaimRegistration(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitRegistration(payload) {
    this.claimRegistrationService.submitClaimRegistration(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  saveAdjudication(payload) {
    this.claimRegistrationService.saveAdjudication(payload).subscribe(resp => {
      this._postSaveHandler(resp);
    });
  }

  submitAdjudication(payload) {
    this.claimRegistrationService.submitAdjudition(payload).subscribe(resp => {
      this._postSubmitHandler(resp);
    });
  }

  private _postSaveHandler(resp: any) {
    this._transactionInProgress = false
    console.log(JSON.stringify(resp))
    if (resp && Object.entries(resp).length > 0 && !resp['errormesage']) {
      let DOName = this._getDOName(this.mapperTransactionState)
      this.nullifyPayloadInEdit = 'start';

      if ((DOName === 'proposalDO' || DOName === 'caseDO') && resp && resp[DOName] && resp[DOName]['proposalNum'])
        this.message.success(`Proposal(${resp[DOName]['proposalNum']}) has been saved`, { nzDuration: 4000 })

      this.transactionGuid = this._intimationTransformServerToUI(resp);
      this.payloadInEdit = this.commonUtilty.deepCopy(resp);
      this.refreshReassingTaskList();
      this.interactService.sendGenericData(this.payloadInEdit);
      this.interactService.sendPolicyListToInsured(this.payloadInEdit)
      this.interactService.sendClaimIOForDocumentManager(this.payloadInEdit);
      this.interactService.pingForRefreshBasePlan();
      // this.interactService.pingForRefreshCoverages();
      this.refreshComponents()
    }
    else {
      this.message.error('Server Error - Technical issue occurred, please contact IT Support.')
    }

  }

  private _postSubmitHandler(resp: any) {
    this._transactionInProgress = false
    if (resp && Object.entries(resp).length > 0 && !resp['errormesage']) {
      let DOName = this._getDOName(this.mapperTransactionState)
      this.nullifyPayloadInEdit = 'start';
      this.refreshComponents()
      if (DOName === 'proposalDO' && resp && resp[DOName] && resp[DOName]['proposalNum'])
        this.message.success(`Proposal(${resp[DOName]['proposalNum']}) has been submitted`, { nzDuration: 4000 })
      if (DOName === 'caseDO' && resp && resp[DOName] && resp[DOName]['proposalNum'])
        this.message.success(`Proposal(${resp[DOName]['proposalNum']}) has been submitted`, { nzDuration: 4000 })

      let userInfo = this.userInfoService.getUserInfo();
      let userRole = null;
      let userRoleDO = userInfo.userRoleDOList.find(item => true);
      userRole = userRoleDO.roleId;
      if (resp && resp.exceptionDOList && resp.exceptionDOList.length <= 0) {
        if(userRoleDO.roleId == 'UNDERWRITER'){
          this.router.navigate(['/app/nbu/inbox/workbench'])
        }else{
          this.router.navigate(['/app/nbu/proposal/search'])
        }
        //Separate Convert Call Removed from here.
      }
      else {
        // this._intimationTransformServerToUI(resp);
        if (this.appMetadataHandler.featureFlags.demoChange) {
          if(this.payloadInEdit){
            // this.message.success(`Proposal(${this.payloadInEdit[DOName]['proposalNum']}) has been submitted`, { nzDuration: 4000 });
          }else{
            // this.message.success(`Proposal has been submitted`, { nzDuration: 4000 });
          }
          if(userRoleDO.roleId == 'UNDERWRITER'){
            this.router.navigate(['/app/nbu/inbox/workbench'])
          }else{
            this.router.navigate(['/app/nbu/proposal/search'])
          }
        }
        else {

        }
      }
    }
    else {
      this.message.error('Server Error - Technical issue occurred, please contact IT Support.')
    }

  }

  _extractSubmissionModeFromIO(payload) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      return payload[DOName]['intimationSourceCd']
    }

  }

  _setSubmissionModeFromUI(payload) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      payload[DOName]['intimationSourceCd'] = this._intimationSourceCd
    }
    return payload
  }

  _intimationTransformServerToUI(serverIO) {
    this._intimationSourceCd = this._extractSubmissionModeFromIO(serverIO)
    this._inputClaimsBasicDetailsComponent = this._ClaimsBasicDetailsServerDOToComponentMapper(serverIO)
    this._inputCapturedPolicyListComponent = this._CapturedPolicyListServerDOToComponentMapper(serverIO)
    // this._inputAllClientListComponent = this._CapturedClientListServerDOToComponentMapper(serverIO)
    this._inputDocumentManagerComponent = this._DocumentManagerDOToComponentMapper(serverIO)
    this._inputProposalDecisionComponent = this._ClaimDecisionDOToComponentMapper(serverIO)
    this._inputUnderwritingDecisionComponent = this._UnderwritingDecisionDOToComponentMapper(serverIO)
    this._inputClaimsBenefitComponent = this._ClaimsBenefitDOToComponentMapper(serverIO)
    this._inputMulticaptureBankDetailsComponent = this._MulticaptureBankDetailsToComponentMapper(serverIO)
    this._inputBankDetailsComponent = this._BankDetailsToComponentMapper(serverIO)
    this._inputOtherPoliciesComponent = this._OtherPoliciesDOToComponentMapper(serverIO);
    console.log("_inputOtherPoliciesComponent", JSON.stringify(this._inputOtherPoliciesComponent));
    this._inputProductCoveragesComponent = this._ProductCoveragesToComponentMapper(serverIO)
    //below transform calls are not verified and approved by Ninad
    this._inputSubmissionDataComponent = this._SubmissionDataComponentMapper(serverIO);
    this._inputAgentListComponent = this._CapturedAgentListServerDOToComponentMapper(serverIO);
    this._inputInsuredCoverageDecisionComponent = this._GenericDOToComponentMapper(serverIO);
    this._inputVehicleDetailsComponent = this._VehicleDetailsServerDOToComponentMapper(serverIO);
    this._inputPropertyRiskLocation = this._AddressComponentToComponentMapper(serverIO);
    this._inputPropertyDetails = this._PropertyDetailsComponentToComponentMapper(serverIO);
    this._inputTripDetails = this._TripDetailsComponentToComponentMapper(serverIO)

    let clientMaps = this.claimClientUtil.buildClientRolePolicyMappings(serverIO,this.clientDOHM, this.claimClientRoles_HM, this.claimantHM, this.claimPaymentsHM);
    if (clientMaps) {
      this._inputClientListComponent.clientDOHM = clientMaps.clientDOHM; 
      this._inputClientListComponent.claimClientRoles = clientMaps.claimClientRoles_HM; 
      this._inputClientListComponent.claimantHM = clientMaps.claimantHM;
      this._inputClientListComponent.claimPaymentsHM = clientMaps.claimPaymentsHM;
      this.componentRefresh()
    }
    console.log("risk location address component transformn check: ", this._inputProductCoveragesComponent);
    // this._toggleRefreshComponent();
    return this.getTransactionGuid(serverIO)
  }

  _inputPropertyRiskLocation: any = [];
  _AddressComponentToComponentMapper(resp) {
    let output = [];
    if (resp && resp['propertyDO'] && resp['propertyDO'].length) {
      resp['propertyDO'].forEach(element => {
        if (element && element['propertyAddressDO'] && element['propertyAddressDO'].length > 0)
          output.push(element['propertyAddressDO'])
      });
    }
    return output
  }
  _inputPropertyDetails: any = [];
  _PropertyDetailsComponentToComponentMapper(resp) {
    let output = [];
    if (resp && resp['propertyDOs'] && resp['propertyDOs'].length) {
      resp['propertyDOs'].forEach(element => {
        if (element && element['propertyDO'] && element['propertyDO'].length > 0)
          output.push(element['propertyDO'])
      });
    }
    return output
  }
  _inputTripDetails: any = [];
  _TripDetailsComponentToComponentMapper(resp) {
    let output = [];
    if (resp && resp['propertyDO'] && resp['propertyDO'].length) {
      resp['propertyDO'].forEach(element => {
        if (element && element['propertyAddressDO'] && element['propertyAddressDO'].length > 0)
          output.push(element['propertyAddressDO'])
      });
    }
    return output
  }

  _ClaimsBasicDetailsComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && payload[DOName]) {
      payload[DOName].eventTypeCd = response.componentData.value.eventType;
      payload[DOName].eventDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.eventDate);
      payload[DOName].eventTm = this.commonUtilty.UIDOtoServerDOsetTime(response.componentData.value.eventTime);
      payload[DOName].causeOfDeathCd = response.componentData.value.causeOfDeath;
      payload[DOName].intimationDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.intimationDt);
      payload[DOName].receivedDt = this.commonUtilty.UIDOtoServerDODate(response.componentData.value.receivedDt)
      if (!payload[DOName].entryDt)
        payload[DOName].entryDt = new Date();
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && !environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimsBasicDetailsComponent = {}
  _ClaimsBasicDetailsServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    var output = {}
    if (payload && DOName && payload[DOName]) {
      output['eventType'] = payload[DOName].eventTypeCd
      if (payload[DOName].eventDt)
        output['eventDate'] = payload[DOName].eventDt
      if (payload[DOName].eventTm)
        output['eventTime'] = payload[DOName].eventTm
      output['causeOfDeath'] = this._ClaimsBasicDetailsComponentToSeverDOBusinessLogic('DEATHEVENTTYPE', payload[DOName].causeOfDeathCd, output['eventType'])
      output['intimationDt'] = payload[DOName].intimationDt
      output['receivedDt'] = payload[DOName].receivedDt
    }
    return output
  }

  _ClaimsBasicDetailsComponentToSeverDOBusinessLogic(BLRULE, sourceData, caseData?) {
    if (BLRULE === 'DEATHEVENTTYPE') {
      if (caseData === 'DEATH' && sourceData != null) {
        return null
      }
    }
  }

  _CapturedPolicyListComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    if (payload && response && DOName && payload[DOName] && (payload[DOName]['policies'] || payload[DOName]['policy'])) {
      if (this.mapperTransactionState == 'claimIntimation') {
        payload[DOName]['policies'] = this.___markClaimLoggedFl(response.componentData)
      }
      else {
        payload[DOName]['policy'] = this.___markClaimLoggedFl(response.componentData)
      }
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputCapturedPolicyListComponent = {}
  _CapturedPolicyListServerDOToComponentMapper(payload) {
    var output = {}
    if (payload && payload['intimationDO'] && payload['intimationDO']['policies'])
      output = payload.intimationDO.policies

    if (payload && payload['claimDO'] && payload['claimDO']['policy'])
      output = payload.claimDO.policy

    if (payload && payload['investigationDO'] && payload['claimDO']['policy'])
      output = payload.investigationDO.policy

    return output
  }

  ___markClaimLoggedFl(data: Array<any>) {
    let output
    if (data && data.length && data.length > 0) {
      output = this.commonUtilty.deepCopy(data)
      output.forEach(policy => {
        policy['claimLoggedFl'] = true
      });
    }
    if (output)
      return output
    else
      return data
  }

  ___markAllRequirementsAsReceived(payload) {
    if (payload && payload['requirementDOs'] && payload['requirementDOs'].length > 0) {
      payload['requirementDOs'].forEach(requirement => {
        requirement['status'] = "RECEIVED"
      });
    }

    return payload
  }

  ___markAllChecklistAsCompleted(payload) {
    if (payload && payload['checkLists'] && payload['checkLists'].length > 0) {
      payload['checkLists'].forEach(checklistItem => {
        checklistItem['completedFl'] = true
      });
    }

    return payload
  }

  _CapturedClientListComponentToSeverDOMapper(payload, response): any {
    let role = response.componentData.role;
    let output;
    let orphanClientsRemoved = this._removeOrphanClient(payload)
    let outputAfterClientsRemoved = this._clientRoleRemoverToServerDO(orphanClientsRemoved, response)
    output = this._clientRoleMapperToServerDO(outputAfterClientsRemoved, response)
    if (output && output.clientDOs && Array.isArray(output.clientDOs)) {
      output.clientDOs.forEach((client, index) => {
        if (!client) {
          output.clientDOs.splice(index, 1)
        }
      });
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(output)}`)
    }
    return output
  }

  _CapturedAgentListComponentToSeverDOMapper(payload, response): any {
    let role = response.componentData.role;
    let output;
    // let orphanClientsRemoved = this._removeOrphanClient(payload)
    // let outputAfterClientsRemoved = this._clientRoleRemoverToServerDO(orphanClientsRemoved, response)
    output = this._agentRoleMapperToServerDO(payload, response)
    if (output && output.clientDOs && Array.isArray(output.clientDOs)) {
      output.clientDOs.forEach((client, index) => {
        if (!client) {
          output.clientDOs.splice(index, 1)
        }
      });
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(output)}`)
    }
    return output
  }

  _inputAgentListComponent = {}
  _CapturedAgentListServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    let output = {}
    let roleNode = this.configData.AgentNodeMapper[this.TransactionState]
    if (payload) {

      //Create Nodes for All the Roles
      if (payload && payload.agentDOs && payload.agentDOs.length > 0) {
        payload.agentDOs.forEach(agentObj => {
          if (!output[agentObj.agentNum]) {
            output[agentObj.agentNum] = [agentObj.clientRefGuid]
          }
          else {
            output[agentObj.agentNum].push(agentObj.clientRefGuid)
          }
        })
      }
      console.log("agent transform server to ui output 1", JSON.stringify(output));
      //Populate ClientList for Every Role
      for (const key in output) {
        if (output.hasOwnProperty(key)) {
          let agentGuidList = this.commonUtilty.deepCopy(output[key])
          output[key] = []
          if (agentGuidList && Array.isArray(agentGuidList) && payload.clientDOs) {
            agentGuidList.forEach(agentGuid => {
              let selectedAgentData = payload.agentDOs ? payload.agentDOs.find(item => {
                if (item)
                  return item['clientRefGuid'] === agentGuid;
              }) : {}
              let proposalAgentsObj = payload[DOName][roleNode].find(item => key === item.agentNum);
              if (proposalAgentsObj) {
                selectedAgentData['commissionPercent'] = proposalAgentsObj.commissionPercent;
                selectedAgentData['primaryFl'] = proposalAgentsObj.primaryFl;
              }
              let fetchedAgentData = payload.clientDOs.find(item => {
                if (item)
                  return item['guid'] === agentGuid
              })
              let agentDO = selectedAgentData;
              let agentClientDO = fetchedAgentData
              let clientDOObj = { agentDO: {}, clientDO: {} };
              let clientDO = []
              clientDOObj.agentDO = agentDO;
              clientDOObj.clientDO = agentClientDO;
              clientDO.push(clientDOObj);
              let agentObj = { role: "AGENT", clientDO: clientDO }
              output[key].push(agentObj)
            })
          }
        }
      }
    }
    console.log("agent transform server to ui output 2", JSON.stringify(output));
    return output
  }

  _CapturedClientListServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    let output = {}
    let clientMap = {}
    let roleNode = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    if (payload && payload[DOName] && payload[DOName][roleNode]) {

      //Create Nodes for All the Roles
      if (payload && payload[DOName] && payload[DOName][roleNode] && Array.isArray(payload[DOName][roleNode]) && payload[DOName][roleNode].length > 0)
        payload[DOName][roleNode].forEach(clientRole => {
          if (!output[clientRole.roleCd]) {
            output[clientRole.roleCd] = [clientRole.clientRefGuid]
          }
          else {
            output[clientRole.roleCd].push(clientRole.clientRefGuid)
          }

          // Extract Copy Scenario
          if (clientMap[clientRole.clientRefGuid]) {
            if (clientMap[clientRole.clientRefGuid] === "NOMINEE" && clientRole.roleCd === "CLAIMANT") {
              output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
            }
            if (clientMap[clientRole.clientRefGuid] === "CLAIMANT" && clientRole.roleCd === "NOMINEE") {
              output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
            }

            // if (clientMap[clientRole.clientRefGuid] === "OWNER") {
            //   output['EMITTEDCLIENT'] = [clientRole.clientRefGuid]
            // }
          }
          else{
            clientMap[clientRole.clientRefGuid] = clientRole.roleCd;
          }
        })

      //Populate ClientList for Every Role
      for (const key in output) {
        if (output.hasOwnProperty(key)) {
          let clientRefGuidList = this.commonUtilty.deepCopy(output[key])
          output[key] = []
          if (clientRefGuidList && Array.isArray(clientRefGuidList) && payload.clientDOs) {
            clientRefGuidList.forEach(clientRef => {
              let client = payload.clientDOs.find(item => {
                if (item)
                  return item['guid'] === clientRef
              })
              client = this.extractAttributesFromClientRoleNode(client, payload);
              if (client)
                output[key].push(client)
            })
          }
        }
      }

      //Extract PAYEES
      output = this._extratRefGuidsOfPayees(payload, output)
    }
    return output
  }

  private extractAttributesFromClientRoleNode(client: any, payload: any) {
    if (client && payload) {
      let DOName = this._getDOName(this.mapperTransactionState);
      let roleNode = this.configData.StateToClientRolesNodeMapper[this.mapperTransactionState]
      payload[DOName][roleNode].forEach(policyClient => {
        if (policyClient.roleCd != 'OWNER' && client['guid'] == policyClient['clientRefGuid']) {
          client['nomineeSplitPrct'] = policyClient['nomineeSplitPrct'] || 0;
          client['relationCd'] = policyClient['relationCd'];
        }
      });
    }

    return client
  }

  _extratRefGuidsOfPayees(payload, output) {
    let listOfPayees = []
    let nodeName = 'claimPayments'
    let DOName = this._getDOName(this.TransactionState)
    if (payload && DOName && payload[DOName] && payload[DOName][nodeName] && payload[DOName][nodeName].length) {
      payload[DOName][nodeName].forEach(claimPayment => {
        if (claimPayment)
          listOfPayees.push(claimPayment.clientRefGuid)
      });
    }
    output['PAYEE'] = this.commonUtilty.deepCopy(listOfPayees)
    return output
  }

  insuredClientData = null;
  insuredGuid = null;
  _clientRoleMapperToServerDO(payload, response) {
    let role
    let output = this.commonUtilty.deepCopy(payload)
    // if (payload && response && response.componentData && response.componentData.role) {
    //   role = response.componentData.role
    //   let selectedClientData = response.componentData.clientList.selectedClientData
    //   let clientsToBeRemoved = []
    //   if (selectedClientData) {
    //     clientsToBeRemoved = selectedClientData.filter(client => client['remove'])
    //   }
    //   let fetchedClientData = response.componentData.clientList.fetchedClientData;
    //   fetchedClientData = this.copyAdditionalAttributesFromSelectedClientItemToFetchedClientItem(response.componentData.clientList)
    //   if (fetchedClientData && Array.isArray(fetchedClientData)) {
    //     fetchedClientData.forEach(item => {
    //       let isClientToBeRemoved = clientsToBeRemoved.findIndex(clientTobeRemove => {
    //         return clientTobeRemove['guid'] == item['guid']
    //       })
    //       if (isClientToBeRemoved == -1) {
    //         output = this._pushToClientDO(output, item);
    //         output = this._addClientRole(output, item, role, this.TransactionState)
    //       }
    //     })
    //   }
    // }

    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role
      let selectedClientData = response.componentData.clientList.selectedClientData
      // if (this.appMetadataHandler.featureFlags._normalizeSelectClientDataIfGuidIsNullified) {
      //   selectedClientData = this._normalizeSelectClientDataIfGuidIsNullified(selectedClientData, response);
      // }
      let clientsToBeAdded = []
      let clientFlagMap = {}
      if (selectedClientData && Array.isArray(selectedClientData)) {
        clientsToBeAdded = selectedClientData.filter(client => !client['remove'])
        clientFlagMap = this.commonUtilty.convertArrayToMap(selectedClientData, 'guid') || {}
      }
      let fetchedClientData = response.componentData.clientList.fetchedClientData
      fetchedClientData = this.copyAdditionalAttributesFromSelectedClientItemToFetchedClientItem(response.componentData.clientList)
      if (fetchedClientData && Array.isArray(fetchedClientData)) {
        fetchedClientData.forEach(item => {
          let isClientToBeAdded = clientsToBeAdded.findIndex(clientTobeRemove => {
            return clientTobeRemove['guid'] == item['guid']
          })
          if (isClientToBeAdded != -1) {
            if (clientFlagMap && clientFlagMap[item.guid] && !clientFlagMap[item.guid]['remove']) {
              //TODO take Ninad's review
              //below is the test code
              if (item['guid'] == this.insuredGuid && this.insuredClientData) {
                item = this.insuredClientData;
              }
              //test code end
              output = this._pushToClientDO(output, item);
              if(role == 'NOMINEE'){ // CUSTOME Code for Nominee For Insured Mapping.
                output = this._addClientRole(output, item, role, this.TransactionState, clientsToBeAdded)
              }
              else{
                output = this._addClientRole(output, item, role, this.TransactionState)
              }
            }
          }
        })
      }
    }
    return output
  }

  copyAdditionalAttributesFromSelectedClientItemToFetchedClientItem(clientList) {
    let attributes = ['nomineeSplitPrct', 'relationCd'] // if any more attributes needed it can be added here
    if (clientList && clientList.selectedClientData && clientList.fetchedClientData) {
      if (this.commonUtilty.isArrayIterable(clientList.fetchedClientData)) {
        clientList.fetchedClientData.forEach(fetchedClientItem => {
          let selectedClientDataItem
          if (this.commonUtilty.isArrayIterable(clientList.selectedClientData)) {
            selectedClientDataItem = clientList.selectedClientData.find(selectedClientDataItem => selectedClientDataItem['guid'] == fetchedClientItem['guid'])
            if (selectedClientDataItem && fetchedClientItem) {
              attributes.forEach(attr => {
                fetchedClientItem[attr] = selectedClientDataItem[attr]
              })
            }
          }
        });
      }
    }

    return clientList.fetchedClientData
  }

  _agentRoleMapperToServerDO(payload, response) {
    console.log("captured role in _agentRoleMapperToServerDO", response.componentData.role);
    console.log("components response", response);
    console.log("agents components data", response.componentData);
    let role
    let output = this.commonUtilty.deepCopy(payload)
    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role

      // if (Array.isArray(this.agentDataSet) && this.agentDataSet.length > 0) {
      let agentClientDOList = [];
      let fetchedClientData = response.componentData.agentList.fetchedClientData;
      let selectedClientData = response.componentData.agentList.selectedClientData;
      if (fetchedClientData && typeof fetchedClientData == typeof []) {
        fetchedClientData.forEach(item => {
          if (item) {
            let selectedCLient = Array.isArray(selectedClientData) ? selectedClientData.find(s => s.clientRefGuid == item.guid) : null;
            output = this._pushToClientDO(output, item);
            output = this._addPolicyAgent(output, selectedCLient, this.TransactionState);
            // output = this._addClientRole(output, item, role, this.TransactionState)
          }
        });
      }

      if (selectedClientData && typeof selectedClientData == typeof []) {
        selectedClientData.forEach(item => {
          if (item) {

            // output = this._addClientRole(output, item, role, this.TransactionState)
          }
        });
      }
      // }
    }
    return output
  }

  _removeOrphanClient(payload, roleCd?) {
    //Functionality Pending

    return payload
  }

  _clientRoleRemoverToServerDO(payload, response) {
    let role
    let output = this.commonUtilty.deepCopy(payload)
    if (payload && response && response.componentData && response.componentData.role) {
      role = response.componentData.role
      let selectedClientData = response.componentData.clientList.selectedClientData
      let clientsToBeRemoved = []
      if (selectedClientData) {
        clientsToBeRemoved = selectedClientData.filter(client => client['remove'])
      }
      let fetchedClientData = response.componentData.clientList.fetchedClientData
      if (fetchedClientData != null && typeof fetchedClientData == typeof []) {
        fetchedClientData.forEach(item => {
          let isClientToBeRemoved = clientsToBeRemoved.findIndex(clientTobeRemove => {
            return clientTobeRemove['guid'] == item['guid']
          })

          if (isClientToBeRemoved != -1) {
            output = this._removeClientRole(output, item, role, this.TransactionState);
            output = this._removeClientDO(output, item, this.TransactionState)
          }
        })
      }
    }
    return output
  }

  _removeClientRole(p, m, r, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    let index
    if (p && p[DOName] && p[DOName][NodeName]) {
      index = p[DOName][NodeName].findIndex(x => {
        return x.clientRefGuid === m.guid && x.roleCd === r
      });

      if (index != -1) {
        p[DOName][NodeName].splice(index, 1)
      }
    }

    return p
  }

  _removeClientDO(p, m, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    if (p && p.clientDOs && m && m.guid) {
      //Check if client has no other role existing only then delete clientDO
      let index = p.clientDOs.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1) {
        if (p && p[DOName] && p[DOName][NodeName]) {
          //find the index of role, the clientDO currently has
          let roleIndex = p[DOName][NodeName].findIndex(x => {
            return x.clientRefGuid === m.guid
          });
          if (roleIndex === -1) // If -1 that means the specific clientDO has no active role in transaction
            p.clientDOs.splice(index, 1)
        }
      }
    }
    return p
  }

  _pushToClientDO(p, m) {
    if (p && p.clientDOs && m && m.guid) {
      let index = p.clientDOs.findIndex(x => { if (x && m) return x.guid === m.guid });
      if (index != -1)
        p.clientDOs.splice(index, 1, m)
      else {
        p.clientDOs.push(m)
      }
    }
    return p
  }

  _addClientRole(p, m, r, mapperTransactionState, nomineeClient?) {
    let DOName = this._getDOName(mapperTransactionState)
    let NodeName = this.configData.StateToClientRolesNodeMapper[this.TransactionState]
    let index
    if (p && p[DOName] && p[DOName][NodeName]) {
      index = p[DOName][NodeName].findIndex(x => {
        return x.clientRefGuid === m.guid && x.roleCd === r
      });

      if (index != -1) {
        let claimClientRoleItem = this.commonUtilty.deepCopy(p[DOName][NodeName][index])
        claimClientRoleItem.clientRefGuid = m.guid
        claimClientRoleItem.roleCd = r
        claimClientRoleItem.nomineeSplitPrct = m.nomineeSplitPrct || 0;
        if(r == 'NOMINEE' && this.commonUtilty.isArrayIterable(nomineeClient) && m && Object.keys(m).length){ // NOMINEE FOR field ui to server.
          nomineeClient.forEach(item=>{
            if(item.id == m.id && item.nomineeForInsured){
              claimClientRoleItem.nomineeForInsured = item.nomineeForInsured;
            }
          })
        }
        claimClientRoleItem.relationCd = m.relationCd;
        p[DOName][NodeName].splice(index, 1, claimClientRoleItem)
      }
      else {
        let claimClient;
        if(this.commonUtilty.isArrayIterable(nomineeClient) && m && Object.keys(m).length){  // NOMINEE FOR field ui to server.
          nomineeClient.forEach(item=>{
            if(item.id == m.id){
              claimClient = new ClaimClientRole(m.guid, r, "BYPASS", null ,item.nomineeForInsured, item.nomineeSplitPrct)
            }
          })
        }
        else{
          claimClient = new ClaimClientRole(m.guid, r, "BYPASS")
        }
        claimClient['relationCd'] = m.relationCd;
        claimClient['nomineeSplitPrct'] = m.nomineeSplitPrct || 0
        if (!p[DOName][NodeName]) p[DOName][NodeName] = []
        p[DOName][NodeName].push(claimClient)
      }

      //Removing Orphan Claimants
      //TODO Owner Ninad: Remove Orphan claimants
      // if (!this.appMetadataHandler.isStable && r === "CLAIMANT" && this.appMetadataHandler.claimsModes.claimantMode === 'SINGLE') {
      //   let orphanCliamantsRemoved = p[DOName][NodeName].filter(claimRole => {return ((claimRole.clientRefGuid != m.guid )&& (claimRole.roleCd != "CLAIMANT"))})
      //   p[DOName][NodeName] = this.commonUtilty.deepCopy(orphanCliamantsRemoved)
      // }
    }

    return p
  }

  _addPolicyAgent(p, m, mapperTransactionState) {
    let DOName = this._getDOName(mapperTransactionState)
    let AgentNodeName = this.configData.AgentNodeMapper[this.TransactionState]
    let index
    if (m) {
      if (p && p[DOName] && p[DOName][AgentNodeName]) {
        index = p[DOName][AgentNodeName].findIndex(x => {
          return x.agentNum === m.agentNum
        });

        if (index != -1) {
          let agentListRoleItem = this.commonUtilty.deepCopy(p[DOName][AgentNodeName][index])
          agentListRoleItem.agentNum = m.agentNum
          // agentListRoleItem.roleCd = r
          p[DOName][AgentNodeName].splice(index, 1, agentListRoleItem)
        }
        else {
          let agentPolicyClient = new PolicyAgentDO();
          // agentPolicyClient.id = m.id;
          agentPolicyClient.guid = new GuidGenerator().setGuid();
          agentPolicyClient.agentNum = m.agentNum;
          agentPolicyClient.primaryFl = m.primaryFl;
          agentPolicyClient.firstName = m.firstName;
          agentPolicyClient.lastName = m.lastName;
          // agentPolicyClient.companyContactUserId = m.companyContactUserId;
          agentPolicyClient.clientId = m.clientId;
          agentPolicyClient.channelCd = m.channel;
          // agentPolicyClient.companyCd = m.companyCd;
          // agentPolicyClient.subChannelCd = m.subChannelCd;
          // agentPolicyClient.partnerbranchCd = m.partnerbranchCd;
          // agentPolicyClient.vatApplicableFl = m.vatApplicableFl;
          // agentPolicyClient.companyBranchCd = m.companyBranchCd;
          agentPolicyClient.commissionPercent = m.commissionPercent;

          if (!p[DOName][AgentNodeName]) p[DOName][AgentNodeName] = []
          p[DOName][AgentNodeName].push(agentPolicyClient)
        }

        //Removing Orphan Claimants
        //TODO Owner Ninad: Remove Orphan claimants
        // if (!this.appMetadataHandler.isStable && r === "CLAIMANT" && this.appMetadataHandler.claimsModes.claimantMode === 'SINGLE') {
        //   let orphanCliamantsRemoved = p[DOName][NodeName].filter(claimRole => {return ((claimRole.clientRefGuid != m.guid )&& (claimRole.roleCd != "CLAIMANT"))})
        //   p[DOName][NodeName] = this.commonUtilty.deepCopy(orphanCliamantsRemoved)
        // }
      }
    } else throw `TRANSFORM ISSUE: EMPTY SELECTED CLIENT DATA FOUND FOR AGENT -- CapturedAgentListComponent`;
    return p
  }



  //differential
  _getDOName(state) {
    let output = this.configData.StateToDOMapper[state]
    let defaultClaimDOFeatureOnAndNoDOFoundInMapper = this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !this.configData.StateToDOMapper[state]
    let defaultClaimDOFeatureOffAndNoDOFoundInMapper = !this.appMetadataHandler.featureFlags['setDOAsClaimDOIfNoDOMappingFound'] && !this.configData.StateToDOMapper[state]
    if (defaultClaimDOFeatureOnAndNoDOFoundInMapper) {
      return 'claimDO'
    }
    else if (defaultClaimDOFeatureOffAndNoDOFoundInMapper)
      throw "No Valid DO name for the state passed --" + state;
    else
      return output

  }

  _DocumentManagerComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      if (payload.requirementDOs && response.componentData.requirementDOs.length>0) {
        payload.requirementDOs = this.commonUtilty.deepCopy(response.componentData.requirementDOs)
      }
      if (payload.entityDocumentDOs) {
        payload.entityDocumentDOs = this.commonUtilty.deepCopy(response.componentData.entityDocumentDOs)
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }

    return payload
  }

  _inputDocumentManagerComponent = {};
  _DocumentManagerDOToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState);
    let output = {
      'requirementDOs': null,
      'entityDocumentDOs': null
    };
    if (payload) {
      /* Requirements*/
      if (payload['requirementDOs']) output['requirementDOs'] = payload['requirementDOs'];
      /* Docs */
      if (payload['entityDocumentDOs']) output['entityDocumentDOs'] = payload['entityDocumentDOs'];
    }
    return payload;//output;
  }

  _ProposalDecisionComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['uwDecisionCd'] = response.componentData.value.uwDecisionCd
      payload[DO]['uwDecisionDt'] = response.componentData.value.uwDecisionDt
      payload[DO]['uwDecisionRemarks'] = response.componentData.value.uwDecisionRemarks
      payload[DO]['statusReasonCd'] = response.componentData.value.statusReasonCd
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputProposalDecisionComponent = {};
  _ClaimDecisionDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _UnderwritingDecisionComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['uwDecisionCd'] = response.componentData.value.underwritingDecision
      payload[DO]['uwDecisionValue'] = response.componentData.value.underwritingRemarks
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputUnderwritingDecisionComponent = {};
  _UnderwritingDecisionDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  selectedDecisionCd
  _fetchSelectedDecisionCdFromUnderwritingDecisionComponent(value) {
    this.selectedDecisionCd = value
    const componentName = "InsuredCoverageDecisionComponent"
    if (this.selectedDecisionCd) {
      this.listOfAllChildren = this.listOfAllChildren.filter(e => e != componentName)
    }
    else {
      this.listOfAllChildren = this.listOfAllChildren.filter(e => e != componentName)
      this.listOfAllChildren.push(componentName)
    }
  }

  _GenericComponentToSeverDOMapper(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    if (payload && payload[DO] && response && response.UItoServerTransform) {
      let transformFunction = response.UItoServerTransform.bind(this)
      payload = transformFunction(payload, response)
      if((response.UItoServerTransform.name == 'HealthUItoServerTransform' && DO == 'caseDO') || (response.UItoServerTransform.name == 'LifeUItoServerTransform' && DO == 'caseDO')){ // CUSTOME CODE FOR uwDecisionCd set //
        // payload = this.setCoverageList(payload); 
      }
    }
    else {
      console.group(`%cUIToServer Transformation ${response.componentName} : Failed. Either of the below four things have a problem`, 'color: white; background-color: red; padding: 2px 5px; border-radius: 2px')
      console.info('1. payload', payload)
      console.info('2. payload[DO]', payload[DO])
      console.info('3. response', response)
      console.info('4. response.UItoServerTransform', response.UItoServerTransform)
      console.groupEnd();

    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    if (response.componentName == "TripDetailsComponent") {
      let policyCommencementDt = response.componentData.form.value.policyCommencementDt;
      
      if (policyCommencementDt) {
          let timestampDate = new Date(policyCommencementDt).getTime();
          response.componentData.form.value.policyCommencementDt = timestampDate;
          payload[DO].policyCommencementDt = timestampDate;
      }
      let policyExpiryDt = response.componentData.form.value.policyExpiryDt;
      if(policyExpiryDt){
        let expiryDate = new Date(policyExpiryDt).getTime();
          response.componentData.form.value.policyExpiryDt = expiryDate;
          payload[DO].policyExpiryDt = expiryDate;
      }
  }
    return payload
  }

  _inputInsuredCoverageDecisionComponent = {};
  _GenericDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _ClaimsBenefitComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]) {
      payload[DO]['claimCoverages'] = response.componentData
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputClaimsBenefitComponent = {};
  _ClaimsBenefitDOToComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _OtherPoliciesComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    this.otherListNode = this.configData.OtherListNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      // payload[DO][this.otherListNode].push(...response.componentData);
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputOtherPoliciesComponent = {};
  _OtherPoliciesDOToComponentMapper(payload) {
    let output = null;
    let DO = this._getDOName(this.TransactionState)
    this.otherListNode = this.configData.OtherListNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload[DO][this.otherListNode])
    }
    return output;
  }

  _MulticaptureBankDetailsComponentToSeverDOMapper_old(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    let paymenNode = this.configData.PaymentNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {

      if (this.TransactionState === "policyDataEntry") {
        response.componentData.forEach(receivedPaymentDetails => {

          let foundIndex = payload[DO][paymenNode].findIndex(paymentObj => paymentObj.clientRefGuid == receivedPaymentDetails.clientRefGuid)
          if (foundIndex == -1) {

            let paymentDO = new PolicyPaymentDO();
            paymentDO.accountHolderName = receivedPaymentDetails.accountHolderName;
            paymentDO.accountNum = receivedPaymentDetails.accountNum;
            paymentDO.paymentMethodCd = receivedPaymentDetails.paymentMethodCd;
            paymentDO.clientRefGuid = receivedPaymentDetails.clientRefGuid;
            payload[DO][paymenNode].push(paymentDO)
          }
          else {
            for (const key in receivedPaymentDetails) {
              if (receivedPaymentDetails.hasOwnProperty(key) && receivedPaymentDetails[key]) {
                payload[DO][paymenNode][foundIndex][key] = receivedPaymentDetails[key]
              }
            }
          }
        });
      } else {
        response.componentData.forEach(receivedPaymentDetails => {
          let foundIndex = payload[DO][paymenNode].findIndex(claimPayment => claimPayment.clientRefGuid == receivedPaymentDetails.clientRefGuid)
          if (foundIndex == -1) {
            payload[DO][paymenNode].push(receivedPaymentDetails)
          }
          else {
            for (const key in receivedPaymentDetails) {
              if (receivedPaymentDetails.hasOwnProperty(key) && receivedPaymentDetails[key]) {
                payload[DO][paymenNode][foundIndex][key] = receivedPaymentDetails[key]
              }
            }
          }
        });
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _MulticaptureBankDetailsComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    let paymenNode = this.configData.PaymentNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      // payload[DO]['claimPayments'] = response.componentData
      payload[DO][paymenNode] = payload[DO][paymenNode] ? payload[DO][paymenNode] : []
      response.componentData.forEach(receivedPaymentDetails => {
        let foundIndex = payload[DO][paymenNode].findIndex(claimPayment => claimPayment.clientRefGuid == receivedPaymentDetails.clientRefGuid)
        if (foundIndex == -1) {
          payload[DO][paymenNode].push(receivedPaymentDetails)
        }
        else {
          for (const key in receivedPaymentDetails) {
            if (receivedPaymentDetails.hasOwnProperty(key) && receivedPaymentDetails[key]) {
              payload[DO][paymenNode][foundIndex][key] = receivedPaymentDetails[key]
            }
          }
        }
      });
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _BankDetailsComponentToSeverDOMapper(payload, response) {
    let DOName = this._getDOName(this.TransactionState)
    let paymentList = DOName == 'caseDO' ? (payload[DOName].casePayments || []) : (payload[DOName].proposalPayments || []);
    let paymentDO = this.commonUtilty.isArrayIterable(paymentList) ? paymentList[0] : new ProposalPaymentDO();
    let caseOrProposalPayment = DOName == 'caseDO' ? 'casePayments' : 'proposalPayments';
    if (response && response.componentData) {
      paymentDO.accountHolderName = response.componentData.accountHolderName;
      paymentDO.accountNum = response.componentData.accountNum;
      paymentDO.accountTypeCd = response.componentData.accountTypeCd;
      paymentDO.paymentMethodCd = response.componentData.paymentMethodCd;
      paymentDO.branchIdNum1 = response.componentData.branchIdNum1;
      paymentDO.branchIdNum2 = response.componentData.branchIdNum2;
      paymentDO.bankName = response.componentData.bankName;
      paymentDO.bankBranchName = response.componentData.bankBranchName;
      paymentDO.purposeCd = response.componentData.purposeCd;
      payload[DOName][caseOrProposalPayment][0] = paymentDO;
    }
    return payload
  }

  coverages = [];
  _InsuredCoverageDecisionComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    let DOName = this.commonUtilty.getDOName(payload)
    let CoveragesNode = this.configData.CoverageNodeMapper[this.mapperTransactionState];
    if(payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][CoveragesNode])
      && response && response.componentData && 
      this.commonUtilty.isArrayIterable(response.componentData.coverageSpecificDecisionList)
      && this.commonUtilty.isArrayIterable(response.componentData.insuredSpecificDecisionList)){
        payload[DO][CoveragesNode].forEach(item=>{
          response.componentData.coverageSpecificDecisionList.forEach(element=>{
            // if(item.guid == element.guid &&  item.planTypeCd !== 'BASEPLAN'){ //removed this condition for baseplan condition for base plan decision
            if(item.guid == element.guid ){
              item.uwDecisionCd = element.uwDecisionCd; // Coverage UW Decision Mapping
              item.uwDecisionRemarks = element.uwDecisionRemarks;
              item.sumInsuredAmt = element.sumInsuredAmt;
              item.approvedSumInsuredAmt = element.approvedSumInsuredAmt;
              item.loadingTypeCd = element.loadingTypeCd
              if(this.commonUtilty.isArrayIterable(element.caseCoverageLoadings)){
                item.caseCoverageLoadings = this.commonUtilty.deepCopy(element.caseCoverageLoadings)
              }
              if(this.commonUtilty.isArrayIterable(element.caseCovLoadingExclusions)){
                item.caseCovLoadingExclusions = this.commonUtilty.deepCopy(element.caseCovLoadingExclusions)
              }
              if(this.commonUtilty.isArrayIterable(item.caseCoverageInsureds)){
                  item.caseCoverageInsureds.forEach(ins=>{
                    ins.uwDecisionCd = element.uwDecisionCd
                    ins.uwDecisionRemarks = element.uwDecisionRemarks
                    ins.caseCovInsuredLoadingExclusions = this.commonUtilty.deepCopy(element.caseCoverageInsureds[0].caseCovInsuredLoadingExclusions)
                  })
                }

              if(item.primaryInsured && Object.keys(item.primaryInsured).length){ // Coverage Primary Insured Decision Mapping
                response.componentData.insuredSpecificDecisionList.forEach(insured=>{ 
                  if(item.primaryInsured.clientRefGuid == insured.clientRefGuid){
                    item.primaryInsured.uwDecisionCd = insured.uwDecisionCd
                    item.primaryInsured.uwDecisionRemarks = insured.uwDecisionRemarks

                    // if(this.commonUtilty.isArrayIterable(item.caseCoverageInsureds)){
                    //   item.caseCoverageInsureds.forEach(ins=>{
                    //     ins.uwDecisionCd = insured.uwDecisionCd
                    //     ins.uwDecisionValue = insured.uwDecisionValue
                    //   })
                    // }
                  }
                })
              }
            }
          })
        })

        this.coverages =  this.commonUtilty.deepCopy(payload[DO][CoveragesNode]);
      }
      let clientListNode = "caseClients"
      if(payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][clientListNode])
      && response && response.componentData && 
      this.commonUtilty.isArrayIterable(response.componentData.coverageSpecificDecisionList)
      && this.commonUtilty.isArrayIterable(response.componentData.insuredSpecificDecisionList)){
        payload[DO][clientListNode].forEach(item=>{
          response.componentData.insuredSpecificDecisionList.forEach(insured=>{ 
            if(item.clientRefGuid == insured.clientRefGuid){
              item.uwDecisionCd = insured.uwDecisionCd
              item.uwDecisionRemarks = insured.uwDecisionRemarks
            }
          })
        })
      }

    return payload;
  }

  _inputMulticaptureBankDetailsComponent = [];
  _MulticaptureBankDetailsToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState)
    let paymentNode = this.configData.PaymentNodeMapper[this.TransactionState];
    let clientNode = this.configData.StateToClientRolesNodeMapper[this.TransactionState];
    let output = [];
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload[DO][paymentNode])
    }

    return output;
  }

  _inputBankDetailsComponent = [];
  _BankDetailsToComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState)
    let paymentNode = this.configData.PaymentNodeMapper[this.TransactionState];
    let output = [];
    if(payload && payload[DO] && this.commonUtilty.isArrayIterable(payload[DO][paymentNode])){
      output = payload[DO][paymentNode][0];
    }
    return output;
  }

  _SubmissionDataComponentToSeverDOMapper(payload, response) {
    console.log("payload", JSON.stringify(payload));
    console.log("response", response);
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]

    if (!this.appMetadataHandler.featureFlags.enableDynamicRendering) {
      payload[DO].baseProductCd = response.componentData.value.productType;
      payload[DO].sumInsuredAmt = response.componentData.value.sumInsuredAmt;
      payload[DO].purposeOfInsuranceCd = response.componentData.value.purposeOfInsuranceType;
      payload[DO].baseProductFamilyCd = this.productFamilyCd;
      // payload[DO].pdfTemplateCd = this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd;
      payload[DO].pdfTemplateCd = this.productFamilyCd;
      payload[DO].submissionModeCd = "PORTAL"
      payload[DO].currencyCd = response.componentData.value.currencyType
      payload[DO].proposalReceivedDt = response.componentData.value.receivedDate
      payload[DO].effectiveDt = response.componentData.value.receivedDate
      payload[DO].policyCommencementDt = response.componentData.value.inceptionDate;
      payload[DO].proposalSignedDt = response.componentData.value.signedDate;
      payload[DO].policyExpiryDt = response.componentData.value.expiryDate;
      payload[DO].proposalEntryDt = new Date();
      // payload[DO].policyTripDO = response.componentData.form.value;
      payload[DO].errorFl = false;
      if (this.productFamilyCd == 'LIFE') {
        payload[DO].termTypeCd = response.componentData.value.termType;
        payload[DO].parentPolicyNum = response.componentData.value.masterPolicyNo;
        payload[DO].sunInsuredTypeCd = response.componentData.value.coverType;
      }
      payload[DO].policyTerm = response.componentData.value.term;
    }

    return payload;
  }

  _inputSubmissionDataComponent = [];
  _SubmissionDataComponentMapper(payload) {
    let DO = this._getDOName(this.TransactionState)
    let output = null;
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  dataSubject$
  _ProductCoveragesComponentToSeverDOMapper(payload, response) {
    let newCoverages = []
    let oldCoverages = []
    console.log("response for product coverages component", response);
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]
    // let componenetResponse = this.commonUtilty.convertMapToArray(response.componentData)
    if (payload && payload[DO]) {
      // if (componenetResponse && Array.isArray(componenetResponse)) {
      //   newCoverages = componenetResponse.filter(item => !item.id)
      //   oldCoverages = componenetResponse.filter(item => item.id)
      // }
      if (response && Array.isArray(response.componentData)) {
        newCoverages = response.componentData.filter(item => !item.id)
        oldCoverages = response.componentData.filter(item => item.id)
      }
      if (oldCoverages && Array.isArray(oldCoverages) && oldCoverages.length > 0 &&
        payload[DO][coverageNodeName] && Array.isArray(payload[DO][coverageNodeName]) && payload[DO][coverageNodeName].length > 0) {
        oldCoverages.forEach(oldCoverage => {
          let foundIndex = payload[DO][coverageNodeName].findIndex(currentCoverage => currentCoverage.id == oldCoverage.id)
          payload[DO][coverageNodeName][foundIndex] = this.commonUtilty.deepCopy(oldCoverage)
        })
      }

      if (newCoverages && Array.isArray(newCoverages) && newCoverages.length > 0 &&
        payload[DO][coverageNodeName] && Array.isArray(payload[DO][coverageNodeName]) && payload[DO][coverageNodeName].length > 0) {
        payload[DO][coverageNodeName].push(...newCoverages)
      }
      
      if(!this.commonUtilty.isArrayIterable(oldCoverages) && !this.commonUtilty.isArrayIterable(newCoverages)){
        this.coverages =  this.commonUtilty.deepCopy(payload[DO][coverageNodeName]);
      }
    }

    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _inputProductCoveragesComponent = {};
  _ProductCoveragesToComponentMapper(payload) {
    let output = null;
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      output = this.commonUtilty.deepCopy(payload[DO][coverageNodeName])
    }
    return output;
  }

  _inputProductCoveragesBasePlanComponent = [];
  _ProductCoveragesBasePlanComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }

  _inputProductCoveragesAdditionalCoverComponent = [];
  _ProductCoveragesAdditionalCoverComponentMapper(payload) {
    let output = null;
    if (payload) {
      output = this.commonUtilty.deepCopy(payload)
    }
    return output;
  }


  getTransactionGuid(serverIO) {
    let DOName = this._getDOName(this.TransactionState)
    if (serverIO && DOName && serverIO[DOName])
      return serverIO[DOName]['guid'] || null
    else
      return null
  }


  NullValue: any = null;
  ClientCaptureFooter = null;

  tabs: any[] = [];
  nzTabPosition = 'top';
  selectedIndex = 0;
  nomineeDataSet: any[] = [];  
  appointeeDataSet: any[] = [];
  payerDataSet: any = [];
  insuredDataSet: any[] = [];
  primaryInsuredDataSet: any[] = [];
  agentDataSet: any[] = [];
  ownerDataSet: any[] = [];
  vehicleDataSet: any[] = [];
  membersDataSet: any[] = [];
  MULTI: any = "MULTI";
  SINGLE: any = "SINGLE";
  claimantDataSet: any[] = [];
  // policyDataSet:any[] =[];
  parentPolicyItem: any[] = [];
  policyListFetchedFromServer: any[] = [];
  enableCopyOfPrimaryInsuredAsOwner = true;
  enableCopyOfClaimantAsPayer = true;
  transactionGuid = null
  _intimationSourceCd = null

  showLastNote: boolean = true;
  hideTab: boolean = false;

  // for auto rules showing names based on lookup, these var is used for that
  decisionCd: any;
  decisionTypeCd: any;
  manualUwDecisionCd: any;
  uwRuleSubType: any;
  autoUwRuleCd: any;

  /* tslint:disable-next-line:no-any */
  log(args: any[]): void {
    console.log(args);
  }

  agentList
  genericSubject$
  productSpecificationList = [];
  toggleInsuredListSubject$
  toggleCoveragesSubject$

  configPath = environment.configPath
  configData: any;
  currentDO: string
  
  gridModal :any
  configurationGuid:any= 'e636e679-c675-4eac-bf2c-766750cfa2ff';
  splitModeImages = ['/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_1.jpg', '/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_2.jpg', '/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_3.jpg', '/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_4.jpg','/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_5.jpg','/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_6.jpg','/assets/images/Proposal_Forms_John_Doe/John_Doe_PF_7.jpg'];
  singleImgViewer = '/assets/images/Proposal_Forms_Dan_Miller/John_Doe -Proposal_Form.jpg';
  disableTransaction= false;
  disableSaveSubmitButton : boolean = false
  enableActionButton : boolean = false
  splitModeDocument$: any;
  enableUWTab=false;
  coordinatesMap : any = null;
  private clientStoreSubscription: Subscription;

  ngOnInit(): void {
    console.log(this.payloadInEdit);
    this.currentDO = this.configData && this.configData.StateToDOMapper ? this.configData.StateToDOMapper[this.mapperTransactionState] : 'proposalDO';
    this.getConfigDataAndInitialize();
    this.subscribeAndRefreshCoveragesComponent();
    this.fetchUserInfo();
    this.onClientRoleUpdate();
    this.refreshReassingTaskList();


    //let payloadData= this.store.select((store) => store.payload);
    this.store.select('counter').subscribe(data =>{
        if(data){
          let output = {componentName : 'DynamicUIBuilder',storeData:this.commonUtilty.convertMapToArrayWithoutDeepCopy(data.payload)} 
          output = this.checkValidationsStatus(output)
          this._BaseEmitHandler(output,'DynamicUIBuilder');
        }
        
    });

    this.clientStoreSubscription = this.clientStore.select('clientStore').pipe(distinctUntilChanged()).subscribe(data =>{
      console.log(data);
    });

    // this.interactService.viewDocumentInSplitMode$.subscribe(imgResp=>{
    //   if(imgResp){
    //     // this.images = [];
    //     this.splitModeImages.push(imgResp['imgBase64'])
    //     this.singleImgViewer = imgResp['imgBase64']
    //     if(imgResp['closeDrawer']) {
    //       this.docuPanelOpen = false
    //       this.docManagerExpanded = false;
    //       this.enableZoom = false;
    //     } 
    //   }
    // })
    if(this.appMetadataHandler.featureFlags.enableSplitPreview){
      if (this.splitModeDocument$) this.splitModeDocument$.unsubscribe();
      this.interactService.viewDocumentInSplitMode$.subscribe(imgResp => {
        if (imgResp) {
          // this.images = [];
          this.splitModeImages.push(imgResp['imgBase64'])
          this.singleImgViewer = imgResp['imgBase64']
          if (imgResp['closeDrawer']) {
            this.docuPanelOpen = false
            this.docManagerExpanded = false;
            this.enableZoom = false;
          }
        }
      })
    }

    this.coordinatesMap = guidedDataJSON.fieldDataDetails
  }

  userRole = null;
  fetchUserInfo(){
    let userInfo = this.userInfoService.getUserInfo();
    let userRoleDO = userInfo.userRoleDOList.find(item => true);
    this.userRole = userRoleDO.roleId;
  }

  dataSubmittedFlag = false
  showSaveSubmit = false;
  isEditWithConfig:boolean = false;
  private intializeTransaction() {
    this.interactService.transactionSubject$.pipe(take(1)).subscribe(res => {      
      this.isEditWithConfig = res && res.IO ? res.IO['isEditWithConfig']: false;
      this.dataTransformService.isSidebarCollapsed = true
      if (this.appMetadataHandler.featureFlags.enableMockHealthIO)
        res.IO = this.configData.healthDummyJSON;

      if (!(res.state == 'REFERRALS')) {
        if (res.lob == 'TRAVEL') this.TransactionState = res.lob + res.state;
        else if (res.lob == 'PROPERTY') this.TransactionState = res.lob + res.state;                      
        else if (res.lob == 'MOTOR') this.TransactionState = res.lob + res.state;
        else if (res.lob == 'LIFE') this.TransactionState = res.lob + res.state;
        else this.TransactionState = res.state;
      } else this.TransactionState = res.state;
      
      this.dataSubmittedFlag = true
      console.log("transaction state for data entry 1", this.TransactionState);
      this.transactionMasterUpdateControl = this.configData.inboxTypeToUpdateControlMapper[res.inboxType];

      if (!(res.state == 'REFERRALS')) {
        if (res.lob == 'TRAVEL') this.mapperTransactionState = res.lob + res.state;
        else if (res.lob == 'PROPERTY') this.mapperTransactionState = res.lob + res.state;                      
        else if (res.lob == 'MOTOR') this.mapperTransactionState = res.lob + res.state;
        else if (res.lob == 'LIFE') this.mapperTransactionState = res.lob + res.state;
        else this.mapperTransactionState = res.state;
      } else this.mapperTransactionState = res.state;

      this.proposalType = res.proposalType;
      this.productFamilyCd = res.lob;
      this.selectedProduct = res.product;
      this.productSpecificationList.push(this.selectedProduct);
      this.interactService.sendGenericData(this.productSpecificationList);
      console.log("selected product data", JSON.stringify(this.selectedProduct));
      console.log("transaction state for data entry 2", this.mapperTransactionState);
      const consoleStyle = 'color: green; padding: 2px 5px; border-radius: 2px';
      console.log(`CURRENT LOB IS - ${this.productFamilyCd}`, consoleStyle);
      

      if (!this.isEditWithConfig) {
        if (this.appMetadataHandler.featureFlags.enableAutoInitializeTransformDataPipe) {
          if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
            this.trasactionPageDataStateMap = this.dataTransformService.initializeTransactionPageDataStateMap(this.mapperTransactionState, this.configData);
            this.listOfAllChildren = this.dataTransformService.getListOfChildrenForCurrentState(this.mapperTransactionState, this.configData);
          }
          else {
            this.trasactionPageDataStateMap = this.initializeTransactionPageDataStateMap(this.mapperTransactionState, this.configData);
          }
        }
      } else {
        if (this.appMetadataHandler.featureFlags.enableAutoInitializeTransformDataPipe) {
          this.uiBuilderService.fetchUIConfigurationByGuid(this.configurationGuid).subscribe(resp => {
            this.configuration = resp ? resp['configuration'] : {};
            this.configuration = this.convertConditionalListToFieldRules(this.configuration)
            //this.configuration = this.commonUtilty.deepCopy(this.configuration1)
            this.configData['StateToChildComponentMapper'][this.mapperTransactionState] = [...this.configData['StateToChildComponentMapper'][this.mapperTransactionState], ...this.lookupDataService.customComponentsList];
            this.configData.GenericTransformComponentList.push(...this.reinitializeChildComponentsAndGenericTransformComponentsList(this.configuration)['genericTransformComponentList']);
            this.configData['StateToChildComponentMapper'][this.mapperTransactionState] = [...this.configData['StateToChildComponentMapper'][this.mapperTransactionState], ...this.reinitializeChildComponentsAndGenericTransformComponentsList(this.configuration)['childrenComponentEmitterList']];

            if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
              this.trasactionPageDataStateMap = this.dataTransformService.initializeTransactionPageDataStateMap(this.mapperTransactionState, this.configData);
              this.listOfAllChildren = this.dataTransformService.getListOfChildrenForCurrentState(this.mapperTransactionState, this.configData);
            }
            else {
              this.trasactionPageDataStateMap = this.initializeTransactionPageDataStateMap(this.mapperTransactionState, this.configData);
            }
          })
        }
      }
      // this.sendClientDataToClientStore(res);
      this.nullifyPayloadInEdit = 'start';
      this._intimationSourceCd = res.intimationSourceCd;
      if (res.IO && res.IO != undefined) {
        this.payloadInEdit = this.commonUtilty.deepCopy(res.IO);
        if (this.payloadInEdit && this.payloadInEdit['propertyDO'] && this.payloadInEdit['propertyDO'].length)
          this.payloadInEdit['propertyDO'] = this.payloadInEdit['propertyDO'].find(e => true)

          if (this.payloadInEdit && this.payloadInEdit['vehicleDO'] && this.payloadInEdit['vehicleDO'].length)
          this.payloadInEdit['vehicleDO'] = this.payloadInEdit['vehicleDO'].find(e => true)
        this.flattenedPayloadInEdit = this.commonUtilty.flattenObject(this.payloadInEdit);
        console.log('FLATTENEDPAYLOAD', this.flattenedPayloadInEdit);
        this.agentList = this.extractAgentDOList(res.IO);
        this.interactService.sendPolicyToPolicySummary(this.commonUtilty.getDO(this.payloadInEdit));
        // this.fetchCaseDataByGuid();
        this.autuUWRules = this.payloadInEdit['autoUwResults'];
        this.fetchCollaborations(this.payloadInEdit)
        this.interactService.sendClaimIOForDocumentManager(this.payloadInEdit);
      }
      if(!this.payloadInEdit || !this.payloadInEdit[this.currentDO] || !this.payloadInEdit[this.currentDO].uwDecisionCd || this.payloadInEdit[this.currentDO].uwDecisionCd == 'REFER'){
        this.showSaveSubmit = true;
      }
      this.tempJosn = res.IO;
      if (res.taskId)
        this.taskId = res.taskId;
      console.log("temp json ", this.tempJosn);
      if (!this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
        this.initializeChildSubscribers();
      }

      if (this.appMetadataHandler.featureFlags.enableUsageOfDataTransformService) {
        this.dataTransformService.initializeChildSubscribers(this.trasactionPageDataStateMap, this.mapperTransactionState).subscribe(responses => {
          if (responses)
            this._intimationTransformUItoServer(responses)
        })
      }

      if (res.IO != null)
      if(this.commonUtilty.isArrayIterable(res.IO['questionnaires'])){
        this.questionCdListFromQuestionnaire = this.getQuestionCdList(res.IO['questionnaires'])
        this.getListOfQuestionMasterCds(this.questionCdListFromQuestionnaire, res.IO)
      }
        this.checkTransactionStatus(res.IO) //  Custom Code for enabling UnderWriting Rules Tab for Counter Offer and Manula Underwriting Task, Diable Transaction UI for Counter Offer.
        this.transactionGuid = this._intimationTransformServerToUI(res.IO);
        if(this.mapperTransactionState == 'proposal_ManualUw'|| this.mapperTransactionState == 'LIFEproposal_ManualUw'
        || this.mapperTransactionState == 'MOTORproposal_ManualUw' || this.mapperTransactionState == 'PROPERTYproposal_ManualUw'
        ||this.mapperTransactionState == 'TRAVELproposal_ManualUw' || this.mapperTransactionState == 'REFERRALS'){
          this.appMetadataHandler.entityCd = 'CaseDO'
         }
         else{
          this.appMetadataHandler.entityCd = 'ProposalDO'
         }
        //  this.sendClientDataToClientStore(res);
      this.refreshReassingTaskList();

    });
    this.setDefaultStatePermissionVars();
    this.closeAllModel();
    // localStorage.setItem('FLATTENPAYLOAD', JSON.stringify(this.flattenedPayloadInEdit));
  }

  sendClientDataToClientStore(resp){
    let LOB = this.appMetadataHandler.currentLobState;  // TODO : fetch from config.
    let DO = this._getDOName(this.TransactionState);  // TODO : fetch from config.

    if(resp && Object.keys(resp.IO).length > 0){
      this.clientHandlingService.createClientRoleMap({...resp.IO}, DO, LOB);
      this.clientStore.dispatch(fetchClient({payload :{...this.clientHandlingService.clientRoleDataMap}}));
    }
  }


  disableDecisionTransaction = false
  checkTransactionStatus(IO){
    let DOName = this.commonUtilty.getDOName(IO)
    if(IO && IO[DOName] && IO[DOName].coResponseCd
      && (IO[DOName].coResponseCd == 'ACCEPT' || IO[DOName].coResponseCd == 'REJECT')
      && this.mapperTransactionState=='proposal_DataEntry' && this.mapperTransactionState == 'TRAVELproposal_DataEntry'
      && this.mapperTransactionState == 'MOTORproposal_DataEntry' && this.mapperTransactionState == 'PROPERTYproposal_DataEntry'
      && this.mapperTransactionState == 'LIFEproposal_DataEntry'){
      this.disableTransaction = true
    }
    else{
      this.disableTransaction = false;
    }
    if(this.userRole == 'UNDERWRITER'){
      this.disableDecisionTransaction = false
    }
    else{
      this.disableDecisionTransaction = true
    }
    if (!(this.userRole === 'UNDERWRITER') && IO && IO[DOName] && IO[DOName].statusCd === 'DECOMPLETE') {
      this.disableSaveSubmitButton = true;
    }else{
      this.disableSaveSubmitButton = false;
    }  
    if(IO && IO[DOName] && IO[DOName].statusCd && (IO[DOName].statusCd == 'CONOTACCEPTED' || IO[DOName].statusCd == 'ISSUED' || IO[DOName].statusCd == 'REJECTED') 
    && this.mapperTransactionState=='proposal_DataEntry'
    && this.mapperTransactionState=='MOTORproposal_DataEntry' && this.mapperTransactionState == 'TRAVELproposal_DataEntry'){
      this.enableUWTab = false;
      this.disableTransaction = true;
    }
    else if(IO && IO[DOName] && IO[DOName].stageCd && (IO[DOName].stageCd == 'PENDING_COUNTER_OFFER')){
      this.enableActionButton = true;
    }
    else if(this.mapperTransactionState=='proposal_ManualUw'|| this.mapperTransactionState == 'LIFEproposal_ManualUw'
        || this.mapperTransactionState == 'MOTORproposal_ManualUw' || this.mapperTransactionState == 'PROPERTYproposal_ManualUw'
        ||this.mapperTransactionState == 'TRAVELproposal_ManualUw'){
      this.enableUWTab = false
    }
    else if( IO[DOName].stageCd == 'ISSUED') this.enableUWTab = false;
    else{
      this.enableUWTab = false
    }
  }
  // getConfigDataAndInitialize() {
  //   // get configData from Assets
  //   this.apiRequestService.get(this.configPath, null, true).subscribe(response => {
  //     this.configData = this.commonUtilty.deepCopy(response);
  //     this.tabStates = this.commonUtilty.deepCopy(this.configData.tabStates)
  //     console.log("get config data checked: ", this.configData)
  //     this.intializeTransaction();
  //   })
  // }

   /*Loading config file locally */
  public getJSON(): Observable<any> {
    return this.http.get(this.configPath);
  }

  getConfigDataAndInitialize() {
    if (!this.configData) {
      if (environment.overRideHost) {
        /*Locally loading configuration json file */
        this.getJSON().subscribe(response => {
          this.tabStates = this.commonUtilty.deepCopy(response.tabStates)
          this.configData = this.commonUtilty.deepCopy(response);
          this.intializeTransaction();
        });
      } else {
        /*Loading json file from server */
        this.apiRequestService.get(this.configPath, null, !environment.getConfigPathWithContext).subscribe(response => {
          if (response)
            this.tabStates = this.commonUtilty.deepCopy(response.tabStates)
          this.configData = this.commonUtilty.deepCopy(response);
          this.intializeTransaction();
        })
      }
    } else {
      this.tabStates = this.commonUtilty.deepCopy(this.configData.tabStates)
      this.configData = this.commonUtilty.deepCopy(this.configData);
      this.intializeTransaction();
    }

  }

  extractAgentDOList(IO) {
    let output = [];
    let DO = this.commonUtilty.getDO(IO);
    if (IO && DO) {
      let agentDOs = IO['agentDOs']
      let clientDOs = IO['clientDOs']
      let agentList = DO.caseAgents || DO.proposalAgents;
      if (this.commonUtilty.isArrayIterable(agentList)) {
        agentList.forEach(transactionAgent => {
          transactionAgent['agentDO'] = agentDOs.find(agentClientDO => agentClientDO.agentNum == transactionAgent.agentNum)
          if (transactionAgent['agentDO'])
            transactionAgent['agentClientDO'] = clientDOs.find(clientDO => clientDO.guid == transactionAgent['agentDO'].clientRefGuid || clientDO.id == transactionAgent['agentDO'].clientId)
        })
        output = this.commonUtilty.deepCopy(agentList)
      }
    }
    return output
  }

  getRulesDescription(ruleName, name) {
    if (name == 'ruleName') {
      if (this.autoUwRuleCd && this.autoUwRuleCd.length) {
        let autoUwRuleCd = this.autoUwRuleCd.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return autoUwRuleCd.length ? autoUwRuleCd[0].lookupValue : '';
      }
    } else if (name == 'ruleSubType') {
      if (this.uwRuleSubType && this.uwRuleSubType.length) {
        let uwRuleSubType = this.uwRuleSubType.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return uwRuleSubType.length ? uwRuleSubType[0].lookupValue : '';
      }
    } else if (name == 'decisionType') {
      if (this.decisionTypeCd && this.decisionTypeCd.length) {
        let decisionTypeCd = this.decisionTypeCd.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return decisionTypeCd.length ? decisionTypeCd[0].lookupValue : '';
      }
    } else if (name == 'decision') {
      if (this.decisionCd && this.decisionCd.length) {
        let decisionCd = this.decisionCd.filter((item) => {
          if (item.lookupKey == ruleName) { return true; }
        })
        return decisionCd.length ? decisionCd[0].lookupValue : '';
      }
    }
  }

  private overlayObserver!: MutationObserver;
  ngAfterViewInit() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (!overlayContainer) return;
    this.overlayObserver = new MutationObserver(() => {
      const wrappers = overlayContainer.querySelectorAll('.cdk-global-overlay-wrapper');
      wrappers.forEach(wrapper => {
        if (wrapper.querySelector('.ant-message')) {
          (wrapper as HTMLElement).style.zIndex = '10000';
        }
      });
    });
  
    this.overlayObserver.observe(overlayContainer, { childList: true, subtree: true });
    this.initializeIntimationTabs();
  }

  


  // ngAfterViewChecked() {
  //   if (this.appMetadataHandler.featureFlags.enableDataEntryMode)
  //     if(this.enableZoom && !this.floatingImgViewerEnableZoom) {
  //       this.imageZoom("myimage", "myresult");
  //     }
  //     if(this.floatingImgViewerEnableZoom) {
  //       this.imageZoom("floatingmyimage", "floatingmyresult"); 
  //     }
  // }

  /* Variables */
  dataSet = [{}, {}];

  showConfirm(toStage: string): void {
    this.modalService.confirm({
      nzTitle: `<i>Are you sure you want to reverse to ${toStage}?</i>`,
      nzContent: '<b>This action cannot be undone!</b>',
      nzOkText: "Reverse",
      nzOnOk: () => console.log('OK')
    });
  }

  /* Police Station Details */
  hasPoliceStnDetails: boolean = true;

  /* Nominee Same as Claimant ? */
  // claimantSameAsNominee: boolean = true;
  private _claimantSameAsNominee: any;
  set claimantSameAsNominee(value: boolean) {

    if (value !== null) {
      this._claimantSameAsNominee = value;
    }
    else
      this._claimantSameAsNominee = false

    this.triggerClaimantSameAsNomineeChanges()
  }
  get claimantSameAsNominee(): boolean {
    return this._claimantSameAsNominee;
  }

  triggerClaimantSameAsNomineeChanges() {
    if (this._claimantSameAsNominee)
      this.setClaimantAsNominee()
    else
      this.claimantDataSet = [];
  }
  setClaimantAsNominee() {
    this.claimantDataSet = [];
    this.claimantDataSet = this.nomineeDataSet;
  }

  modalEvent$;
  closeAllModel() {
    if (this.modalEvent$ != null) this.modalEvent$.unsubscribe()
    this.modalEvent$ = this.interactService.closeModelSubject$.subscribe(res => {
      if (res) {
        this[res] = false;
      }
    })

  }

  editClientData: any
  editClient(modalFlagName, data) {
    this.editClientData = data
    console.log("edit client data in transaction", JSON.stringify(this.editClientData));
    this[modalFlagName] = true
  }

  /* PANELS */

  notesPanelOpen = false;
  notesPanel(status) { this.notesPanelOpen = !!status }

  policyPanelOpen = false;
  policyPanel(status) { this.policyPanelOpen = !!status }

  profilePanelOpen = false;
  profilePanel(status) { this.profilePanelOpen = !!status }

  corresPanelOpen = false;
  corresPanel(status) { this.corresPanelOpen = !!status }

  docuPanelOpen = false;
  docuPanel(status) { 
    this.docuPanelOpen = !!status 
    this.dataTransformService.docuPanelOpen = !!status;
  }

  documentManagerHandler(data) {
    this.docuPanel(data)
  }
  // draggableBoxes = [];
  policySummary(status) { 
    let policySummaryConfig = [
      { title: "Proposal Summary", width: "656px", height:"500px", minWidth: "500px", type: "policy-summary", open: false, minimized: true, zIndex: 10002, data: {id:10, desc:"Pass a data object"}  }
    ];
    // this.draggableBoxes.push(...policySummaryConfig)
    console.log("obj add after policy summary click: ", this.draggableBoxes)
   }
   
   medicalRiskHandler(status) {
    this.subscribeToPolicyList(); 
    let medicalRiskConfig = [
      { title: "Medical Risk", width: "656px", height:"500px", minWidth: "500px", type: "medical-risk", open: false, minimized: true, zIndex: 10002, data: {id:10, desc:"Pass a data object"}  }
    ];
    // this.draggableBoxes.push(...medicalRiskConfig)
   }

  PolicyList$
  policyData
  subscribeToPolicyList() {
    if (this.PolicyList$) this.PolicyList$.unsubscribe()
    this.PolicyList$ = this.interactService.policyListSubject$.subscribe(policies => {
      if (policies)
        this.policyData = this.commonUtilty.deepCopy(policies);
    })
  }

  worksheetPanelOpen = false;
  worksheetPanel(status) { this.worksheetPanelOpen = !!status }

  workflowPanelOpen = false;
  showDropdown = false;
  workflowPanel(status, showDropdown = false) {
    this.showDropdown = showDropdown;
    this.workflowPanelOpen = !!status;
  }

  pendingPanelOpen = false;
  pendingPanel(status) { this.pendingPanelOpen = !!status }

  /* Investigator modal */
  modInvtgVis: boolean = false;

  note: string = '';
  noteCannedReply(indx: number) {
    switch (indx) {
      case 0: this.note = 'Please have a look at the ';
        break;
      case 1: this.note = 'Requesting additional investigation for ';
        break;
      case 2: this.note = 'Required Documents are not in place. Kindly do a through verification for ';
        break;
    }

  }



  /* Star */
  isStarred: boolean = false;
  /* Demo case --- only "adding" is shown */
  starThis() {
    this.message.loading('Adding to starred items', { nzDuration: 1200 });
    setTimeout(() => {
      this.message.success('#P0000107 added to you starred items', { nzDuration: 1200 });
      this.isStarred = true;
    }, 1200);
  }


  /* Rich Text Editor */
  modalCorrespNew: boolean = false;
  openCorrModal() {
    this.modalCorrespNew = true;
    this.corresPanel(0); //Close corresp panel (z index error fix)
  }
  correspondenceRichText: any = `
  <h3>Information regarding your proposal #P0000107<h3>
  <p>Dear %policyholder_name%,</p>
  <br>
  <p>We request you to submit %document_name% for %insured_name% at your earliest convenience.</p>
  <p>This would help us process your proposal </p>
  <br>
  <p>Thank you,</p><br>
  <p>Team StandardLife</p>
  `;
  handleFileUpload(data) {
    console.log(data);
  }

  correspType: string = "email";
  modSubmit: boolean = false;

  defaultUploadsList: any = [
    {
      uid: 1,
      name: 'CERTI1.pdf',
      status: 'done',
      url: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456',
      thumbUrl: 'https://image.slidesharecdn.com/sampleprojectrequirementsdocument-libraryblog-120912084344-phpapp02/95/sample-project-requirements-document-library-blog-2-728.jpg?cb=1347439456'
    },
    {
      uid: 2,
      name: 'DOC45.pdf',
      status: 'done',
      url: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg',
      thumbUrl: 'https://images.template.net/wp-content/uploads/2016/03/28100800/project-process-documentation.jpg'
    }
  ];

  uploadArray = [{}];
  addUploadRow() {
    let objPush = {};
    this.uploadArray.push(objPush)
  }
  removeUploadRow() {
    this.uploadArray.pop();
  }


  /* Bank Details */
  bank: any = {};

  fetchFromIFSC() {
    this.bank = {};
    this.message.loading('Fetching Bank Details ...', { nzDuration: 1200 });
    setTimeout(() => {
      this.bank = {
        bankName: "ICICI BANK LTD.",
        bankBranchName: "MUMBAI - FORT",
        micr: "400229016",
        city: "MUMBAI",
        address: "NAVSARI BUILDING, 240, D.N.ROAD, FORT, MUMBAI. 400001"
      }
    }, 1200);
  }

  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [{
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };

  /* Event Type */
  // eventType: string = "Death";


  /* Search by Customer or Policy */
  searchCustOrPolicy: string = "customer";
  searchCustOrPolicyLoading: boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }
  searchAddCustomer = 'search-customer';
  modSearchCustOrPolicy: boolean = false;

  showCustomerPolicies: boolean = false;
  showCustomerPoliciesName: string = '';
  viewAddCustomersPolicies(namePassed) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = namePassed;
  }

  modSearchNominee: boolean = false;  
  modSearchAppointee: boolean = false;
  modSearchCustomerClaimant: boolean = false;

  searchPolicyClientOk() {
    this.modSearchCustOrPolicy = false
  }

  /* Modals for Hospital and Doctor */
  modHospDetails: boolean = false;
  modDocDetails: boolean = false;
  modRejectIntimation: boolean = false;


  /* ERRORS ==== */
  hasErrors: boolean = false;
  setErrorState(state: boolean) {
    if (state) {
      this.message.loading('Saving', { nzDuration: 1000 });
      setTimeout(() => {
        this.message.error('Form has errors. Please fix to continue', { nzDuration: 3000 });
        this.hasErrors = state;
        this.fakeValidationStatus = 'error';
      }, 1000);
    }
    else {
      this.hasErrors = state;
      this.fakeValidationStatus = null;
    }
  }
  /* Error Panel */
  errPanelOpen: boolean = false;
  errPanelCollapsed: boolean = false;
  errDetailsPanel(state) { this.errPanelOpen = !!state }
  errorPanelToggle() {
    //Expand/collapse visible error panel
    this.errPanelCollapsed = !this.errPanelCollapsed;
  }

  /* Jump To Tab, Highlight field */
  fakeValidationStatus: any = null;
  errJumpTo(tabIndex: number, fieldToHighlight: string) {
    /* Auto-close panel ?*/
    this.errPanelOpen = false;
    /* Process */
    setTimeout(() => {
      /* Switch Tab */
      this.selectedIndex = tabIndex;
    }, 250);
    setTimeout(() => {
      /* Focus on Field */
    }, 500);
  }

  intimationDummyRequest = null
  copySourceForPrimaryInsured: ClientList = { selectedClientData: [], fetchedClientData: [] }
  copySourceForPayer: ClientList = { selectedClientData: [], fetchedClientData: [] }
  updateClientList(data, clientType) {

    if (clientType === 'NOMINEE') {
      this.nomineeDataSet = data;
      this.interactService.sendNomineeListToBankDetails(data);
      // if (!this.nomineeClaimantFlag)
      //   this.claimantDataSet = data;
    }
    else
      this.copySourceForPrimaryInsured = data;
  }

  copySource = {}
  _EmittedClientHandler(data, targetRole?) {
    let targetInfo = data['targetInfo'];
    console.log("emiited client handler data", data);
    console.log("emiited client handler target role", targetInfo);
    if (data && targetInfo == 'PRIMARYINSURED') {
      this.copySourceForPrimaryInsured = data['clientList'];
      this.primaryInsuredDataSet = data['clientList'];
      this.refreshPrimaryInsuredTab();
    } else if (data && targetInfo == 'PAYER'){
      this.copySourceForPayer = data['clientList'];
      this.payerDataSet = data['clientList'];
      if(this._inputAllClientListComponent && this._inputAllClientListComponent[targetInfo] && data['clientList'] && data['clientList']['selectedClientData'] && data['clientList']['selectedClientData'][0]){
        this._inputAllClientListComponent[targetInfo] = this.commonUtilty.uniquePushInArray(this._inputAllClientListComponent[targetInfo],data['clientList']['selectedClientData'][0], 'guid');
      }
      this.refreshPayerTab();
    }
  }

  refreshPrimaryInsuredFlag: boolean = true;
  refreshPrimaryInsuredTab(){
    this.refreshPrimaryInsuredFlag = false;
    setTimeout(() => {
      this.refreshPrimaryInsuredFlag = true;
    }, 100);
  }
  
  refreshPayerFlag: boolean = true;
  refreshPayerTab(){
    this.refreshPayerFlag = false;
    setTimeout(() => {
      this.refreshPayerFlag = true;
    }, 100);
  }
  refreshPayerDetails: boolean = true;
  refreshPolicyHolderDetails(){
    this.refreshPayerDetails = false;
    setTimeout(() => {
      this.refreshPayerDetails = true;
    }, 100);
  }
  refreshFlag = true
  refreshClients() {
    this.refreshFlag = false
    setTimeout(() => {
      this.refreshFlag = true
    }, 100);
  }

  updatePolicyList(data) {
    if (data && data.length === 1)
      this.parentPolicyItem = data[0];
    else
      this.policyListFetchedFromServer = data
  }
  _inputAllClientListComponent
  updatePayerDetails(data, payerRole){
    this.ownerDataSet = data;
    if(this._inputAllClientListComponent){
      if(!this._inputAllClientListComponent[payerRole]){
        this._inputAllClientListComponent[payerRole] = data['clientList'] ? data['clientList']['fetchedClientData'] ? data['clientList']['fetchedClientData'] : [] : []
        this._inputAllClientListComponent['PAYER'] = data['clientList'] ? data['clientList']['selectedClientData'] ? data['clientList']['selectedClientData'] : [] : []
      }
      else{
        this._inputAllClientListComponent['PAYER'] = data['clientList'] ? data['clientList']['selectedClientData'] ? data['clientList']['selectedClientData'] : [] : []
      }
      data['clientList']['selectedClientData'].forEach((client,i) =>{
        if(client.remove && !client.isPayee) {
          this._inputAllClientListComponent['PAYER'].splice(i,1);
        }
        
      })
    }
    this.refreshPolicyHolderDetails() 
  }
  
  getNominee(data) {
    this.nomineeDataSet = data.componentData;
    this.closeNomineeModal();

  }

  getAppointee(data) {
    this.appointeeDataSet = data.componentData;
    // this.updateClientList(this.claimantDataSet,"Claimant");
    this.closeAppointeeModal();
  }

  closeAppointeeModal() {
    this.modSearchAppointee = false;
  }

  getOwner(data) {
    this.ownerDataSet = data.componentData;
    console.log("owner data set", JSON.stringify(this.ownerDataSet));
    this.closeOwnerModal();

  }

  closeOwnerModal() {
    this.modSearchCustomerOwner = false;
  }

  getInsured(data) {
    this.insuredDataSet = data.componentData;
    this.closeInsuredModal();

  }

  getPrimaryInsured(data) {
    this.primaryInsuredDataSet = data.componentData
    this.closePrimaryInsuredModal()
  }

  getAgent(data) {
    this.agentDataSet = data.componentData;
    console.log("agentDataSet", JSON.stringify(this.agentDataSet));
    // this.closeAgentModal()
  }

  closeInsuredModal() {
    this.modSearchCustomerInsured = false;
  }

  closePrimaryInsuredModal() {
    this.modSearchCustomerPrimaryInsured = false;
  }

  closeAgentModal() {
    this.modSearchAgent = false;
  }

  getMembers(data) {
    this.membersDataSet = data.componentData;
    this.closeMemberModal();

  }
  closeMemberModal() {
    this.modSearchCustomerMembers = false;
  }

  getPayer(data: { componentData: any; }) {
    if(data.componentData && data.componentData.fetchedClientData && this.commonUtilty.isArrayIterable(data.componentData.fetchedClientData) && data.componentData.fetchedClientData.length && data.componentData.fetchedClientData[0]) {
      this.payerDataSet['fetchedClientData'] = this.commonUtilty.uniquePushInArray(this.payerDataSet['fetchedClientData'], data.componentData.fetchedClientData[0] , 'guid')
    }
    if(data.componentData && data.componentData.selectedClientData && this.commonUtilty.isArrayIterable(data.componentData.selectedClientData) && data.componentData.selectedClientData.length && data.componentData.selectedClientData[0]){
      this.payerDataSet['selectedClientData'] = this.commonUtilty.uniquePushInArray(this.payerDataSet['selectedClientData'], data.componentData.selectedClientData[0] , 'guid')
      if(this._inputAllClientListComponent){
        this._inputAllClientListComponent['PAYER'] = this.payerDataSet['selectedClientData'] ? this.payerDataSet['selectedClientData'] : [] 
      }
    }
    // this.payerDataSet = data.componentData;
    if (this.payerDataSet && Array.isArray(this.payerDataSet.selectedClientData) && this.payerDataSet.selectedClientData.length > 0) {
      this.payerDataSet.selectedClientData.forEach((selectedCLient, index) => {
        this.commonUtilty.onChangeForPayer(selectedCLient, this.payerDataSet.fetchedClientData[index], true).subscribe((resp: any) => {
          this.interactService.sendPayeeListToBankDetails(resp)
        })
      })
    }
    this.refreshPayerTab();
    this.closePayerModal();

  }
  closePayerModal() {
    this.modSearchCustomerPayer = false;
  }

  getVehicle(data) {
    this.vehicleDataSet = data.componentData;
    this.closeVehicleModal();

  }
  closeVehicleModal() {
    this.modSearchCustomerVehicle = false;
  }

  getPolicyList(data) {

    if (data && data.length === 1)
      this.parentPolicyItem = data[0];
    else
      this.policyListFetchedFromServer = data

  }

  closeNomineeModal() {
    this.modSearchNominee = false;
  }

  getClaimant(data) {
    this.claimantDataSet = data.componentData;
    // this.updateClientList(this.claimantDataSet,"Claimant");
    this.closeClaimantModal();

  }

  closeClaimantModal() {
    this.modSearchCustomerClaimant = false;
  }

  pingChildToGetData() {
    this.interactService.pingChildToReact(this.route.routeConfig.component.name);
  }

  pingToClientSearchForNominee() {
    this.pingChildToGetData();
    this.modSearchCustomerClaimant = false;
  }

  pingToAgentSearchForData() {
    this.interactService.pingAgentSearch(true);
    this.modSearchAgent = false;
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {

      dateString = moment(rawDate).format('DD MMM YYYY');
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  removeNominee(data, list, uniqueID) {
    this.nomineeDataSet = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
  }

  removeClaimant(data, list, uniqueID, index) {
    this.claimantDataSet = this.commonUtilty.removeItemFromListUnSorted(data, list, uniqueID);
    this.interactService.removeClient('CLAIMANT', data, index, list)
  }

  pingToClientSearchForClaimant() {
    this.pingChildToGetData();
    this.modSearchNominee = false;
  }


  metaDataArray = [
    {
      "key": "policyNum",
      "description": "Policy Number",
      "isVisible": true
    },
    {
      "key": "clmIntimationNum",
      "description": "Claim Number",
      "isVisible": true
    },
    {
      "key": "commencementDt",
      "description": "Policy Commencement",
      "isVisible": true
    },
    {
      "key": "Insured",
      "description": "Insured Name",
      "isVisible": true,
    },
    {
      "key": "claimedAmt",
      "description": "Claimed Amount",
      "isVisible": true,
    },
    {
      "key": "MEMBERS",
      "description": "Members Name",
      "isVisible": true,
    }
  ];


  // for static data content
  permissions: any = [];
  showLastComment: boolean = false;
  modHospitalizationDetails: boolean = false;
  modSearchAddHosp: boolean = false;
  modSearchAddDoctor: boolean = false;
  tempBenefit1: string = `250000`;
  tempBenefit2: string = `20000`;
  tempBenefit3: string = `350000`;
  tempBenefitTotal: string = `150000`;

  /* Hospital Tabs: Hide/Show */
  tabHosp: any = "search-hosp";
  /* Doctor Tabs: Hide/Show */
  tabDoc: any = "search-doc";

  setDefaultStatePermissionVars() {
    this.permissions = {
      basic: { show: true, edit: true },
      insured: { show: true, edit: true },
      nominee_claimant: { show: true, edit: true },
      hospitalization: { show: true, edit: true },
      bank_details: { show: true, edit: true },
      benefit: { show: true, edit: true },
      payment_breakup: { show: true, edit: true },
      payout_details: { show: true, edit: true },
      adj_claim_decision: { show: true, edit: true },
      investigation_report: { show: true, edit: true },
      other_policies: { show: true, edit: true },
      analytics: { show: true, edit: true },
    };
    /* Set other defaults */
    this.showLastComment = true;
  }

  reffrelUserType: any = null;
  modalTitle: any = null;
  // referOrSubmitMode(roleUserType) {
  //   if (roleUserType == 'INVESTIGATOR') {
  //     this.modalTitle = "Assign Investigator"
  //   } else {
  //     this.modalTitle = "Refer Task"

  //   }
  //   this.reffrelUserType = roleUserType
  //   this.interactService.referToRoleUserType(roleUserType)
  //   this.modInvtgVis = true;

  // }
  refertoUser() {
    if (this.taskId && this.assigneeUser) {
      this.interactService.referToRoleUserType$.pipe(take(1))
        .subscribe(o => {
          let value = this.ReferMap[o]
          let DOName = this._getDOName(this.mapperTransactionState)
          let taskIO: TaskIO = new TaskIO()
          taskIO.assignedto = this.assigneeUser
          taskIO.taskCd = value;
          taskIO.objectName = 'ClaimDO'
          taskIO.entityGuid = this.payloadInEdit[DOName].guid
          this.workqueueService.createTask(taskIO).subscribe(resp => {
            this.modInvtgVis = false;

          });
        })

    }
  }

  ReferMap = {
    INVESTIGATOR: "claimInvestigtion",
    UNDERWRITER: "claimUWReferral",
    REINSURER: "claimReinsReferral",
  }
  //For Refer Modal


  /* Rules */
  //rulesData = rulesDataObj;


  fetchProducts(productFamilyCd) {
    this.workqueueService.fetchProducts(productFamilyCd)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              this.productData.push(criteria);
            } else {
              this.productData = [];
            }

            // let searchCriteriaDO = new SearchAPIMetaDataDO();
            // searchCriteriaDO.key = criteria.attributeName;
            // searchCriteriaDO.keyDescription = criteria.description;
            // searchCriteriaDO.valueInputType = criteria.attributeDataTypeCd;
            // searchCriteriaDO.lookupName = criteria.attr.ibuteLookupCd;
            // searchCriteriaDO.lookup = [];
            // searchCriteriaDO.enable = true;
            // searchCriteriaDO.isMandatory = criteria.mandatoryFl == 'YES' ? true : false;
            // this.CRITERIALOOKUP.push(searchCriteriaDO)
          })

          if (this.tempJosn) {
            let DO = this._getDOName(this.TransactionState)
            let selectedProductData = this.productData.filter(item => item.productId === this.payloadInEdit[DO].baseProductCd)
            console.log("selected product data", JSON.stringify(selectedProductData));
            this.productSpecificationList = selectedProductData
            this.interactService.sendGenericData(this.productSpecificationList);
          }
        }
        console.log("product data when fetching from API", JSON.stringify(this.productData));
      })
  }

  autuUWRules = [];
  fetchCaseDataByGuid() {
    if (this.payloadInEdit && this.payloadInEdit['caseDO']) {
      let guid = this.payloadInEdit['caseDO'].guid;
      this.policyService.getCaseByGuid(guid).subscribe(response => {
        console.log("case response", JSON.stringify(response));
        if (response)
          this.autuUWRules = response.autoUwResults;
      })
    }
  }

  setMainProductData(payload, response, DO, coverageNodeName) {
    let clientGuid = null;
    let clientId = null;
    let PolicyClientNode = this.configData.StateToClientRolesNodeMapper[this.mapperTransactionState];
    if (payload && payload[DO]) {
      let policyClient = payload[DO][PolicyClientNode].find(item => item.roleCd === 'PRIMARYINSURED')
      clientGuid = policyClient.clientRefGuid;
      clientId = policyClient.clientId;
    }

    let basePlanCoverageObj = new ProposalCoverageDO();
    basePlanCoverageObj.planTypeCd = 'BASEPLAN';
    basePlanCoverageObj.guid = new GuidGenerator().setGuid();
    basePlanCoverageObj.productCd = response['BasePlanComponent'].productCd;
    basePlanCoverageObj.sumInsuredAmt = response['BasePlanComponent'].value.sumInsuredAmt;
    basePlanCoverageObj.planOptionCd = response['BasePlanComponent'].value.planTypeCd;
    // basePlanCoverageObj.associationType = response['BasePlanComponent'].value.packageType;
    basePlanCoverageObj.policyTerm = response['BasePlanComponent'].value.policyTerm;
    let coveragesInsuredDO = new ProposalCoverageInsuredDO();
    coveragesInsuredDO.clientRefGuid = clientGuid;
    // coveragesInsuredDO.clientId = clientId;
    coveragesInsuredDO.roleCd = "PRIMARYINSURED";

    basePlanCoverageObj.proposalCoverageInsureds.push(coveragesInsuredDO);

    if (Array.isArray(basePlanCoverageObj.proposalCoverageSchedules)) {
      if (response.componentData.value.term === basePlanCoverageObj.proposalCoverageSchedules.length) {
        // do nothing
      } else {
        basePlanCoverageObj.proposalCoverageSchedules = [];
        let policyTerm = response.componentData.value.term;
        for (let i = 0; i < policyTerm; i++) {
          let policyCoverageSchedule = new ProposalCoverageScheduleDO();
          policyCoverageSchedule.productTypeCd = basePlanCoverageObj.productCd;
          policyCoverageSchedule.proposalYear = i + 1;

          basePlanCoverageObj.proposalCoverageSchedules.push(policyCoverageSchedule);
        }
      }
    }

    payload[DO][coverageNodeName].push(basePlanCoverageObj);

    let premiumBreakup = new ProposalPremiumBreakupDO();
    payload[DO]['premiumBreakupList'].push(premiumBreakup);

    return payload;
  }

  checkIfMainProductExists(payload) {
    let mainProductFound = false;
    let DO = this._getDOName(this.TransactionState)
    let coverageNodeName = this.configData.CoverageNodeMapper[this.TransactionState]
    if (payload && payload[DO]) {
      if (payload[DO][coverageNodeName] && payload[DO][coverageNodeName].length && payload[DO][coverageNodeName].length > 0) {
        payload[DO][coverageNodeName].forEach(coverObj => {
          if (coverObj.planTypeCd === 'BASEPLAN')
            mainProductFound = true;
        });
      }
    }
    return mainProductFound;
  }

  getMandatoryCoverages(list) {
    this.mandatoryCoveragesList = [];
    if (this.commonUtilty.isArrayIterable(list))
      this.mandatoryCoveragesList = this.commonUtilty.deepCopy(list);
  }

  setMandatoryCoverages(payload) {
    let CoveragesNode = this.configData.CoverageNodeMapper[this.mapperTransactionState];
    let CoveragesInsuredNode = this.configData.CoverageInsuredNodeMapper[this.mapperTransactionState];
    let DO = this._getDOName(this.TransactionState)
    if (this.commonUtilty.isArrayIterable(this.mandatoryCoveragesList)) {
      this.mandatoryCoveragesList.forEach(coverage => {
        let coverageDO = new ProposalCoverageDO();
        coverageDO.productCd = coverage.riderCd;
        let riderAttribute = coverage.productRiderAttributelist && coverage.productRiderAttributelist.length > 0 ? coverage.productRiderAttributelist.find(item => item.vocabularyCd == 'SumInsured') : null;
        if (riderAttribute) {
          coverageDO.sumInsuredAmt = riderAttribute.configuredValue;
        }
        coverage.planTypeCd = 'RIDER';
        if (this.commonUtilty.isArrayIterable(this.customHookService.insuredList)) {
          this.customHookService.insuredList.forEach(insured => {
            let coverageInsured = new ProposalCoverageInsuredDO();
            coverageInsured.clientRefGuid = insured.clientDO.guid;
            // coverageInsured.clientId = insured.clientDO.id;
            coverageInsured.roleCd = "INSURED";
            coverageDO[CoveragesInsuredNode].push(coverageInsured);
          })
        }
        payload[DO][CoveragesNode] = this.commonUtilty.uniquePushInArray(payload[DO][CoveragesNode], coverageDO, 'productCd');
      })
    }

    return payload;
  }

  emittedComponentData = {}
  manageInsuredAndCoveragesDecisions(policyDecision) {
    this.givenPolicyDecision = policyDecision;
    this.refreshCoveragesDecision = false;
    setTimeout(() => {
      this.refreshCoveragesDecision = true;
    }, 300);
  }

/* ================ Draggable Boxes ================ */
  /* IMP NOTE: this is a barebone implementation of UppModal;
     For full-fledged production use, you must put these boxes globally (app-level) and
     **** open/add/remove modals using a service and data subscription !! ****
  */
     draggableBoxes = [
      // { title: "Worksheet Preview", width: "860px", height:"500px", minWidth: "500px", type: "worksheet-preview", open: false, minimized: true, zIndex: 10000, data: {id:10, desc:"Pass a data object"} },
      // { title: "PDF Preview", width: "656px", height:"500px", minWidth: "500px", type: "pdf-preview", open: false, minimized: true, zIndex: 10002, data: {id:10, desc:"Pass a data object"}  },
       { title: "Proposal Summary", width: "656px", height:"500px", minWidth: "500px", type: "policy-summary", open: false, minimized: true, isVisible : false, zIndex: 10002, data: {id:10, desc:"Pass a data object"} },
       { title: "Paper Application", width: "700px", height:"700px", minWidth: "500px", type: "split-screen", open: false, minimized: true, isVisible : false, zIndex: 10002, data: {id:11, desc:"Pass a data object"}  }
    ];
    /* Draggable Boxes - Functions */
    bringDraggableBoxToTop(i:number, highest=0) {
      this.draggableBoxes.forEach(i=>{if(highest<i.zIndex) highest=i.zIndex;});
      if(this.draggableBoxes[i].zIndex<highest) this.draggableBoxes[i].zIndex = highest + 1;
    }
    deleteBox(i) {
      this.draggableBoxes[i].open = false; this.draggableBoxes[i].minimized = true; // close it first
      this.draggableBoxes.splice(i,1); // delete
      // this.makeBoxesDraggable(); // re-init() drags (Required for jQuery version alone)
    }

    floatingPreviewScreen = false;
    splitScreenBoxes = [
      // { title: "Worksheet Preview", width: "860px", height:"500px", minWidth: "500px", type: "worksheet-preview", open: false, minimized: true, zIndex: 10000, data: {id:10, desc:"Pass a data object"} },
      // { title: "PDF Preview", width: "656px", height:"500px", minWidth: "500px", type: "pdf-preview", open: false, minimized: true, zIndex: 10002, data: {id:10, desc:"Pass a data object"}  },
       { title: "Paper Application Viewer", width: "960px", height:"500px", minWidth: "500px", type: "split-screen", open: false, minimized: true, zIndex: 10002, data: {id:11, desc:"Pass a data object"}  }
    ];

    setSplitScreenFloating(i:number, highest=0) {
      this.splitScreenBoxes.forEach(i=>{if(highest<i.zIndex) highest=i.zIndex;});
      if(this.splitScreenBoxes[i].zIndex<highest) this.splitScreenBoxes[i].zIndex = highest + 1;
    }   

    closeSplitMode(box) {
      box.minimized = true;
      box.open = false;
      if (box.type == 'split-screen') {
        this.dataTransformService.isSidebarCollapsed = false
        this.dataTransformService.enableFloatingSplitScreen = true;
        this.enableZoom = false
      }
    }

    enableSplitScreen() {
      this.dataTransformService.isSidebarCollapsed = true
      this.dataTransformService.enableFloatingSplitScreen = false;
      this.enableZoom = true
      this.floatingPreviewScreen = false;
    }
   
    /* ================ END Draggable Boxes ================ */


    saveEvent(){
      
      this.currentAllComponentData
     /* this.store.dispatch(
        {
          type:"savePolicy",
          payload:this.currentAllComponentData
        }
      )*/
       this.store.dispatch(customSavePolicy({payload :{...this.currentAllComponentData}}))
    }

    get tabsets() {
      if(this.configuration && this.commonUtilty.isArrayIterable(this.configuration['configurations'])){
        return this.configuration['configurations'].find(e => e.type == 'tabset').sections
      }
      return [];
    }

    fetchUIConfiguration(){ // a76936e6-57fc-48fc-93fa-0e138ca44a4a //  f981369f-dad9-4c87-b763-b65439801f20 //1e657fad-4e69-4c92-83c9-d4818ae3802e 37a01b95-9cdd-402b-8616-0df42027d110

      this.uiBuilderService.fetchUIConfigurationByGuid('37a01b95-9cdd-402b-8616-0df42027d110').subscribe(resp =>{ 
        this.configuration = resp ? resp['configuration'] : {};
        this.configuration = this.convertConditionalListToFieldRules(this.configuration)
          //this.configuration = this.commonUtilty.deepCopy(this.configuration1)
          this.configData.GenericTransformComponentList.push(...this.reinitializeChildComponentsAndGenericTransformComponentsList(this.configuration)['genericTransformComponentList']);
      })
    }

    // this method will initialize children emitters, generic transform list if this.isEditWithConfig is true
    reinitializeChildComponentsAndGenericTransformComponentsList(configMetaData){
      let tempGenericCompList = [];
      let childrenComponentEmitterList = []
      if(configMetaData && this.commonUtilty.isArrayIterable(configMetaData.configurations)){
        let tabSections = configMetaData.configurations.find(e => e.type == 'tabset').sections;
        if(this.commonUtilty.isArrayIterable(tabSections)){
          tabSections.forEach(tab => {
            if(tab && this.commonUtilty.isArrayIterable(tab.sections)){
              tab.sections.forEach(tabSection => {
                tempGenericCompList.push(tabSection.controlId);
                if(tabSection.type=='custom-component') {
                  // let component = this.lookupDataService.customComponentsList.find(comp=>comp.lookupKey==tabSection.heading);
                  childrenComponentEmitterList.push(tabSection.heading);
                }
              });
            }
          });
        }
      }
      return { genericTransformComponentList: tempGenericCompList, childrenComponentEmitterList: childrenComponentEmitterList};
    }

  convertConditionalListToFieldRules(configuration) {
    if (configuration && this.commonUtilty.isArrayIterable(configuration.configurations)) {
      let tabSections = configuration.configurations.find(e => e.type == 'tabset').sections;
      configuration.configurations.forEach((config, configIndex) => {
        if (config.type == 'tabset' && this.commonUtilty.isArrayIterable(config.sections)) {
          config.sections.forEach((section, sectionIndex) => {

            if (this.commonUtilty.isArrayIterable(section.sections)) {
              section.sections.forEach((element, index) => {
                if (this.commonUtilty.isArrayIterable(element.formItems)) {
                  element.formItems.forEach((formItem, formItemIndex) => {

                    if (this.commonUtilty.isArrayIterable(formItem.conditionalList)) {

                      let UiConditionDO = formItem.conditionalList.map(item => {
                        let fieldRuleDO: any = {}
                        fieldRuleDO.sourceFieldGenericMapping = "baseDO-" + item.fieldKey.split("-").pop(),
                          fieldRuleDO.sourceField = item.fieldKey,
                          fieldRuleDO.targetAttribute = "hidden",
                          fieldRuleDO.expression = {
                            operation: item.condition,
                            expectedValueOf: null,
                            data: this.commonUtilty.convertCSVToArray(item.valueForParameter)
                          },
                          fieldRuleDO.result = null
                        return fieldRuleDO
                      });
                       configuration.configurations[configIndex].sections[sectionIndex].sections[index].formItems[formItemIndex]['fieldRules'] = UiConditionDO
                    }

                  });
                }

              });
            }
          });
        }
      });
    }
    return configuration;
  }

    refreshComponentToggle:boolean = true;
    currentAllComponentData = {};

    configuration={}
    configuration1:any = {
      "entity": "ProposalDO",
      "configurations": [
          {
              "guid": "4b9e0ff9-1340-4340-a04d-8550f5007972",
              "createdDt": 1676010976187,
              "updatedDt": 1676030248538,
              "createdUser": "kewal@metamorphtech.com",
              "updatedUser": "kewal@metamorphtech.com",
              "baseCompanyCd": "MMS",
              "versionNum": 2,
              "type": "ribbon",
              "id": 199,
              "objectName": "UIConfigurationDO"
          },
          {
              "guid": "73e90a63-33dd-4f6f-bbc6-9096e72c2adf",
              "createdDt": 1676010976190,
              "updatedDt": 1676030248538,
              "createdUser": "kewal@metamorphtech.com",
              "updatedUser": "kewal@metamorphtech.com",
              "baseCompanyCd": "MMS",
              "versionNum": 2,
              "type": "tabset",
              "id": 200,
              "tabPosition": "top",
              "size": "medium",
              "sections": [
                  {
                      "guid": "15cc283e-57ce-4602-b3e3-50c45af5555e",
                      "createdDt": 1676010976190,
                      "updatedDt": 1676030248538,
                      "createdUser": "kewal@metamorphtech.com",
                      "updatedUser": "kewal@metamorphtech.com",
                      "baseCompanyCd": "MMS",
                      "versionNum": 2,
                      "controlId": "basicDetails",
                      "type": "tab",
                      "name": "Basic Details",
                      "icon": "file",
                      "disabled": false,
                      "sortOrder": 1,
                      "id": 119,
                      "sections": [
                          {
                              "guid": "a91900b3-d08d-44db-a445-5e7dc1dea7f3",
                              "createdDt": 1676010976193,
                              "updatedDt": 1676030248538,
                              "createdUser": "kewal@metamorphtech.com",
                              "updatedUser": "kewal@metamorphtech.com",
                              "baseCompanyCd": "MMS",
                              "versionNum": 2,
                              "controlId": "form-BasicDetails",
                              "type": "form",
                              "icon": "file",
                              "disabled": false,
                              "sortOrder": 1,
                              "heading": "Basic Details",
                              "gridClass": "grid-4x",
                              "id": 160,
                              "formItems": [
                                {
                                  "guid": "45c3c7c9-c8e5-4885-a0af-d8a7bd556cde",
                                  "createdDt": 1675840945158,
                                  "updatedDt": 1676014094938,
                                  "createdUser": "kewal@metamorphtech.com",
                                  "updatedUser": "kewal@metamorphtech.com",
                                  "baseCompanyCd": "MMS",
                                  "versionNum": 10,
                                  "controlId": "field-ProductPlanOptionCdPolicy-4575",
                                  "hidden": false,
                                  "disabled": false,
                                  "fieldName": "Product Plan Option Code Policy",
                                  "fieldKey": "productPlanOptionCd",
                                  "fieldType": "COMBO",
                                  "lookupCd": "productOptionCd",
                                  "fieldMapping": "proposalDO-productPlanOptionCd",
                                  "fieldGenericMapping": "baseDO-productPlanOptionCd",
                                  "vocabularyCd": "ProductPlanOptionCdPolicy",
                                  "extractElementFromArray": false,
                                  "entityCd": "ProposalDO",
                                  "id": 380,
                                  "errors": [
                                    {
                                      "guid": "9a1d4501-e9d2-435a-a30c-0b4a25c025e7",
                                      "createdDt": 1676014094931,
                                      "updatedDt": 1676014094931,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 0,
                                      "id": 1061,
                                      "vocabularyCd": "ProductPlanOptionCdPolicy",
                                      "error": "UI-Metadata is empty for vocabulary code = [ProductPlanOptionCdPolicy].",
                                      "objectName": "UIConfigErrorDO"
                                    }
                                  ],
                                  "objectName": "UIFormItemsDO"
                                },
                                {
                                  "guid": "d2dbc282-f37f-4001-b595-6bd1ae3e743e",
                                  "createdDt": 1675932404802,
                                  "updatedDt": 1676014094938,
                                  "createdUser": "kewal@metamorphtech.com",
                                  "updatedUser": "kewal@metamorphtech.com",
                                  "baseCompanyCd": "MMS",
                                  "versionNum": 3,
                                  "controlId": "field-SumInsuredPolicy-5184",
                                  "hidden": false,
                                  "disabled": false,
                                  "fieldName": "Sum Insured Policy",
                                  "fieldKey": "sumInsured",
                                  "fieldType": "NUMBERINPUT",
                                  "fieldMapping": "proposalDO-sumInsured",
                                  "fieldGenericMapping": "baseDO-sumInsured",
                                  "vocabularyCd": "SumInsuredPolicy",
                                  "extractElementFromArray": false,
                                  "entityCd": "ProposalDO",
                                  "id": 393,
                                  "errors": [
                                    {
                                      "guid": "dc6abe84-7db1-4262-981a-9074c3b8c2f0",
                                      "createdDt": 1676014094932,
                                      "updatedDt": 1676014094932,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 0,
                                      "id": 1062,
                                      "vocabularyCd": "SumInsuredPolicy",
                                      "error": "UI-Metadata is empty for vocabulary code = [SumInsuredPolicy].",
                                      "objectName": "UIConfigErrorDO"
                                    }
                                  ],
                                  "fieldRules": [{ 
                                    "sourceFieldGenericMapping": "baseDO-productPlanOptionCd",
                                    "sourceField": "proposalDO-productPlanOptionCd",
                                    "targetAttribute": "hidden", 
                                    "expression": {
                                      "operation": "==", 
                                      "expectedValueOf": null,
                                      "data": ["PLATINUM", "platinum"]
                                    },
                                    "result": null,
                                    "controlId": "field-SumInsuredPolicy-5184",
                                    "valueForParameter": "BASEPLAN,baseplan"
                                  }],
                                  "objectName": "UIFormItemsDO"
                                }
                              ],
                              "objectName": "UITabSectionsDO"
                          },
                          {
                              "guid": "1613bf95-03b8-4d72-9da3-864881dc7eca",
                              "createdDt": 1676010976201,
                              "updatedDt": 1676030248538,
                              "createdUser": "kewal@metamorphtech.com",
                              "updatedUser": "kewal@metamorphtech.com",
                              "baseCompanyCd": "MMS",
                              "versionNum": 2,
                              "controlId": "editable-grid-facilities",
                              "type": "editable-grid",
                              "icon": "table",
                              "disabled": false,
                              "sortOrder": 0,
                              "heading": "Coverage List",
                              "gridClass": "grid-4x",
                              "fieldKey": "proposalCoverages",
                              "fieldMapping": "proposalDO-proposalCoverages",
                              "id": 161,
                              "entityFetchBy": "guid",
                              "entityFetchURL": "/fetch/hospital/serviceDetails/",
                              "enableAddRemoveRows": "true",
                              "columns": [
                                  {
                                      "guid": "f0abcf70-2859-4d83-978a-1d17ca6b68dc",
                                      "createdDt": 1676010976202,
                                      "updatedDt": 1676030248539,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 2,
                                      "controlId": "editable-grid-facilities",
                                      "icon": "file",
                                      "disabled": false,
                                      "sortOrder": 0,
                                      "fieldName": "Id",
                                      "fieldKey": "id",
                                      "fieldType": "INPUT",
                                      "id": 239,
                                      "columnVisibility": false,
                                      "objectName": "UIGridColumnsDO",
                                      "allowSort": false,
                                      "allowFilter": false
                                  },
                                  {
                                      "guid": "6b4cb0f5-e32d-4bc5-a414-4c94196fd851",
                                      "createdDt": 1676010976205,
                                      "updatedDt": 1676030248539,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 2,
                                      "controlId": "editable-grid-facilities",
                                      "icon": "file",
                                      "disabled": false,
                                      "sortOrder": 1,
                                      "fieldName": "GUID",
                                      "fieldKey": "guid",
                                      "fieldType": "INPUT",
                                      "id": 240,
                                      "columnVisibility": false,
                                      "objectName": "UIGridColumnsDO"
                                  },
                                  {
                                      "guid": "f0abcf70-2859-4d83-978a-1d17ca6b68dc",
                                      "createdDt": 1676010976202,
                                      "updatedDt": 1676030248539,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 2,
                                      "controlId": "editable-grid-facilities",
                                      "icon": "file",
                                      "disabled": false,
                                      "sortOrder": 0,
                                      "fieldName": "Selected",
                                      "fieldKey": "selected",
                                      "fieldType": "CHECKBOX",
                                      "selectAll": true,
                                      "id": 239,
                                      "columnVisibility": true,
                                      "objectName": "UIGridColumnsDO",
                                      "allowSort": false,
                                      "allowFilter": false,
                                      "columnWidth": "100px"
                                  },
                                  {
                                      "guid": "9a9df150-2fc6-4c2b-b837-3897b55cc15a",
                                      "createdDt": 1676010976206,
                                      "updatedDt": 1676030248539,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 2,
                                      "controlId": "editable-grid-facilities",
                                      "icon": "file",
                                      "disabled": false,
                                      "sortOrder": 2,
                                      "fieldName": "Association Type",
                                      "fieldKey": "associationType",
                                      "fieldType": "INPUT",
                                      "id": 241,
                                      "columnVisibility": true,
                                      "objectName": "UIGridColumnsDO",
                                      "allowSort": true,
                                      "allowFilter": true,
                                      "length": 60,
                                      "min": 10,
                                      "max": 30
                                  },
                                  {
                                      "guid": "65c66507-58f4-469f-a3a6-3cc5c5565fab",
                                      "createdDt": 1676010976207,
                                      "updatedDt": 1676030248539,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 2,
                                      "controlId": "editable-grid-facilities",
                                      "icon": "file",
                                      "disabled": false,
                                      "sortOrder": 3,
                                      "fieldName": "Plan Type",
                                      "fieldKey": "planTypeCd",
                                      "fieldType": "COMBO",
                                      "lookupCd": "productPlanType",
                                      "id": 242,
                                      "columnVisibility": true,
                                      "objectName": "UIGridColumnsDO",
                                      "allowSort": true,
                                      "allowFilter": true,
                                      "length": 200
                                  }
                              ],
                              "sections": [
                                  {
                                      "guid": "cebbdea3-c29e-40e0-a9da-1c3c9baadc59",
                                      "createdDt": 1676010976208,
                                      "updatedDt": 1676030248538,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 2,
                                      "controlId": "editable-grid-facilities-nested",
                                      "type": "editable-grid",
                                      "icon": "table",
                                      "disabled": false,
                                      "sortOrder": 0,
                                      "heading": "Sub-Facilities: Nested Table",
                                      "gridClass": "grid-4x",
                                      "fieldKey": "serviceDetails",
                                      "fieldMapping": "providerDO-hospital-hospitalInfrastructure-serviceDetails",
                                      "id": 162,
                                      "entityFetchBy": "guid",
                                      "entityFetchURL": "/fetch/hospital/serviceDetails/",
                                      "enableAddRemoveRows": "true",
                                      "columns": [
                                          {
                                              "guid": "8d5e6ffb-a6bf-4885-a55d-630066b84b1c",
                                              "createdDt": 1676010976209,
                                              "updatedDt": 1676030248538,
                                              "createdUser": "kewal@metamorphtech.com",
                                              "updatedUser": "kewal@metamorphtech.com",
                                              "baseCompanyCd": "MMS",
                                              "versionNum": 2,
                                              "controlId": "editable-grid-facilities",
                                              "icon": "file",
                                              "disabled": false,
                                              "sortOrder": 0,
                                              "fieldName": "Sub-Facilities ID",
                                              "fieldKey": "id",
                                              "fieldType": "INPUT",
                                              "id": 243,
                                              "columnVisibility": true,
                                              "objectName": "UIGridColumnsDO"
                                          },
                                          {
                                              "guid": "4b9451d5-d3d5-4f1a-8523-364f609368ad",
                                              "createdDt": 1676010976210,
                                              "updatedDt": 1676030248538,
                                              "createdUser": "kewal@metamorphtech.com",
                                              "updatedUser": "kewal@metamorphtech.com",
                                              "baseCompanyCd": "MMS",
                                              "versionNum": 2,
                                              "controlId": "editable-grid-facilities",
                                              "icon": "file",
                                              "disabled": false,
                                              "sortOrder": 1,
                                              "fieldName": "GUID",
                                              "fieldKey": "guid",
                                              "fieldType": "INPUT",
                                              "id": 244,
                                              "columnVisibility": true,
                                              "objectName": "UIGridColumnsDO"
                                          },
                                          {
                                              "guid": "a3d3bc25-c135-4036-ae6c-4c1c1bb63c8b",
                                              "createdDt": 1676010976210,
                                              "updatedDt": 1676030248538,
                                              "createdUser": "kewal@metamorphtech.com",
                                              "updatedUser": "kewal@metamorphtech.com",
                                              "baseCompanyCd": "MMS",
                                              "versionNum": 2,
                                              "controlId": "editable-grid-facilities",
                                              "icon": "file",
                                              "disabled": false,
                                              "sortOrder": 4,
                                              "fieldName": "Person In-charge",
                                              "fieldKey": "hod",
                                              "fieldType": "INPUT",
                                              "id": 245,
                                              "columnVisibility": true,
                                              "objectName": "UIGridColumnsDO"
                                          },
                                          {
                                              "guid": "5680366c-b6be-4227-a6a7-93f77ee8156d",
                                              "createdDt": 1676010976211,
                                              "updatedDt": 1676030248538,
                                              "createdUser": "kewal@metamorphtech.com",
                                              "updatedUser": "kewal@metamorphtech.com",
                                              "baseCompanyCd": "MMS",
                                              "versionNum": 2,
                                              "controlId": "editable-grid-facilities",
                                              "icon": "file",
                                              "disabled": false,
                                              "sortOrder": 3,
                                              "fieldName": "Type",
                                              "fieldKey": "serviceTypeCd",
                                              "fieldType": "COMBO",
                                              "lookupCd": "infraServiceTypeCd",
                                              "id": 246,
                                              "columnVisibility": true,
                                              "objectName": "UIGridColumnsDO"
                                          },
                                          {
                                              "guid": "878b1886-9453-4bbc-b6be-a5230ec9bb76",
                                              "createdDt": 1676010976212,
                                              "updatedDt": 1676030248538,
                                              "createdUser": "kewal@metamorphtech.com",
                                              "updatedUser": "kewal@metamorphtech.com",
                                              "baseCompanyCd": "MMS",
                                              "versionNum": 2,
                                              "controlId": "editable-grid-facilities",
                                              "icon": "file",
                                              "disabled": false,
                                              "sortOrder": 2,
                                              "fieldName": "Category",
                                              "fieldKey": "serviceCategoryCd",
                                              "fieldType": "COMBO",
                                              "lookupCd": "infraServiceCategoryCd",
                                              "id": 247,
                                              "columnVisibility": true,
                                              "objectName": "UIGridColumnsDO"
                                          }
                                      ],
                                      "objectName": "UITabSectionsDO"
                                  }
                              ],
                              "errors": [
                                  {
                                      "guid": "7935b216-26d4-4635-9d47-b8263c469cff",
                                      "createdDt": 1676030248537,
                                      "updatedDt": 1676030248537,
                                      "createdUser": "kewal@metamorphtech.com",
                                      "updatedUser": "kewal@metamorphtech.com",
                                      "baseCompanyCd": "MMS",
                                      "versionNum": 0,
                                      "id": 1073,
                                      "error": "Error occurred while loading vocabulary for code = [null]. Error is = [Vocabulary = null not found for company cd = MMS].",
                                      "objectName": "UIConfigErrorDO"
                                  }
                              ],
                              "objectName": "UITabSectionsDO",
                              "rowSelectable": "SINGLE",
                              "paginationPosition": "both",
                              "readOnly": false,
                              "allowPagination": true,
                              "showRecordPerPageOption": true
                          }
                      ],
                      "objectName": "UITabElementDO"
                  }
              ],
              "objectName": "UIConfigurationDO"
          },
          {
              "guid": "322f2c71-11ed-41ca-9a92-428ec45ad0b9",
              "createdDt": 1676010976213,
              "updatedDt": 1676030248538,
              "createdUser": "kewal@metamorphtech.com",
              "updatedUser": "kewal@metamorphtech.com",
              "baseCompanyCd": "MMS",
              "versionNum": 2,
              "type": "footer",
              "id": 201,
              "objectName": "UIConfigurationDO"
          }
      ],
      "guid": "f17879ba-fe42-48b8-bb3d-82ddad3bba82",
      "id": 220,
      "workflowStatusCd": "PUBLISH",
      "additionalEntities": null,
      "configNum": "UI0000151",
      "additionalConfigs": []
  };

    "configuration_old" = {      
    "guid": "f981369f-dad9-4c87-b763-b65439801f20",
    "createdDt": 1675061995835,
    "updatedDt": 1675061995835,
    "createdUser": "abhishek@metamorphtech.com",
    "updatedUser": "abhishek@metamorphtech.com",
    "baseCompanyCd": "MMS",
    "versionNum": 0,
    "id": 215,
    "configNum": "UI0000146",
    "configurations": [
        {
            "guid": "95161083-cfaa-4f01-ace8-9fd8931c56a4",
            "createdDt": 1675061995846,
            "updatedDt": 1675061995846,
            "createdUser": "abhishek@metamorphtech.com",
            "updatedUser": "abhishek@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": 0,
            "type": "ribbon",
            "id": 184,
            "objectName": "UIConfigurationDO"
        },
        {
            "guid": "504fd5ed-2e4d-4e6d-9fa1-f8179c177d2e",
            "createdDt": 1675061995859,
            "updatedDt": 1675061995859,
            "createdUser": "abhishek@metamorphtech.com",
            "updatedUser": "abhishek@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": 0,
            "type": "tabset",
            "id": 185,
            "tabPosition": "top",
            "size": "medium",
            "sections": [
                {
                    "guid": "e64226f2-45a2-413d-b1ab-27aa7abbcd17",
                    "createdDt": 1675061995861,
                    "updatedDt": 1675061995861,
                    "createdUser": "abhishek@metamorphtech.com",
                    "updatedUser": "abhishek@metamorphtech.com",
                    "baseCompanyCd": "MMS",
                    "versionNum": 0,
                    "controlId": "basicDetails",
                    "type": "tab",
                    "name": "Basic Details",
                    "icon": "file",
                    "disabled": false,
                    "sortOrder": 1,
                    "id": 107,
                    "sections": [
                        {
                            "guid": "e93de4f9-77fd-47b4-866a-6b2a01bdc9f2",
                            "createdDt": 1675061995870,
                            "updatedDt": 1675061995870,
                            "createdUser": "abhishek@metamorphtech.com",
                            "updatedUser": "abhishek@metamorphtech.com",
                            "baseCompanyCd": "MMS",
                            "versionNum": 0,
                            "controlId": "form-BasicDetails_new",
                            "type": "form",
                            "icon": "file",
                            "disabled": false,
                            "sortOrder": 1,
                            "heading": "Basic Details",
                            "gridClass": "grid-4x",
                            "id": 141,
                            "formItems": [
                                {
                                    "guid": "b67ab44e-fbdb-4bee-b22d-5c4d6adc3d9b",
                                    "createdDt": 1675061995885,
                                    "updatedDt": 1675061995885,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "hidden": false,
                                    "disabled": false,
                                    "fieldName": "Provider Type",
                                    "fieldKey": "providerTypeCd",
                                    "fieldType": "INPUT",
                                    "lookupCd": "providerTypeForPMCd",
                                    "defaultValue": "HOSPITAL",
                                    "fieldMapping": "proposalDO-providerTypeCd",
                                    "fieldGenericMapping": "baseDO-providerTypeCd",
                                    "extractElementFromArray": false,
                                    "id": 353,
                                    "validationList": [
                                        {
                                            "guid": "69454993-4794-4d4a-96f6-3965c21fe449",
                                            "createdDt": 1675061995914,
                                            "updatedDt": 1675061995914,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "validation": "required",
                                            "severity": "error",
                                            "errorMessage": "This ID field is required",
                                            "id": 35,
                                            "objectName": "UIValidationsDO"
                                        }
                                    ],
                                    "conditionalList": [
                                        {
                                            "guid": "854812de-1cdb-47fc-9d12-f335eef7f671",
                                            "createdDt": 1675061995896,
                                            "updatedDt": 1675061995896,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "id": 26,
                                            "objectName": "UIConditionDO"
                                        }
                                    ],
                                    "errors": [
                                        {
                                            "guid": "029b001b-e795-4fe7-90ac-32c8f067b469",
                                            "createdDt": 1675061995905,
                                            "updatedDt": 1675061995905,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "id": 796,
                                            "error": "Entity [null] not found.",
                                            "objectName": "UIConfigErrorDO"
                                        }
                                    ],
                                    "objectName": "UIFormItemsDO"
                                },
                                {
                                    "guid": "5fd78173-5c06-40bc-9392-522f6b47193e",
                                    "createdDt": 1675061995927,
                                    "updatedDt": 1675061995927,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "hidden": false,
                                    "disabled": false,
                                    "fieldName": "Provider Id",
                                    "fieldKey": "providerID",
                                    "fieldType": "COMBO",
                                    "lookupCd": "providerTypeForPMCd",
                                    "defaultValue": "HOSPITAL",
                                    "fieldMapping": "proposalDO-providerID",
                                    "fieldGenericMapping": "baseDO-providerID",
                                    "extractElementFromArray": false,
                                    "id": 354,
                                    "errors": [
                                        {
                                            "guid": "7d07acbe-0f87-470c-804f-50a7c71028bd",
                                            "createdDt": 1675061995929,
                                            "updatedDt": 1675061995929,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "id": 797,
                                            "error": "Entity [null] not found.",
                                            "objectName": "UIConfigErrorDO"
                                        }
                                    ],
                                    "objectName": "UIFormItemsDO"
                                }
                            ],
                            "objectName": "UITabSectionsDO"
                        },
                        {
                            "guid": "6d4db99f-addc-4cdb-89d4-f4c206ddccfe",
                            "createdDt": 1675061995930,
                            "updatedDt": 1675061995930,
                            "createdUser": "abhishek@metamorphtech.com",
                            "updatedUser": "abhishek@metamorphtech.com",
                            "baseCompanyCd": "MMS",
                            "versionNum": 0,
                            "controlId": "editable-grid-facilities",
                            "type": "editable-grid",
                            "icon": "table",
                            "disabled": false,
                            "sortOrder": 0,
                            "heading": "Facilities",
                            "gridClass": "grid-4x",
                            "fieldKey": "serviceDetails",
                            "fieldMapping": "proposalDO-hospital-hospitalInfrastructure-serviceDetails",
                            "id": 142,
                            "entityFetchBy": "guid",
                            "entityFetchURL": "/fetch/hospital/serviceDetails/",
                            "enableAddRemoveRows": "true",
                            "columns": [
                                {
                                    "guid": "82ef241d-4484-4ed9-b0bb-c640cf2c0914",
                                    "createdDt": 1675061995931,
                                    "updatedDt": 1675061995931,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "editable-grid-facilities",
                                    "icon": "file",
                                    "disabled": false,
                                    "sortOrder": 0,
                                    "fieldName": "Id",
                                    "fieldKey": "id",
                                    "fieldType": "INPUT",
                                    "id": 206,
                                    "columnVisibility": false,
                                    "hidden" : true,
                                    "objectName": "UIGridColumnsDO"
                                },
                                {
                                    "guid": "7cd9ef0a-7572-4606-9ba3-1d0b88d07161",
                                    "createdDt": 1675061995941,
                                    "updatedDt": 1675061995941,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "editable-grid-facilities",
                                    "icon": "file",
                                    "disabled": false,
                                    "sortOrder": 1,
                                    "fieldName": "GUID",
                                    "fieldKey": "guid",
                                    "fieldType": "INPUT",
                                    "id": 207,
                                    "columnVisibility": false,
                                    "hidden" : true,
                                    "objectName": "UIGridColumnsDO"
                                },
                                {
                                    "guid": "baad596c-8339-4e46-9c5f-76c129190bee",
                                    "createdDt": 1675061995942,
                                    "updatedDt": 1675061995942,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "editable-grid-facilities",
                                    "icon": "file",
                                    "disabled": false,
                                    "sortOrder": 2,
                                    "fieldName": "Category",
                                    "fieldKey": "serviceCategoryCd",
                                    "fieldType": "COMBO",
                                    "lookupCd": "infraServiceCategoryCd",
                                    "id": 208,
                                    "columnVisibility": true,
                                    "objectName": "UIGridColumnsDO"
                                },
                                {
                                    "guid": "5a82e70e-45b5-4825-837e-629556e814ab",
                                    "createdDt": 1675061995943,
                                    "updatedDt": 1675061995943,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "editable-grid-facilities",
                                    "icon": "file",
                                    "disabled": false,
                                    "sortOrder": 3,
                                    "fieldName": "Type",
                                    "fieldKey": "serviceTypeCd",
                                    "fieldType": "COMBO",
                                    "lookupCd": "infraServiceTypeCd",
                                    "id": 209,
                                    "columnVisibility": true,
                                    "objectName": "UIGridColumnsDO"
                                },
                                {
                                    "guid": "14d47a52-b028-43b1-b486-a6085088bdbb",
                                    "createdDt": 1675061995944,
                                    "updatedDt": 1675061995944,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "editable-grid-facilities",
                                    "icon": "file",
                                    "disabled": false,
                                    "sortOrder": 4,
                                    "fieldName": "Person In-charge",
                                    "fieldKey": "hod",
                                    "fieldType": "INPUT",
                                    "id": 210,
                                    "columnVisibility": true,
                                    "objectName": "UIGridColumnsDO"
                                }
                            ],
                            "sections": [
                                {
                                    "guid": "88fcb429-3f99-4d38-824f-00acbe238a6b",
                                    "createdDt": 1675061995946,
                                    "updatedDt": 1675061995946,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "editable-grid-facilities-nested",
                                    "type": "editable-grid",
                                    "icon": "table",
                                    "disabled": false,
                                    "sortOrder": 0,
                                    "heading": "Sub-Facilities: Nested Table",
                                    "gridClass": "grid-4x",
                                    "fieldKey": "serviceDetails",
                                    "fieldMapping": "proposalDO-hospital-hospitalInfrastructure-serviceDetails",
                                    "id": 143,
                                    "entityFetchBy": "guid",
                                    "entityFetchURL": "/fetch/hospital/serviceDetails/",
                                    "enableAddRemoveRows": "true",
                                    "columns": [
                                        {
                                            "guid": "b0781b4d-b964-4e0e-b46f-48968258a77a",
                                            "createdDt": 1675061995947,
                                            "updatedDt": 1675061995947,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "controlId": "editable-grid-facilities",
                                            "icon": "file",
                                            "disabled": false,
                                            "sortOrder": 0,
                                            "fieldName": "Sub-Facilities ID",
                                            "fieldKey": "id",
                                            "fieldType": "INPUT",
                                            "id": 211,
                                            "columnVisibility": false,
                                            "objectName": "UIGridColumnsDO"
                                        },
                                        {
                                            "guid": "9feffef2-a9cc-4f40-9b7c-397315090cbd",
                                            "createdDt": 1675061995948,
                                            "updatedDt": 1675061995948,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "controlId": "editable-grid-facilities",
                                            "icon": "file",
                                            "disabled": false,
                                            "sortOrder": 1,
                                            "fieldName": "GUID",
                                            "fieldKey": "guid",
                                            "fieldType": "INPUT",
                                            "id": 212,
                                            "columnVisibility": false,
                                            "objectName": "UIGridColumnsDO"
                                        },
                                        {
                                            "guid": "123b4b94-cb84-4787-8703-4611755b1687",
                                            "createdDt": 1675061995949,
                                            "updatedDt": 1675061995949,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "controlId": "editable-grid-facilities",
                                            "icon": "file",
                                            "disabled": false,
                                            "sortOrder": 4,
                                            "fieldName": "Person In-charge",
                                            "fieldKey": "hod",
                                            "fieldType": "INPUT",
                                            "id": 213,
                                            "columnVisibility": true,
                                            "objectName": "UIGridColumnsDO"
                                        },
                                        {
                                            "guid": "5e59652a-e870-4a54-8b16-76f5f9feeaf4",
                                            "createdDt": 1675061995950,
                                            "updatedDt": 1675061995950,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "controlId": "editable-grid-facilities",
                                            "icon": "file",
                                            "disabled": false,
                                            "sortOrder": 3,
                                            "fieldName": "Type",
                                            "fieldKey": "serviceTypeCd",
                                            "fieldType": "COMBO",
                                            "lookupCd": "infraServiceTypeCd",
                                            "id": 214,
                                            "columnVisibility": true,
                                            "objectName": "UIGridColumnsDO"
                                        },
                                        {
                                            "guid": "e022d568-ac88-440c-ad9d-366e41189c72",
                                            "createdDt": 1675061995951,
                                            "updatedDt": 1675061995951,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "controlId": "editable-grid-facilities",
                                            "icon": "file",
                                            "disabled": false,
                                            "sortOrder": 2,
                                            "fieldName": "Category",
                                            "fieldKey": "serviceCategoryCd",
                                            "fieldType": "COMBO",
                                            "lookupCd": "infraServiceCategoryCd",
                                            "id": 215,
                                            "columnVisibility": true,
                                            "objectName": "UIGridColumnsDO"
                                        }
                                    ],
                                    "objectName": "UITabSectionsDO"
                                }
                            ],
                            "errors": [
                                {
                                    "guid": "1ac65a96-7243-40d6-9f42-a525468222a2",
                                    "createdDt": 1675061995945,
                                    "updatedDt": 1675061995945,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "id": 798,
                                    "error": "Error occurred while loading vocabulary for code = [null]. Error is = [Vocabulary = null not found for company cd = MMS].",
                                    "objectName": "UIConfigErrorDO"
                                }
                            ],
                            "objectName": "UITabSectionsDO"
                        }
                    ],
                    "objectName": "UITabElementDO"
                },
                {
                    "guid": "df10056d-0d24-426b-987a-757c1c28a9b0",
                    "createdDt": 1675061995952,
                    "updatedDt": 1675061995952,
                    "createdUser": "abhishek@metamorphtech.com",
                    "updatedUser": "abhishek@metamorphtech.com",
                    "baseCompanyCd": "MMS",
                    "versionNum": 0,
                    "controlId": "tab-9166",
                    "type": "tab",
                    "name": "Coverage Details",
                    "icon": "file",
                    "hidden": false,
                    "disabled": false,
                    "sortOrder": 1,
                    "id": 108,
                    "sections": [
                        {
                            "guid": "d61c6c0b-42a9-4c23-a3d6-66a7bf69b41c",
                            "createdDt": 1675061995954,
                            "updatedDt": 1675061995954,
                            "createdUser": "abhishek@metamorphtech.com",
                            "updatedUser": "abhishek@metamorphtech.com",
                            "baseCompanyCd": "MMS",
                            "versionNum": 0,
                            "controlId": "form-2604",
                            "type": "form",
                            "icon": "profile",
                            "heading": "New Section",
                            "gridClass": "grid-4x",
                            "id": 144,
                            "formItems": [
                                {
                                    "guid": "4b42c373-f51a-48c3-aba8-f0ecb40456c6",
                                    "createdDt": 1675061995955,
                                    "updatedDt": 1675061995955,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "field-SumInsured-427",
                                    "hidden": false,
                                    "disabled": false,
                                    "fieldName": "Sum Insured",
                                    "fieldType": "NUMBERINPUT",
                                    "fieldKey":"sumInsured",
                                    "vocabularyCd": "SumInsured",
                                    "extractElementFromArray": false,
                                    "entityCd": "ClaimDO",
                                    "id": 355,
                                    "fieldMapping": "proposalDO-sumInsured",
                                    "fieldGenericMapping": "baseDO-sumInsured",
                                    "errors": [
                                        {
                                            "guid": "cd42bb90-9de8-4f10-ba94-bba55bf357c9",
                                            "createdDt": 1675061995956,
                                            "updatedDt": 1675061995956,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "id": 799,
                                            "vocabularyCd": "SumInsured",
                                            "error": "Entity [ClaimDO] not found.",
                                            "objectName": "UIConfigErrorDO"
                                        }
                                    ],
                                    "objectName": "UIFormItemsDO"
                                },
                                {
                                    "guid": "1351739a-134e-4c30-8c71-bc06dc5b7c28",
                                    "createdDt": 1675061995956,
                                    "updatedDt": 1675061995956,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "field-EventTypeCd-9726",
                                    "hidden": false,
                                    "disabled": false,
                                    "fieldName": "Event Type Code",
                                    "fieldType": "INPUT",
                                    "filedKey": "sumEventTypeCd",
                                    "vocabularyCd": "EventTypeCd",
                                    "extractElementFromArray": false,
                                    "entityCd": "ClaimDO",
                                    "id": 356,                                    
                                    "fieldMapping": "proposalDO-sumEventTypeCd",
                                    "fieldGenericMapping": "baseDO-sumEventTypeCd",
                                    "errors": [
                                        {
                                            "guid": "932943b3-06c0-42c0-8440-e40b2091f246",
                                            "createdDt": 1675061995962,
                                            "updatedDt": 1675061995962,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "id": 800,
                                            "vocabularyCd": "EventTypeCd",
                                            "error": "Entity [ClaimDO] not found.",
                                            "objectName": "UIConfigErrorDO"
                                        }
                                    ],
                                    "objectName": "UIFormItemsDO"
                                },
                                {
                                    "guid": "b21f57f2-575c-47bc-aad0-238e5b8fa7b7",
                                    "createdDt": 1675061995964,
                                    "updatedDt": 1675061995964,
                                    "createdUser": "abhishek@metamorphtech.com",
                                    "updatedUser": "abhishek@metamorphtech.com",
                                    "baseCompanyCd": "MMS",
                                    "versionNum": 0,
                                    "controlId": "field-PaymentMethodCd-6464",
                                    "hidden": false,
                                    "disabled": false,
                                    "fieldName": "Payment Method Code",
                                    "fieldType": "INPUT",
                                    "fieldKey": "",
                                    "vocabularyCd": "sumPaymentMethodCd",
                                    "extractElementFromArray": false,
                                    "entityCd": "ClaimDO",
                                    "id": 357,
                                    "fieldMapping": "proposalDO-sumPaymentMethodCd",
                                    "fieldGenericMapping": "baseDO-sumPaymentMethodCd",
                                    "errors": [
                                        {
                                            "guid": "f9a9df0a-cfcd-44b5-9ee9-09f11e6f61a8",
                                            "createdDt": 1675061995965,
                                            "updatedDt": 1675061995965,
                                            "createdUser": "abhishek@metamorphtech.com",
                                            "updatedUser": "abhishek@metamorphtech.com",
                                            "baseCompanyCd": "MMS",
                                            "versionNum": 0,
                                            "id": 801,
                                            "vocabularyCd": "PaymentMethodCd",
                                            "error": "Entity [ClaimDO] not found.",
                                            "objectName": "UIConfigErrorDO"
                                        }
                                    ],
                                    "objectName": "UIFormItemsDO"
                                }
                            ],
                            "objectName": "UITabSectionsDO"
                        }
                    ],
                    "objectName": "UITabElementDO"
                }
            ],
            "objectName": "UIConfigurationDO"
        },
        {
            "guid": "fed1346c-251d-41f0-a386-fe5326583cb6",
            "createdDt": 1675061995966,
            "updatedDt": 1675061995966,
            "createdUser": "abhishek@metamorphtech.com",
            "updatedUser": "abhishek@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": 0,
            "type": "footer",
            "id": 186,
            "objectName": "UIConfigurationDO"
        }
    ],
    "errors": [
        {
            "guid": "3ccf3b70-1cd1-43a5-960d-6adb98fdb6af",
            "createdDt": 1675061995967,
            "updatedDt": 1675061995967,
            "createdUser": "abhishek@metamorphtech.com",
            "updatedUser": "abhishek@metamorphtech.com",
            "baseCompanyCd": "MMS",
            "versionNum": 0,
            "id": 802,
            "error": "Exception Thrown. Error is [Parent Entity [null] Not found].",
            "objectName": "UIConfigErrorDO"
        }
    ],
    "objectName": "UIFieldConfigurationDO"

    };

    DESTRUCTURE_DynamicUIBilder(responses){

      if(this.commonUtilty.isArrayIterable(responses)){

        let dynamicUIBuilderIndex= responses.findIndex(item=> item.componentName == 'DynamicUIBuilder')

        if(dynamicUIBuilderIndex !=-1){

          let listOfComponents= [...responses[dynamicUIBuilderIndex].storeData];
           responses.splice(dynamicUIBuilderIndex,1)
          responses=[...responses,...listOfComponents]
        }
      }
      return responses
    }

    checkValidationsStatus(output){
      this._dynamicBuilderErrorList=[]
      if(this.commonUtilty.isArrayIterable(output.storeData)){
          output.storeData.forEach(storeResponse => {
          if(storeResponse.componentData && this.commonUtilty.isArrayIterable(storeResponse.componentData.errorDOs)){
            this._dynamicBuilderErrorList.push(...storeResponse.componentData.errorDOs)
          }
        });
      }

      return output

    }

  // Document Manager Expanded View Code
  docManagerExpanded = false
  docPanelExpandedView() {
    this.docManagerExpanded = !this.docManagerExpanded;
  }

  claimsBasicDetailsForm : any;
  // use this function in html component selector either custom component selector or dynamic form
  // this method takes the fieldKey and map the coordinates against that field keyof, so that on lens move that field will be highlighted on the image
  // Create a output property in dynamic component or any custom component and emit the field key from there
  scrollHandler(event){
    console.log("scroll event ,", event);
  }
  autoScroll(scrollTop) {
    // Your condition to determine whether to scroll or not
    const shouldScroll = true; // Replace with your condition

    if (shouldScroll) {
      // Scroll to the bottom (you can adjust this based on your requirements)
      this.zoomContainerRef.nativeElement.scrollTop = scrollTop;
    }
  }
  enableTableView(isZoomEnabled){
    this.dataView = isZoomEnabled ? 'table-layout' : 'tab-layout' ;
  }
  
  getDataOnChange(event) {
    let mouseMove;
    console.log("field changed", event, this.claimsBasicDetailsForm);
    mouseMove = {
      pageX: 0,
      pageY: 0
    }
    const has = Object.prototype.hasOwnProperty;
    if (has.call(this.coordinatesMap, event) && this.lens && this.lens.offsetWidth) {
      console.log('selected event =', this.coordinatesMap[event])
      mouseMove = this.coordinatesMap[event];
      this.autoScroll(mouseMove.scrollTop ? mouseMove.scrollTop : 0) // page 1 : 0, page 2: 580, page 3 : 1146, page 4 : 
    var pos, x, y;
    pos = this.getCursorPos(mouseMove, this.img);
    x = pos.x - (this.lens.offsetWidth / 2);
    y = pos.y - (this.lens.offsetHeight / 2);
    this.cx = this.lens.offsetWidth != 0 ? this.result.offsetWidth / this.lens.offsetWidth : 0;
    this.cy = this.lens.offsetHeight != 0 ? this.result.offsetHeight / this.lens.offsetHeight : 0;
    /* Prevent the lens from being positioned outside the image: */
    if (x > this.img.width - this.lens.offsetWidth) { x = this.img.width - this.lens.offsetWidth; }
    if (x < 0) { x = 0; }
    if (y > this.img.height - this.lens.offsetHeight) { y = this.img.height - this.lens.offsetHeight; }
    if (y < 0) { y = 0; }
    /* Set the position of the lens: */
    this.lens.style.left = x + "px";
    this.lens.style.top = y + "px";
    /* Display what the lens "sees": */
    this.result.style.backgroundPosition = "-" + (x * this.cx) + "px -" + (y * this.cy) + "px";
    this.result.style.backgroundImage = "url('" + this.img.src + "')";
    this.result.style.backgroundSize = (this.img.width * this.cx) + "px " + (this.img.height * this.cy) + "px";
    // this.moveLens(mouseMove);
    }
  }

  img; lens; result; cx = 0; cy = 0;
  enableZoom = false;
  floatingImgViewerEnableZoom = false;
  imageZoom(imgID, resultID) {
    this.img = document.getElementById(imgID);
    this.result = document.getElementById(resultID);
    /* Create lens: */
    this.lens = document.getElementById('lens-div')
    // this.lens = document.createElement("DIV");
    // this.lens.setAttribute("class", "img-zoom-lens");
    // /* Insert lens: */
    // this.img.parentElement.insertBefore(this.lens, this.img);
    /* Calculate the ratio between result DIV and lens: */
    // this.cx = this.lens.offsetWidth !=0 ? this.result.offsetWidth / this.lens.offsetWidth : 0;
    // this.cy = this.lens.offsetHeight !=0 ? this.result.offsetHeight / this.lens.offsetHeight : 0;
    /* Set background properties for the result DIV */
    // this.result.style.backgroundImage = "url('" + this.img.src + "')";
    if(this.result) {
      this.result.style.backgroundSize = (this.img.width * this.cx) + "px " + (this.img.height * this.cy) + "px";
    }
    /* Execute a function when someone moves the cursor over the image, or the lens: */
    // lens.addEventListener("mousemove", this.moveLens.bind(this));
    // this.img.addEventListener("mousemove", this.moveLens.bind(this));
    // /* And also for touch screens: */
    // lens.addEventListener("touchmove", this.moveLens.bind(this));
    // img.addEventListener("touchmove", this.moveLens.bind(this));
    // this.moveLens(event, this.lens, this.result, cx, cy, img);
    // this.getCursorPos(event, this.img)
  }
  // 'PRIMARYINSURED': { pageX: 1160, pageY: 669 }
 
  // Note: Currently the move lens is giving error, its not able to get the image and result id, this is working on other applications like Life/Health Claims, need to resolve this on NBU
  moveLens(e) {
    console.log("moveLens event", e);
    var pos, x, y;
    /* Prevent any other actions that may occur when moving over the image */
    e.preventDefault();
    /* Get the cursor's x and y positions: */
    pos = this.getCursorPos(e, this.img);
    /* Calculate the position of the lens: */
    x = pos.x - (this.lens.offsetWidth / 2);
    y = pos.y - (this.lens.offsetHeight / 2);

    this.cx = this.lens.offsetWidth != 0 ? this.result.offsetWidth / this.lens.offsetWidth : 0;
    this.cy = this.lens.offsetHeight != 0 ? this.result.offsetHeight / this.lens.offsetHeight : 0;

    /* Prevent the lens from being positioned outside the image: */
    if (x > this.img.width - this.lens.offsetWidth) { x = this.img.width - this.lens.offsetWidth; }
    if (x < 0) { x = 0; }
    if (y > this.img.height - this.lens.offsetHeight) { y = this.img.height - this.lens.offsetHeight; }
    if (y < 0) { y = 0; }
    /* Set the position of the lens: */
    this.lens.style.left = x + "px";
    this.lens.style.top = y + "px";
    /* Display what the lens "sees": */
    this.result.style.backgroundPosition = "-" + (x * this.cx) + "px -" + (y * this.cy) + "px";
    this.result.style.backgroundImage = "url('" + this.img.src + "')";
    this.result.style.backgroundSize = (this.img.width * this.cx) + "px " + (this.img.height * this.cy) + "px";
  }

  getCursorPos(e, img) {
    var a, x = 0, y = 0;
    e = e || window.event;
    /* Get the x and y positions of the image: */
    a = img ? img.getBoundingClientRect() : null;
    /* Calculate the cursor's x and y coordinates, relative to the image: */
    x = a ? e.pageX - a.left : null;
    y = a ? e.pageY - a.top : null;
    /* Consider any page scrolling: */
    x = x ? x - window.pageXOffset : null;
    y = y ? y - window.pageYOffset : null;
    return { x: x, y: y };
  }

  // togglePreviewBtn = true;
  // togglePreview(){
  //   this.togglePreviewBtn = !this.togglePreviewBtn;
  // }

  viewType:boolean = true
  transactionViewType: string = null
  viewLoader : boolean = false
  setDataView(view, p?) {
  this.viewLoader = true;
  setTimeout(() => {
    this.viewLoader = false
  }, 3000);
    if(view){
      this.dataView ='grid-layout'
    }else{
      this.dataView = 'list-layout'
    }
    p.nzActive = !p.nzActive;
  }

  terms(p,type : String) {
    p.nzActive = !p.nzActive;
  }


  setCoverageList(payload){
    let DO = this.commonUtilty.getDOName(payload)
    if(this.commonUtilty.isArrayIterable(this.coverages) && payload && payload[DO]
       && this.commonUtilty.isArrayIterable(payload[DO].caseCoverages)){
        //  payload[DO].caseCoverages = this.commonUtilty.deepCopy(this.coverages)
         payload[DO].caseCoverages.forEach((caseCoverage,index)=>{
          this.coverages.forEach(coverage=>{
            if(coverage.guid == caseCoverage.guid){
              payload[DO].caseCoverages[index] = this.commonUtilty.deepCopy(coverage);
              if(caseCoverage && caseCoverage.planTypeCd && caseCoverage.planTypeCd == 'BASEPLAN'){
                payload[DO]['sumInsuredAmt'] = coverage['sumInsuredAmt']
                payload[DO]['baseAnnualPremium'] = coverage['baseAnnualPremium']
              }
            }
            
          })
         })

    }
    else if(this.commonUtilty.isArrayIterable(this.coverages) && payload && payload[DO]
    && this.commonUtilty.isArrayIterable(payload[DO].proposalCoverages)){
      payload[DO].proposalCoverages = this.commonUtilty.deepCopy(this.coverages)
    }
      
    return payload;
   }

   setLabTestData(payload,labTestData){
    if(payload && !payload.labTests && this.commonUtilty.isArrayIterable(labTestData)){
      payload.labTests = labTestData
    }
    else{
      payload.labTests = null;
    }
    
    return payload

   }

   showCounterSaveSubmit= false;
   setResponseCd(resp){
    if(resp){
      this.responseCd = resp;
      this.showCounterSaveSubmit = true;
    }
   }

   setActionsResponse(payload){
    let DO = this.commonUtilty.getDOName(payload)
    if(payload && payload[DO] && this.responseCd){
      payload[DO].coResponseCd = this.responseCd
    }
    return payload;
   }


   riskSummarizationContent = null;
   riskSummarizationLoader = false;
   riskSummarizationApiError = false;
   fraudDeatils = [];
   fraudScore = 0;
   propensity=0;
   modelPrediction = null;
   recommendation = null;
   enableAnalyticsPanel = false
   fetchFraudDeatils(){
    let url = 'fetchBatchLog'
    let pathVariables = [];
    if(this.payloadInEdit && this.payloadInEdit.proposalDO){
      pathVariables.push(this.payloadInEdit.proposalDO.proposalNum);
      // url = `batchlog/fetchBatchLog/${this.payloadInEdit.proposalDO.proposalNum}`
    }
    if(this.payloadInEdit && this.payloadInEdit.caseDO){
      pathVariables.push(this.payloadInEdit.caseDO.proposalNum);
      // url = `batchlog/fetchBatchLog/${this.payloadInEdit.caseDO.proposalNum}`
    }
    this.apiRequestService.getCallWithAPIMapper(url, null, null, pathVariables).subscribe(resp =>{
      if(resp)
        this.fraudDeatils = resp
      else console.log("Server Error : Please check with system administrator")

      if(this.fraudDeatils && this.commonUtilty.isArrayIterable){
        this.fraudDeatils.forEach(detail => {
          if(detail.batchName && detail.batchName == 'PROBABILITY'){
            let propensityRespData = this.commonUtilty.deepCopy([JSON.parse(detail.responseData)]);
            this.propensity = propensityRespData[0] ? propensityRespData[0].claim_prediction_years ? propensityRespData[0].claim_prediction_years : null : null;
            this.dataTransformService.propensityRisk = this.propensity;
          }
          if(detail.batchName && detail.batchName == 'FWA_RISK'){
            let fraudScoreRespData = this.commonUtilty.deepCopy([JSON.parse(detail.responseData)]);
           this.fraudScore = fraudScoreRespData[0] ? fraudScoreRespData[0].predictionProbabilityPercent ? fraudScoreRespData[0].predictionProbabilityPercent : null : null;
            this.modelPrediction = fraudScoreRespData[0] ? fraudScoreRespData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            this.dataTransformService.fraudRisk = this.modelPrediction;
            this.dataTransformService.fraudScore = this.fraudScore;
            this.recommendation = fraudScoreRespData[0] ? fraudScoreRespData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
            this.dataTransformService.riskRecommendation = this.recommendation;
          }
          if(detail.batchName && detail.batchName == 'UW_RISK'){
            let UWRiskData = this.commonUtilty.deepCopy([JSON.parse(detail.responseData)]);
            this.dataTransformService.riskSummary = UWRiskData[0]['content'] ? UWRiskData[0]['content'] : null;
            // this.modelPrediction = UWRiskData[0] ? UWRiskData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            // this.recommendation = UWRiskData[0] ? UWRiskData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
          }
        })
      }
    })
  }

 
  getRiskSummarizationDetails(IO, listOfQuestion) {
    this.riskSummarizationLoader = true;
    // API: https://product-dev-services.metamorphosys.co.in/fwa-health/nbu_risk_summary
    // Request: 
    // {
    //    "product_type":"LIFE_Claims_Dev",
    //    "business_process":"FWARISKANALYSIS",
    //    "module_name":"VisionIntelligence",
    //    "model_id":"mistral",
    //    "input_data":"Case Summary:  Applicant Name: Smith Jones  Age: 56   Occupation: Govt job  Residential Location: Chennai     Hobbies: Reading    Medical History:  Hypertension: No  Family Medical History: No Smoking Status: Non-smoker  Alcohol Consumption: No      Tobacco Consumption: Yes  Recent Health Check-Up Results: normal BMI, healthy cholesterol levels, no signs of diabetes. Financial Information:  Annual Income: Rs 2000000  Existing Debts: No loan   Insurance History: Yes, previous health insurance claims. "
    // }  
    // Sample JSON data (Assuming the JSON data is stored in a variable named jsonData)
    const jsonData = `Your JSON data here`;
    const headers = { 'Content-Type': 'application/json' };
    // Parsing JSON
    const data = IO;

    // Helper function to calculate age from date of birth


    // Extracting required information
    const clientDO = data.clientDOs?.[0] || {};
    const personDO = clientDO.personDO || {};

    const applicantName = `${personDO.firstName || ''} ${personDO.middleName || ''} ${personDO.lastName || ''}`.trim();
    const dob = new Date(personDO.dateOfBirth);
    const age = this.calculateAge(dob);
    const occupation = clientDO.occupationCd || "N/A";
    const residentialLocation = clientDO.city || "N/A";
    const hobbies = "Reading"; // Placeholder as hobbies are not in JSON

    // Extracting medical history information
    const questionnaires = data.questionnaires?.[0]?.questionnaireDtls || [];
    const medicalHistory = this.getMedicalHistory(questionnaires,listOfQuestion)

    // Adding additional hardcoded medical history
    medicalHistory["Hypertension"] = "No";
    medicalHistory["Family Medical History"] = "No";
    medicalHistory["Recent Health Check-Up Results"] = "normal BMI, Calculated healthy cholesterol levels, no signs of diabetes";

    // Extracting financial information
    const annualIncome = clientDO.income || "N/A";
    const existingDebts = "No loan"; // Placeholder as debts information is not in JSON
    const insuranceHistory = "No"; // Placeholder

    // Preparing the case summary
    const caseSummary = {
      "Applicant Name": applicantName,
      "Age": age,
      "Occupation": occupation,
      "Residential Location": residentialLocation,
      "Hobbies": hobbies,
      "Medical History": medicalHistory,
      "Financial Information": {
        "Annual Income": annualIncome,
        "Existing Debts": existingDebts,
        "Insurance History": insuranceHistory
      }
    };

    console.log("Rish Summarization case summary = ", caseSummary);

    let payload = {
      "product_type": "LIFE_Claims_Dev",
      "business_process": "FWARISKANALYSIS",
      "module_name": "VisionIntelligence",
      "model_id": "'palm2-32k",
      "input_data": caseSummary
    }
    // let URL = `https://product-fwa.metamorphosys.co.in/fwa-health/nbu_risk_summary`
    // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
    // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports_v1`
    // let URL = `https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
    let URL = `https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_agent`
    this.http.post(URL, payload, { headers })
      .subscribe(jsonResp => {
        console.log("summarization response = ", jsonResp)
        this.riskSummarizationContent = jsonResp['content'];
        this.dataTransformService.riskSummarizationResponse = jsonResp;
        this.dataTransformService.riskSummary = this.riskSummarizationContent;
        this.riskSummarizationLoader = false;
      }, err => {
        this.riskSummarizationLoader = false;
        this.riskSummarizationApiError = true;
        // this.msg.error('Server Error - Technical issue occurred, please contact IT Support.', { nzDuration: 4000 })
      });
}
overAllRiskRecommendation = null;
getUWRiskSummaryDetails(IO,listOfQuestion){
  const jsonData = `Your JSON data here`;
  // Parsing JSON
  const data = IO;

  // Helper function to calculate age from date of birth


  // Extracting required information
  const clientDO = data.clientDOs?.[0] || {};
  const personDO = clientDO.personDO || {};

  const applicantName = `${personDO.firstName || ''} ${personDO.middleName || ''} ${personDO.lastName || ''}`.trim();
  const dob = new Date(personDO.dateOfBirth);
  const age = this.calculateAge(dob);
  const occupation = clientDO.occupationCd || "N/A";
  const residentialLocation = clientDO.city || "N/A";
  const hobbies = "Reading"; // Placeholder as hobbies are not in JSON

  // Extracting medical history information
  const questionnaires = data.questionnaires?.[0]?.questionnaireDtls || [];
  const medicalHistory = this.getMedicalHistory(questionnaires,listOfQuestion)

  // Adding additional hardcoded medical history
  medicalHistory["Hypertension"] = "No";
  medicalHistory["Family Medical History"] = "No";
  medicalHistory["Recent Health Check-Up Results"] = "normal BMI, Calculated healthy cholesterol levels, no signs of diabetes";

  // Extracting financial information
  const annualIncome = clientDO.income || "N/A";
  const existingDebts = "No loan"; // Placeholder as debts information is not in JSON
  const insuranceHistory = "No"; // Placeholder

  // Preparing the case summary
  const caseSummary = {
    "Applicant Name": applicantName,
    "Age": age,
    "Occupation": occupation,
    "Residential Location": residentialLocation,
    "Hobbies": hobbies,
    "Medical History": medicalHistory,
    "Financial Information": {
      "Annual Income": annualIncome,
      "Existing Debts": existingDebts,
      "Insurance History": insuranceHistory
    }
  };
  let payload =
  {
    "product_type": "FWARISKANALYSIS",
    "module_name": "GENAI",
    "business_process": "UW_SUMMARIZER",
    "output_lang": "en_US",
    "workflowCd": "NBUINITIATION",
    "companyCd": "MMS_IND",
    "countryCd": "IND",
    "proposal_io": IO
    // "input_data": caseSummary
   }
   const headers = { 'Content-Type': 'application/json',
  'Authorization' : this.apiRequestService.token};
  this.dataTransformService.riskSummarizationLoader = true;
  //  let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
  // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports_v1`
  // let URL = `https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
  let URL = `https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_agent`
   this.http.post(URL, payload, { headers })
      .subscribe(jsonResp => {
        console.log("summarization response = ", jsonResp)
        this.riskSummarizationContent = jsonResp['content'];
        this.interactService.sendriskSummarizationContent(this.riskSummarizationContent)
        this.dataTransformService.riskSummarizationResponse = jsonResp;
        this.dataTransformService.riskSummary = this.riskSummarizationContent;
        this.overAllRiskRecommendation = this.extractString('Overall Risk Assessment',this.dataTransformService.riskSummary)
        this.dataTransformService.riskSummarizationLoader = false;
        console.log("over all reco = ", this.overAllRiskRecommendation);
      }, err => {
        this.dataTransformService.riskSummarizationLoader = false;
        this.riskSummarizationApiError = true;
        // this.msg.error('Server Error - Technical issue occurred, please contact IT Support.', { nzDuration: 4000 })
    });
}

extractString(keyword: string, markdownData) {
  // const data = JSON.parse(markdownData);
  // const content = data['content'];

  // Regular expression to match the string following the provided keyword
  const regex = new RegExp(`${keyword}\\*\\*\\s*:\\s*(.*?\\b.*?)\\n`, 'g');
  const match = regex.exec(markdownData);

  if (match && match.length > 1) {
    const extractedString = match[1];
    console.log(`Extracted string for "${keyword}":`, extractedString);
    return extractedString;
  } else {
    console.log(`String "${keyword}" not found.`);
    return null;
  }
}

  calculateAge(dob) {
    const birthDate = new Date(dob);
    const difference = Date.now() - birthDate.getTime();
    const ageDate = new Date(difference);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}

 getMedicalHistory(questionnaires, listOfQuestion){
  let acc = {}
  if(this.commonUtilty.isArrayIterable(questionnaires) && this.commonUtilty.isArrayIterable(listOfQuestion)){
    questionnaires.forEach(item=>{
      listOfQuestion.forEach(ele=>{
        if(item.questionCd === ele.questionCd && this.commonUtilty.isArrayIterable(ele.questionMsgDO)){
          ele.questionMsgDO.forEach(ques=>{
            acc[ques.message] = item.responseCd || "N/A";
          })
        }
      })
    })
    // questionnaires.reduce((acc, q) => {
    //   acc[q.vocabularyCd] = q.responseDtl || "N/A";
    //   return acc;
    // }, {});
  }
  return acc;
 }

 questionCdListFromQuestionnaire = []
 getQuestionCdList(questionnaire) {
  let questionCdList = []
  if (this.commonUtilty.isArrayIterable(questionnaire)) {
    questionnaire.forEach(questionItem => {
      if (this.commonUtilty.isArrayIterable(questionItem.questionnaireDtls)) {
        questionItem.questionnaireDtls.forEach(questionnaireDtl => {
          if (questionnaireDtl.questionCd)
            questionCdList.push(questionnaireDtl.questionCd)
        });
      }
    });
  }
  return questionCdList
}

getListOfQuestionMasterCds(listOfQuestionCds, IO){
  const payload = {
    "params": listOfQuestionCds // send the questionCd
  }
  this.apiRequestService.postCallWithAPIMapper('fetchByQuestionCd', payload).subscribe(resp=>{
    if(this.commonUtilty.isArrayIterable(resp)){
      //  this.getRiskSummarizationDetails(IO, resp)
      // this.getUWRiskSummaryDetails(IO, resp);
    }
  })
}
_VehicleDetailsComponentUIToSeverDOMapper(payload, response) {
  let DOName = this._getDOName(this.TransactionState)
  let vehicleDo = new VehicleDO()
    vehicleDo.vehicleMakeCd = response.componentData.value.make
    vehicleDo.vehicleModelCd = response.componentData.value.model
    vehicleDo.vehicleVariant = response.componentData.value.variant
    vehicleDo.fuelTypeCd = response.componentData.value.fuelTypeCd
    vehicleDo.vehicleColour = response.componentData.value.color
    vehicleDo.manufacturingDt = response.componentData.value.manufacturingDt
    vehicleDo.seatingCapacity = response.componentData.value.seatingCapacity

    vehicleDo.fuelTypeCd = response.componentData.value.fuelTypeCd
    // vehicleDo.seatingCapacity = response.componentData.value.appliedForSeatingCapacity
    vehicleDo.bodyTypeCd = response.componentData.value.bodyType
    vehicleDo.chasisNum = response.componentData.value.chasisNum
    vehicleDo.engineNum = response.componentData.value.engineNum
    vehicleDo.plateNumber = response.componentData.value.plateNumber
    vehicleDo.guid = response.componentData.value.guid
    if (!vehicleDo.guid)
      vehicleDo.guid = new GuidGenerator().setGuid();

    payload['vehicleDOs'] = [];
    payload['vehicleDOs'].push(vehicleDo)
  if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && !environment.production) {
    console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }


_inputVehicleDetailsComponent = {}
  _VehicleDetailsServerDOToComponentMapper(payload) {
    let DOName = this._getDOName(this.TransactionState)
    var output = {}
    if (payload && payload['vehicleDOs'] && payload['vehicleDOs'].length > 0) {
      let vehicle = payload['vehicleDOs'].find(e => true)
      if (vehicle){
        output['guid'] =  vehicle.guid 
        output['make'] =  vehicle.vehicleMakeCd 
        output['model'] =  vehicle.vehicleModelCd 
        output['variant'] =  vehicle.vehicleVariant 
        output['fuelTypeCd'] =  vehicle.fuelTypeCd 
        output['color'] =  vehicle.vehicleColour 
        output['manufacturingDt'] =  vehicle.manufacturingDt 
        output['fuelTypeCd'] =  vehicle.fuelTypeCd 
        output['appliedForSeatingCapacity'] =  vehicle.seatingCapacity 
        output['bodyType'] =  vehicle.bodyTypeCd 
        output['chasisNum'] =  vehicle.chasisNum 
        output['engineNum'] =  vehicle.engineNum 
        output['plateNumber'] =  vehicle.plateNumber 
      }
    }
    return output
  }
  _PropertyDetailsComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    let propertyDO = new PropertyDO();
    
    propertyDO = response.componentData.form.value
    if (propertyDO.guid == null)
      propertyDO.guid = new GuidGenerator().setGuid();
    
      payload[DO].sumInsured = response.componentData.form.value.sumInsured

    payload['propertyDO'] = [];
    payload['propertyDO'].push(propertyDO);
    
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  _PropertyDetailsAddressComponentToSeverDOMapper(payload, response) {
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload['propertyDO'] && payload['propertyDO'].length){
      payload['propertyDO'].forEach(element => {
        if (response && response.componentData && response.componentData.length > 0)
        element['propertyAddressDO'] = response.componentData[0]
      });
    }
    
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }
  _TripDetailsComponentToServerDOMapper1(payload, response){
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO].policyTripDO && payload[DO].policyTripDO.length){
      payload[DO].policyTripDO.forEach(element => {
        if (response && response.componentData && response.componentData.length > 0)
        element['policyTripDO'] = response.componentData[0]
      });
    }
    
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }
  _TripDetailsComponentToServerDOMapper(payload, response){
    let DO = this._getDOName(this.TransactionState)
    if (payload && payload[DO]){
      
        if (response && response.componentData && response.componentData.length > 0){
          payload[DO].policyTripDO = response.componentData[0]
          payload[DO].policyTripDO = response.componentData.form.value
        }
    }
    
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  // All Client Edit Scenario
  editableClientData:any
  currentSelectedClientRole:any;
  showClientSearchModal:boolean = false;
  searchClientMdalTitle:string = "Search/Add Client"
  editSelectedClient(data, capturedRole:string) {
    if (capturedRole) {
      const roleLabels = {
        NOMINEE: 'Nominee',
        PRIMARYINSURED: 'Primary Insured',
        INSURED: 'Additional Insured',
        OWNER: 'Policy Holder',
        APPOINTEE: 'Appointee',
        ASSIGNEE: 'Assignee',
        PAYER: 'Payer'
      };
      const roleLabel = roleLabels[capturedRole] || capturedRole;
      this.searchClientMdalTitle = `Search/Add ${roleLabel}`
      this.currentSelectedClientRole = capturedRole
      this.editableClientData = data
      this.showClientSearchModal= true
    }
  }

  addedClientDataSet
  getClientData(data) {
    if(this.showClientSearchModal) this.showClientSearchModal = true
    this.addedClientDataSet = data.componentData || data;
    let output = {role: this.addedClientDataSet.role , [this.addedClientDataSet.clientDO.guid]: this.addedClientDataSet}
    if (output)
      this.interactService.sendClientDOclaimClient(output)
  }

  clientDOHM = new Map();
  claimClientRoles_HM = new Map();
  claimantHM = new Map();
  claimPaymentsHM = new Map();
  _inputClientListComponent = {
    clientDOHM: this.clientDOHM,
    claimClientRoles: this.claimClientRoles_HM,
    claimantHM: this.claimantHM,
    claimPaymentsHM: this.claimPaymentsHM
  };

  newRolePolicyClientMap = new Map<string, Map<string, any>>();

  onClientRoleUpdate() {
    this.interactService.updatedClientData$.subscribe(role=>{
      if(role){
        this.componentRefresh()
      }
    })
  } 
  
  componentRefreshFl: boolean = true
  componentRefresh(){
    this.componentRefreshFl = false;
    setTimeout(() => {
      this.componentRefreshFl = true;
    }, 20);
  }

  clientData = []
  missingRolesDisplayed:boolean = false;
  clientUIToServerTransform(payload){
    let DO = this._getDOName(this.TransactionState)
    this.clientData = [];
    this.clientData = Array.from(this.clientDOHM.values());
    if (payload && payload['clientDOs'])
      payload['clientDOs'] = []
    payload['clientDOs'].push(...this.clientData);

    let caseOrProposalPayment = DO == 'caseDO' ? 'casePayments' : 'proposalPayments';
    if(this.claimPaymentsHM)
      payload[DO][caseOrProposalPayment] = this.claimClientUtil.processProposalPayments(this.claimPaymentsHM);

    payload = this.claimClientUtil.processPayloadAndClientRoles(payload,DO,this.claimClientRoles_HM);
    payload = this.claimClientUtil.processClientRoles(payload,DO, this.claimClientRoles_HM);
    //this.resetDataStructures();

    // Check if required client roles are present for policy transactions
    if (this.transactionSaveType=='submit' && (this.TransactionState.includes('proposal') || this.TransactionState.includes('policy'))) {
      const requiredRoles = ['PRIMARYINSURED','PAYER'];
      const missingRoles = [];
      requiredRoles.forEach(role => {
        if (!this.claimClientRoles_HM.has(role) || this.claimClientRoles_HM.get(role).size === 0) {
          missingRoles.push(role);
        }
      });
      if (missingRoles.length > 0 && !this.missingRolesDisplayed) {
        this.missingRolesDisplayed = true;
        let errorDO = new ErrorDO();
        errorDO.errorMsg = `The following required client roles must be added before submission: ${missingRoles.join(', ')}`;
        errorDO.fieldName = "Client Roles";
        errorDO.fieldNameDescription = "Client Roles";
        errorDO.componentName = "ClientListComponent";
        this._UIErrorList.push(errorDO);
      } 
      if (missingRoles.length == 0 && this.missingRolesDisplayed) {
        const errorIndex : number = this._UIErrorList.findIndex(error => error.fieldName === 'Client Roles');
        if (errorIndex !== -1) {
          this._UIErrorList.splice(errorIndex, 1); // modifies array in-place
        }
      }
    }
    return payload;
  }

// fetch collaboration list
collaborationList = []
fetchCollaborations(payload){
  if(payload){
    let DOName = this.commonUtilty.getDOName(payload)
    if(DOName){
      let guid = payload[DOName]['guid']
      if(guid)
      this.apiRequestService.getCallWithAPIMapper('collaborationFetchByEntityGuid', null, null, [guid]).subscribe(resp=>{
        if(resp && this.commonUtilty.isArrayIterable(resp) && resp.length>0){
          this.collaborationList = this.commonUtilty.deepCopy(resp)
          this.toggleRefreshCollaboration()
        }
      })
    }
  }
}

refreshCollaborationTab:boolean = true
toggleRefreshCollaboration(){
  this.refreshCollaborationTab = false
  setTimeout(()=>{
    this.refreshCollaborationTab = true
  }, 10)
}

openCollaboration: boolean = false
openCollaborationModal(){
  this.openCollaboration = true
}

modShowReassign: boolean = false;
showAssignModal() {
  if (this.taskList.length == 0)
    this.message.error('No records selected, Please select at least one task');
  else
    this.modShowReassign = true;
}

  taskList: any = []
  taskSubject$
  refreshReassingTaskList1() {
    this.taskList = []
    if (this.taskSubject$)
      this.taskSubject$.unsubscribe()
    this.taskSubject$ = this.interactService.taskSubject$.subscribe(res => {
      if (res && res.data) {

        if (res.event) {
          let indexFound = this.taskList.findIndex(item => {
            if (item)
              return item === res.data;
          })
          if (indexFound === -1) {
            this.taskList.push(res.data)
          }
        }
        else {

          let output = this.taskList.filter(item => {
            if (item)
              return item !== res.data;
          }) || []
          this.taskList = output;
        }
      }
    })
  }

  taskData: any
  selectedItems = []
   refreshReassingTaskList() {
    if (this.payloadInEdit) {
      this.taskData = this.payloadInEdit['proposalDO'] || this.payloadInEdit['caseDO'];
    }
    if (this.taskData) {
      this.workqueueService.getWorkflowAudit(this.taskData['guid'], null).subscribe(resp => {
        if (resp) {
          resp.forEach(list => {
            if (list.status == 'PENDING') {
              this.taskList.push(list);
            }
          });
        }
      });
    }
  }

  assingTo: any;
  assingTask() {

    if (!!!this.assingTo)
      this.message.error('No data selected,Please select at least one user');
    else {
      let listTaskIDs = this.taskList.map(task => task)
      this.workqueueService.reassignTaskToUser(listTaskIDs, this.assingTo, this.taskList)
        .subscribe(resp => {
          if (typeof resp.ok === 'undefined') {
            this.modShowReassign = false
            //this.notification.success("Task assigned successfully", `The reference numbers reassigned are: ${resp['taskList'] && Array.isArray(resp['taskList']) ? resp['taskList'].map(task => task.claimNum ? task.claimNum : (task.intimationNum ? task.intimationNum : `TaskId: ${task.id}`)) : 'None'}`);
            this.message.success("Task assigned successfully");
            //this.interactService.pingForRefreshWorkbench();
            this.taskList = [];
            this.assingTo = null;
          }
          else {
            this.message.error("Technical issue occurred, please contact IT Support.")
          }
        })
    }
  }

}